/* Cart-drawer restructure: the legacy #re-order box and #discount-card tier guider
   were removed from the drawer (not in screens-cart.jsx). Their visibility was toggled
   by ~16 direct `document.querySelector("#re-order").style.display = ...` calls that
   would now throw on a null element. setDisplaySafe() no-ops when the element is gone,
   so removing the markup can never throw. */
function setDisplaySafe(selector, value) {
  const el = document.querySelector(selector);
  if (el) el.style.display = value;
}

class LocalCart {
  constructor(storageKey = "localCart") {
      this.storageKey = storageKey, this.cart = this._loadCart();
      //this.welcome25 = await updateWelcome25Row();
      this.sanitizeBoxTargetForOrderType(); // scrub any stale one-time+25 box target at bootstrap

      this.welcome25 = false;
      this.additionalpromo = false;
      this.hasFlag = false;
      this.clubs = [
        // Generic special-pricing flag — add the `special_pricing` tag to any customer to give them
        // the flat $9.95/meal, one-time segment (no code change). Keep in sync with the box picker's
        // special_pricing_tags + the Function's SEGMENT_PRICING.
        "special_pricing",
        "bluefit",
        "conditn",
        "bayfit_leisure_centre",
        "san_souci_leisure_centre",
        "lane_cove_swimming_pool",
        "windy_hill_fitness_centre",
        "belmont_oasis_leisure",
        "aquadome",
        "salisbury",
        "melton_waves",
        "laverton_swim_centre",
        "hurstville_aquatic_centre",
        "sans_souci_leisure_centre",
        "moss_vale_aquatic",
        "lockyer_valley_sports_aquatic_centre",
        "mount_annan",
        "oran_park",
        "the_pavilion_waca_grounds"
      ];  

      this.excludedTags_Global = ["keto_customers","NDIS","bluefit","conditn","T1","T2","T3","bayfit_leisure_centre","san_souci_leisure_centre","lane_cove_swimming_pool","windy_hill_fitness_centre","belmont_oasis_leisure","aquadome","salisbury","melton_waves","laverton_swim_centre","hurstville_aquatic_centre","sans_souci_leisure_centre","moss_vale_aquatic","lockyer_valley_sports_aquatic_centre","mount_annan","oran_park","the_pavilion_waca_grounds"];
      this.isExcluded_Global = userLoggedIn && typeof customerData !== 'undefined' && Array.isArray(customerData.tags) && customerData.tags.some(tag => this.excludedTags_Global.includes(tag));
      

      this.isBluefit = false; 

      if (userLoggedIn && Array.isArray(customerData.tags)){
        this.isBluefit = this.isBluefitUser(customerData.tags);
      }

      console.log('isBluefit', this.isBluefit);

  }

  isBluefitUser(customertags) {
    if (!Array.isArray(customertags) || customertags.length === 0) {
      return false;
    }

    return customertags.some(tag =>
      this.clubs.includes(tag.trim().toLowerCase())
    );
  }

  _loadCart() {
      try { 

          const stored = localStorage.getItem(this.storageKey),
              parsed = stored ? JSON.parse(stored) : {};
          return {
              items: Array.isArray(parsed.items) ? parsed.items : [],
              attributes: Array.isArray(parsed.attributes) ? parsed.attributes : [],
              total_qty: parsed.total_qty || 0,
              item_count: parsed.item_count || 0,
              total_price: parsed.total_price || 0,
              original_total_price: parsed.total_price || 0,
              original_keto_total_price: parsed.original_keto_total_price || 0,
              original_t1_total_price: parsed.original_t1_total_price || 0,
              original_t2_total_price: parsed.original_t2_total_price || 0,
              original_t3_total_price: parsed.original_t3_total_price || 0
          } 
      } catch {
          return {
              items: [],
              total_qty: 0,
              item_count: 0,
              total_price: 0,
              original_total_price: 0,
              original_keto_total_price: 0,
              original_t1_total_price: 0,
              original_t2_total_price: 0,
              original_t3_total_price: 0,
              attributes: []
          }
      }
  }
  _saveCart() {
    
    this.cart.total_qty = this.cart.items.reduce((sum, item) => sum + item.qty, 0);
    this.cart.item_count = this.cart.items.reduce((sum, item) => sum + item.qty, 0);

    this.cart.total_price = this.cart.items.reduce((sum, item) => {
        if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")){          
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.keto_price;
          }
          return sum + item.qty * item.price;
        }else{
          return sum + item.qty * item.price;
        }
    }, 0);   

    this.cart.original_total_price = this.cart.items.reduce((sum, item) => {
        if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.keto_price;
          }
          return sum + item.qty * item.price;
        }else if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.t1_price;
          }
          return sum + item.qty * item.price;
        }else if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.t2_price;
          }
          return sum + item.qty * item.price;
        }else if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.t3_price;
          }
          return sum + item.qty * item.price;
        }else{
          return sum + item.qty * item.price;
        }
    }, 0);

    this.cart.original_keto_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.keto_price;
    }, 0);

    this.cart.original_t1_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.t1_price;
    }, 0);

    this.cart.original_t2_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.t2_price;
    }, 0);

    this.cart.original_t3_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.t3_price;
    }, 0);

    localStorage.setItem(this.storageKey, JSON.stringify(this.cart));
    // console.log(this.cart);
  }

  overwriteFromRemoteCart() {
    return fetch("/cart.json")
      .then(res => res.json())
      .then(data => {
        const cartLevelFrequency =
        (data?.attributes?.orderType && typeof data.attributes.orderType === "string")
          ? data.attributes.orderType
          : (data?.attributes?.orderType?.type || null);

        if (!Array.isArray(data.items) || data.items.length === 0 || !data.items[0].id) {
          this.cart = {
            items: [],
            total_qty: 0,
            item_count: 0,
            total_price: 0,
            original_total_price: 0,
            original_keto_total_price: 0,
            original_t1_total_price: 0,
            original_t2_total_price: 0,
            original_t3_total_price: 0,
            attributes: []
          };
        } else {
          const items = data.items.map(src => {
            // per-item selectedFrequency (preferred), else cart-level
            const itemProps = src.properties || {};
            const itemFrequency = itemProps.selectedFrequency || cartLevelFrequency || null;

            // choose selling plan by frequency
            let sellingPlan = null;
            if (itemFrequency === "WeeklySubscription") {
              sellingPlan = SELLING_PLAN_S;
            } else if (itemFrequency === "FortnightlySubscription") {
              sellingPlan = SELLING_PLAN_FS;
            }

            // ensure properties has selectedFrequency if we’re on a subscription
            const properties = {
              ...itemProps
              //...(itemFrequency ? { selectedFrequency: itemFrequency } : {})
            };

            return {
              product_id: src.product_id,
              variant_id: src.variant_id,
              title: src.title,
              url: src.url,
              image: src.image,
              price: src.original_price,     // cents
              keto_price: 1050,              // your fixed keto cents// cents
              t1_price: KETO_PRICE_T1,  // cents
              t2_price: KETO_PRICE_T2,  
              t3_price: KETO_PRICE_T3,
              qty: src.quantity,
              product_type: src.product_type,
              selling_plan: sellingPlan,              
              //qty_limit_enabled: qty_limit_enabled, 
              //max_qty_per_order: max_qty_per_order,  
              bf_true: src.bf_true,
              properties
            };
          });

          //console.log(items);

          this.cart = {
            items,
            total_qty: data.items.reduce((sum, item) => sum + item.quantity, 0),
            item_count: data.item_count,
            total_price: data.total_price,
            original_total_price: data.original_total_price,
            t1_total_price: data.t1_total_price,
            t2_total_price: data.t2_total_price,
            t3_total_price: data.t3_total_price,
            attributes: data.attributes || []
          };
        }
  
        this._saveCart(); // Save to localStorage
        
        return this.cart;
      })
      .catch(error => {
        console.error("Error overriding cart from remote:", error);
      });
  }

  getContractIdFromCache(email) {
    try {
      const cache = JSON.parse(localStorage.getItem('email_check_cache') || "{}");
      const data = cache[email]?.data;

      if (!data || !data.subscriptions) return null;

      // ✅ priority: active → paused
      if (Array.isArray(data.subscriptions.is_active) && data.subscriptions.is_active.length > 0) {
        return data.subscriptions.is_active[0].id.split("/").pop();
      }

      /*if (Array.isArray(data.subscriptions.is_paused) && data.subscriptions.is_paused.length > 0) {
        return data.subscriptions.is_paused[0].id.split("/").pop();
      }*/

      return null;

    } catch (e) {
      console.error("Error getting contractId from cache:", e);
      return null;
    }
  }

  /**
   * Duplicate-subscription GUARD (Doc5 §2b / backlog F-sub-guard, Phase-1 minimal cut).
   *
   * Returns the active subscription contractId for the currently logged-in customer,
   * or null if none / not logged in. Authoritative: it first checks the synchronous
   * caches (contractInfo localStorage + getContractIdFromCache), and if those are empty
   * — which is exactly how a real subscriber gets mis-routed into a NEW-subscription
   * checkout and ends up with a duplicate contract — it falls back to the same
   * AWS /api/customers/find lookup the cart already uses, using the server-rendered
   * customer.email so the result is reliable even when window_state.email is blank.
   *
   * This is a CLIENT-SIDE guard only. It prevents the accidental-duplicate path that
   * exists today; it does NOT implement the full §2b subscriber-aware menu (that is the
   * deferred part of F-sub-guard and depends on F1/F5).
   */
  async findActiveContractIdForGuard() {
    if (!userLoggedIn) return null;

    // 1) Fast path: explicit contractInfo set during this session.
    try {
      const info = JSON.parse(subscriptionContractId || "{}");
      if (info && info.contractId) return String(info.contractId);
    } catch (e) { /* fall through */ }

    // 2) Resolve a trustworthy email: prefer the server-rendered customer email,
    //    fall back to whatever window_state captured.
    let sdata = {};
    try { sdata = JSON.parse(localStorage.getItem("window_state") || "{}"); } catch (e) { sdata = {}; }
    const email =
      (typeof customerData !== "undefined" && customerData && customerData.email) ||
      sdata.email ||
      "";

    // FAIL SAFE: we only reach here when the customer IS logged in (the guest
    // case returned null at the top). If we cannot resolve ANY email for a
    // logged-in customer, we cannot run the authoritative subscription lookup,
    // so we cannot prove they have no active subscription. Returning null here
    // would ALLOW a possible duplicate (the residual fail-open). Block instead.
    // A genuine guest never reaches this line — they short-circuit on
    // `if (!userLoggedIn) return null;` above — so guests are not over-blocked.
    if (!email) return "__GUARD_LOOKUP_FAILED__";

    // 3) Synchronous cache lookup.
    const cached = this.getContractIdFromCache(email);
    if (cached) return cached;

    // 4) Authoritative network lookup (same endpoint the cart already trusts).
    //
    //    FAIL-SAFE CONTRACT: for a logged-in customer we may only return null
    //    (which ALLOWS the native create-subscription path) when we have a CLEAN,
    //    2xx response that CONCLUSIVELY shows there is no active subscription.
    //    Anything else — non-2xx HTTP status (500/403/429/…), thrown/network error,
    //    unparseable body, or an unexpected/ambiguous shape — returns the block
    //    sentinel so the caller treats the customer as a possible subscriber and
    //    blocks, rather than risk a silent duplicate contract.
    try {
      const response = await fetch(
        "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        }
      );

      // fetch() does NOT throw on HTTP errors. A 500/403/429 (etc.) with a JSON
      // body would parse fine but carry no subscriptions, which previously fell
      // through to null and ALLOWED a duplicate. Treat any non-2xx as a
      // verification FAILURE.
      if (!response.ok) {
        return "__GUARD_LOOKUP_FAILED__";
      }

      // The body must be conclusively parseable JSON; if it isn't, we cannot
      // prove "no subscription", so block.
      let data;
      try {
        data = await response.json();
      } catch (parseErr) {
        return "__GUARD_LOOKUP_FAILED__";
      }

      // The response must carry the expected `subscriptions` shape. A 2xx with
      // a missing/unexpected payload is ambiguous, not a clean "no subscription".
      const subs = data && data.subscriptions;
      if (!subs || typeof subs !== "object") {
        return "__GUARD_LOOKUP_FAILED__";
      }

      const active = subs.is_active;

      // Active subscription present → return the existing contractId so the
      // caller routes onto the existing box.
      if (Array.isArray(active) && active.length > 0) {
        if (active[0] && active[0].id) {
          return String(active[0].id.split("/").pop());
        }
        // We KNOW they have an active subscription but the id is malformed —
        // still a subscriber, so block rather than allow a duplicate.
        return "__GUARD_LOOKUP_FAILED__";
      }

      // ONLY allow (return null) on a clean 2xx that CONCLUSIVELY says there is
      // no active subscription: `is_active` is an explicit, empty array. This is
      // the genuine first-time / non-subscriber path.
      if (Array.isArray(active) && active.length === 0) {
        return null;
      }

      // Anything else (is_active missing, null, or an unexpected type) is
      // ambiguous → fail toward "treat as subscriber / block".
      return "__GUARD_LOOKUP_FAILED__";
    } catch (e) {
      // Fail SAFE: on a thrown/network error for a logged-in customer we cannot
      // prove they have no subscription, so signal "unknown" and let the caller
      // block rather than risk a silent duplicate.
      return "__GUARD_LOOKUP_FAILED__";
    }
  }

  updateReorderBox() {
    const reorderBox = document.querySelector("#re-order");
    const metaText = reorderBox?.querySelector("#re-order-muted");

    if (!reorderBox || !metaText || !LAST_ORDER) return;

    const items = Array.isArray(LAST_ORDER.items) ? LAST_ORDER.items : [];
    
    const totalMeals = items.reduce((sum, item) => {
      return sum + (parseInt(item.qty || item.quantity || 0, 10));
    }, 0);

    const orderDate = LAST_ORDER.created_at
      ? new Date(LAST_ORDER.created_at).toLocaleDateString("en-AU", {
          day: "numeric",
          month: "short",
          year: "numeric"
        })
      : "";

    metaText.textContent = `${totalMeals} meals • ordered ${orderDate}`;
    //reorderBox.style.display = totalMeals > 0 ? "flex" : "none";
    
  }


  updateTierDiscountCard() {
    const windowState = JSON.parse(localStorage.getItem("window_state") || "{}");
    const orderType = windowState.freq || "WeeklySubscription";
    const isSubscription = orderType !== "OneTimePurchase";

    let shipping_amount_get = (localStorage.getItem("shipping_amount") || 0);
    let shipping_aa = parseFloat(shipping_amount_get);
    const hasAddressnew = !!(windowState?.address && String(windowState.address).trim() !== "");  

    console.log('hasAddressnew', hasAddressnew);

    const offers = isSubscription ? promotionalOffers : oneTimeOffers;
    if (!offers) return;

    // F2 cart-deferred — Doc5 §4 per-meal tier ladder (10/14/18/25, ABSOLUTE $/meal,
    // NOT the old %-off 10/14/20). Boundaries + per-meal prices are the locked Doc5 §4
    // table (10=$12.95 · 14=$12.50 · 18=$10.95 · 25=$9.95), the SAME prices the B5
    // cart-transform charges. perMealCents drives the card's display labels/nudge only.
    const TIERS = LocalCart.DOC5_MEAL_TIERS.map(t => ({ mealsRequired: t.meals, perMealCents: t.perMealCents }));

    const mealCount = this.countLunchAndDinnerMeals(this.cart.items);

    // A7: Currency formatting using class method (handles thousands separator and fixed decimals)
    const format = (cents) => this.formatMoney(cents);

    /* ---------- A2-A6: CURRENT & TARGET ---------- */
    const currentTier = [...TIERS].reverse().find(t => mealCount >= t.mealsRequired) || null;
    const targetTier = TIERS.find(t => mealCount < t.mealsRequired) || null;

    /* ---------- SAVINGS CALCULATION (A6: Mixed SKU support) ---------- */
    const lunchDinnerItems = this.cart.items.filter(item => item.product_type === "LUNCH & DINNER");
    let lunchDinnerTotalCents = lunchDinnerItems.reduce((sum, item) => sum + (item.price * item.qty), 0);

    // Handle special promo pricing if active
    if(this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined'){
        lunchDinnerTotalCents = lunchDinnerItems.reduce((sum, item) => sum + (PROMO_PROD_PRICE * item.qty), 0);
    }

    /* F2 cart-deferred — savings under the Doc5 §4 ABSOLUTE $/meal model. The entry tier
       (10 meals = $12.95) is the reference price; reaching a higher tier drops every meal to
       a lower locked per-meal price. "Savings" = (entry per-meal − current tier per-meal) ×
       meals — a real, backend-matching figure (the B5 cart-transform charges these exact
       per-meal prices), never a fabricated %-off. Below the 10-meal floor there is no tier,
       so savings = 0. */
    const entryPerMealCents = LocalCart.DOC5_MEAL_TIERS[0].perMealCents; // 1295
    let currentSavingsCents = 0;
    let currentSavingsCentsWithOutShipping = 0;
    let totalInCents = lunchDinnerTotalCents;
    if (currentTier && currentTier.perMealCents != null) {
      // ONE-TIME caps at the 18 tier ($10.95): the 25 tier ($9.95) is subscriber-only, so a one-time
      // cart at 25+ meals is CHARGED $10.95, not $9.95. Cap the current per-meal rate before deriving
      // savings so the displayed saving matches the backend charge (never overstates on one-time).
      const cappedCurrentCents = this.capRateForOrder(currentTier.perMealCents, orderType);
      const perMealSavingCents = Math.max(0, entryPerMealCents - cappedCurrentCents);
      const productSavingsCents = perMealSavingCents * mealCount;

      currentSavingsCents = productSavingsCents;
      currentSavingsCentsWithOutShipping = productSavingsCents;

      // Subscriptions get free shipping on a qualifying box — surface that as part of the
      // headline saving when an address is present (so shipping_aa is known).
      if (isSubscription && mealCount >= 1 && hasAddressnew) {
        currentSavingsCents += Math.round(shipping_aa * 100);
      }

      totalInCents += Math.round(shipping_aa * 100);
    }

    /* ---------- FOOTER: Cart Discount rows (run ALWAYS, independent of the
       removed tier card). Cart-drawer restructure: this update used to live
       inside the #discount-card .forEach, so removing the card silently killed
       the footer "Cart Discount" / strikethrough total. It is now hoisted out so
       the footer keeps updating with no tier card present. ---------- */
    const totalDiscountWithShippingEl = document.querySelector(".total-discounts-with-shipping");
    const totalDiscountAmountEl = document.querySelector(".total-discount-amount");
    const totalDiscountWithShippingAmountEl = document.querySelector(".total-discounts-with-shipping-amount");

    if (totalDiscountWithShippingAmountEl) {
      if (currentSavingsCentsWithOutShipping > 0) {
        totalDiscountWithShippingAmountEl.textContent = `${format(currentSavingsCentsWithOutShipping)}`;
        totalDiscountWithShippingEl?.classList.remove("d-none");
      } else {
        totalDiscountWithShippingAmountEl.textContent = "";
        totalDiscountWithShippingEl?.classList.add("d-none");
      }
    }

    if (totalDiscountAmountEl) {
      if (currentSavingsCents > 0) {
        totalDiscountAmountEl.textContent = `${format(totalInCents)}`;
        totalDiscountAmountEl?.classList.remove("d-none");
      } else {
        totalDiscountAmountEl.textContent = "";
        totalDiscountAmountEl?.classList.add("d-none");
      }
    }

    /* ---------- TIER CARD VISUALS (only if a .discount-card exists — e.g. the
       bottom-bar instance; the cart-drawer #discount-card was removed in the
       restructure). forEach no-ops with no card present, so nothing throws. ---------- */
    const cards = document.querySelectorAll(".discount-card");
    cards.forEach(cardEl => {

      const titleEl = cardEl.querySelector(".sub"); // Savings line
      const subEl = cardEl.querySelector(".tier-cta"); // Upsell prompt
      const ctaEl = cardEl.querySelector(".title"); // Upsell prompt primary
      const fillEl = cardEl.querySelector(".tier-fill");
      const dots = cardEl.querySelectorAll(".tier-dot");
      const labels = cardEl.querySelectorAll(".tier-labels span");

      // Dynamic Labels — Doc5 §4 absolute $/meal (e.g. "14 · $12.50"), not %-off.
      // If the card markup has only 3 label slots, show the first three tier rungs
      // (10/14/18); the 25 rung lives in the break-nudge copy + eyebrow.
      labels.forEach((label, idx) => {
        const tier = TIERS[idx];
        if (tier) {
          label.innerHTML = `${tier.mealsRequired} &middot; ${format(tier.perMealCents)}`;
          if (idx === 0) {
            label.style.left = isSubscription ? 'calc(0% + 30px)' : 'calc(0% + 10px)';
          }
        }
      });

      /* ---------- UI MESSAGING (A2, A3, A4) ---------- */

      // A2/A3: Savings line
      if (titleEl) {
        if (currentSavingsCents > 0) {
          titleEl.textContent = `You're saving ${format(currentSavingsCents)} 🎉`;
          titleEl.style.display = "block";
        } else {
          titleEl.textContent = "";
          titleEl.style.display = "none";
        }
      }

      // A4: Top tier handling & Rolling prompts (A3)
      if (!targetTier) {
        // Capped at top tier
        if (ctaEl) ctaEl.style.display = "none";
        if (subEl) subEl.textContent = "You've got the best deal!";
      } else if (ctaEl || subEl) {
        if (ctaEl) ctaEl.style.display = "block";
        const mealsNeeded = targetTier.mealsRequired - mealCount;

        // F2 cart-deferred — Doc5 §4 $/meal framing: "Add N more to drop to $Y/meal".
        // $Y = the next tier's LOCKED per-meal price (the same the backend charges), so the
        // promise is honest. Sub adds the free-shipping reminder when it kicks in (≥10 meals).
        let promptText = `Add ${mealsNeeded} more meal${mealsNeeded > 1 ? 's' : ''} to drop to ${format(targetTier.perMealCents)}/meal`;
        if (isSubscription && targetTier.mealsRequired >= 10) {
          if (shipping_aa > 0 && hasAddressnew) {
            promptText += ` + free delivery`;
          }
        }

        if (ctaEl) ctaEl.innerHTML = promptText;
        if (subEl) subEl.innerHTML = promptText;
      }

      /* ---------- PROGRESS BAR (Doc5 §4 rungs 10/14/18) ---------- */
      let progressPercent = 0;
      const t1 = TIERS[0].mealsRequired; // 10
      const t2 = TIERS[1].mealsRequired; // 14
      const t3 = TIERS[2].mealsRequired; // 18

      if (mealCount < t1) {
        progressPercent = (mealCount / t1) * 33.33;
      } else if (mealCount < t2) {
        progressPercent = 33.33 + ((mealCount - t1) / (t2 - t1)) * 33.33;
      } else if (mealCount < t3) {
        progressPercent = 66.66 + ((mealCount - t2) / (t3 - t2)) * 33.34;
      } else {
        progressPercent = 100;
      }

      if (fillEl) fillEl.style.width = `${Math.min(progressPercent, 100)}%`;

      /* ---------- DOTS ---------- */
      dots.forEach((dot, index) => {
        const tier = TIERS[index];
        if (tier) dot.classList.toggle("empty", mealCount < tier.mealsRequired);
      });
    });
  }

  reorderFromLastOrder(lastOrderItems = []) {

    if (!Array.isArray(lastOrderItems) || lastOrderItems.length === 0) {
      console.warn('No items to reorder');
      return;
    }
    
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

    let order__type = state_data.freq ? state_data.freq : "WeeklySubscription";
    let sellingPlan_n = SELLING_PLAN_S
    if (order__type == "WeeklySubscription") {
      sellingPlan_n = SELLING_PLAN_S;
    } else if (order__type == "FortnightlySubscription") {
      sellingPlan_n = SELLING_PLAN_FS;
    }

    // ✅ 1. Clear existing local cart
    this.cart = {
      items: [],
      total_qty: 0,
      item_count: 0,
      total_price: 0,
      original_total_price: 0,
      original_keto_total_price: 0,
      original_t1_total_price: 0,
      original_t2_total_price: 0,
      original_t3_total_price: 0,      
      attributes: {
        orderType: { type: order__type }
      }
    };

    // ✅ 2. Add items to local cart (NO API call)
    lastOrderItems.forEach(item => {

      this.cart.items.push({
        product_id: item.product_id,
        variant_id: item.variant_id,
        title: item.title,
        url: item.url || "#",
        image: item.image || "",
        price: item.price, // already in cents
        keto_price: item.keto_price || 1050,
        t1_price: item.t1_price || KETO_PRICE_T1,
        t2_price: item.t2_price || KETO_PRICE_T2,
        t3_price: item.t3_price || KETO_PRICE_T3,
        qty: item.qty || item.quantity || 1,
        product_type: item.product_type || "",
        selling_plan: sellingPlan_n
      });

    });

    // ✅ 3. Save to localStorage
    this._saveCart();

    console.log('✅ Reorder loaded into LocalCart');
  }

  handleReorderClick(items = window.LAST_ORDER?.items || []) {
    
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");
    let order__type = state_data.freq ? state_data.freq : "WeeklySubscription";
    let sellingPlan_n = SELLING_PLAN_S
    if (order__type == "WeeklySubscription") {
      sellingPlan_n = SELLING_PLAN_S;
    } else if (order__type == "FortnightlySubscription") {
      sellingPlan_n = SELLING_PLAN_FS;
    }

    try {
      if (!items.length) {
        const ItemsNEW = LAST_ORDER.items.map(item => ({
          product_id: item.product_id,
          variant_id: item.variant_id,
          title: item.title,
          url: item.url,
          image: item.image,
          price: item.price,            // already in cents
          keto_price: item.keto_price,
          t1_price: item.t1_price,
          t2_price: item.t2_price,
          t3_price: item.t3_price,
          qty: item.qty,
          product_type: item.product_type,
          selling_plan: sellingPlan_n
        }));

        items = ItemsNEW;
      }  

      console.log('lastOrderItems', LAST_ORDER);    

      // ✅ reorder
      const newCart = this.reorderFromLastOrder(items);

      // ✅ update UI
      this.updateCartInfoFromLocal(".cart-item-loop");

      console.log("✅ Reorder success", newCart);

    } catch (err) {
      console.error("❌ Reorder failed", err);
    }
  }

  async overwriteFromSubscriptionCache(email) {

    try {

      const EMAIL_CACHE_TTL = 30 * 1000; // 1 minute

      const cache = JSON.parse(
        localStorage.getItem("email_check_cache") || "{}"
      );

      const entry = cache[email];

      let data = null;

      // ✅ USE CACHE FIRST + CHECK EXPIRY
      if (entry?.data?.subscriptions) {

        const isExpired =
          (Date.now() - entry.checkedAt) > EMAIL_CACHE_TTL;

        if (!isExpired) {

          console.log("Loaded from cache");

          data = entry.data;

        } else {

          console.log("Cache expired");
        }
      }

      // ✅ API CALL IF CACHE NOT FOUND OR EXPIRED
      if (!data) {

        console.log("Calling API");

        const response = await fetch(
          "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ email })
          }
        );

        data = await response.json();

        if (!data || !data.subscriptions) {
          return null;
        }

        // ✅ SAVE CACHE
        cache[email] = {
          data,
          checkedAt: Date.now()
        };

        localStorage.setItem(
          "email_check_cache",
          JSON.stringify(cache)
        );
      }

      // ✅ UI
      //if (data.subscriptions.is_available) {
      if (data?.subscriptions?.is_active?.length > 0) {

        setDisplaySafe("#pre_selected_data_wrap", "none");

      } else {

        setDisplaySafe("#pre_selected_data_wrap", "block");
      }

      let subs = data.subscriptions;

      // ✅ PRIORITY: ACTIVE → PAUSED
      let selectedSub = null;
      let type = null;

      if (
        Array.isArray(subs.is_active) &&
        subs.is_active.length > 0
      ) {

        selectedSub = subs.is_active[0];
        type = "active";

      }else {

        return null;
      }

      let subType = selectedSub.subscriptionType || {};

      let interval = subType.interval;
      let count = subType.intervalCount;

      let frequency_n = "WeeklySubscription";
      let sellingPlan_n = SELLING_PLAN_S;

      if (interval === "WEEK" && count === 2) {

        frequency_n = "FortnightlySubscription";
        sellingPlan_n = SELLING_PLAN_FS;
      }

      const contractId =
        selectedSub.id.split("/").pop();

      const items = (selectedSub.lineItems || []).map(src => {

        let variantId = Number(
          src.variantId.split("/").pop()
        );

        let productId = Number(
          src.productId.split("/").pop()
        );

        return {
          product_id: productId,
          variant_id: variantId,
          title: src.title,
          title: src.title,
          url: "#",
          image: src.image || "",
          price: Math.round(
            parseFloat(src.price) * 100
          ),
          keto_price: 1050,
          t1_price: KETO_PRICE_T1,
          t2_price: KETO_PRICE_T2,
          t3_price: KETO_PRICE_T3,
          qty: src.quantity,
          product_type: "LUNCH & DINNER",
          selling_plan: sellingPlan_n,
          subscription_contract_id: contractId,
          subscription_type: type,
          properties: {
            selectedFrequency: frequency_n
          }
        };

      });

      // ✅ BUILD CART
      this.cart = {
        items,
        total_qty: items.reduce(
          (sum, i) => sum + i.qty,
          0
        ),
        item_count: items.reduce(
          (sum, i) => sum + i.qty,
          0
        ),
        total_price: items.reduce(
          (sum, i) => sum + (i.price * i.qty),
          0
        ),
        original_total_price: items.reduce(
          (sum, i) => sum + (i.price * i.qty),
          0
        ),
        original_keto_total_price: 0,
        original_t1_total_price: 0,
        original_t2_total_price: 0,
        original_t3_total_price: 0,
        attributes: {
          orderType: {
            type: frequency_n
          }
        }
      };

      this._saveCart();

      console.log("Loaded subscription:", type);

      return this.cart;

    } catch (error) {

      console.error(
        "Error overriding from subscription cache:",
        error
      );

      return null;
    }
  }
  
  
  customaddToCart(variantId, quantity, selling_plan=null) {
    var formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity,
        'selling_plan': selling_plan
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cartData => { // Renamed to cartData to avoid conflicts
        // console.log('Success:', cartData);
        getCartData()
          .then(data => {
            this.updateCartInfoFromLocal('.cart-item-loop');
          })
          .catch(error => {
            console.error('Error getting cart data:', error);
          });
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }


  addItem(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan = null, qty_limit_enabled, max_qty_per_order, $productQuantityAction = null, bf_true) {    
    let index;
    const ketoPrice = KETO_PRICE;
    
    //alert(bf_true);

    let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

    console.log('deliveryInfoNew1=>',deliveryInfoNew);

    console.log('state_data1=>',state_data); 
    let new_step = parseInt(state_data.step || 0, 10);

    // #1 (Saahil): do NOT auto-open the cart drawer on add — the customer adds meals from the
    // menu without the drawer popping over the grid each time. The cart count/state still
    // updates via updateCartInfoFromLocal below; they open the cart via the cart icon / Review.

    selling_plan ? index = this.cart.items.findIndex(item => item.variant_id === variantId && item.selling_plan === selling_plan) : index = this.cart.items.findIndex(item => item.variant_id === variantId), index !== -1 ? (this.cart.items[index].qty += qty, this.cart.items[index].qty <= 0 && this.cart.items.splice(index, 1)) : this.cart.items.push({
        product_id: productId,
        variant_id: variantId,
        title,
        url,
        image,
        price,
        compare_at_price:  product_type === "LUNCH & DINNER" ? (compare_at_price || price) : (compare_at_price || price),
        keto_price: ketoPrice,        
        t1_price: KETO_PRICE_T1,  // cents
        t2_price: KETO_PRICE_T2,  
        t3_price: KETO_PRICE_T3,
        qty,
        product_type,
        selling_plan,
        qty_limit_enabled,
        max_qty_per_order,
        bf_true
    }), this._saveCart();
    this.updateCartInfoFromLocal('.cart-item-loop');   
  }

  addItemCondition(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan = null, qty_limit_enabled, max_qty_per_order, $productQuantityAction = null, produc_postcol = null, acknowledge_message = null, bf_true) {    
    
    let index;
    const ketoPrice = KETO_PRICE;
    const validAddress = localStorage.getItem("widgetAddress");     
    this.addItem(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan, qty_limit_enabled, max_qty_per_order, null, bf_true);
  }

  updateItem(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan = null, $productQuantityAction = null) {
      let index;
      let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

      console.log('deliveryInfoNew2=>',deliveryInfoNew);

      console.log('state_data2=>',state_data);
      let new_step = parseInt(state_data.step || 0, 10);

      // #1 (Saahil): do NOT auto-open the cart drawer on a qty update either.

      // Default compare-at to the item's own price — never a hardcoded $12.95 (was a false strikethrough on sub-$12.95 meals).
      compare_at_price = product_type === "LUNCH & DINNER" ? (compare_at_price || price) : (compare_at_price || price);

      selling_plan ? index = this.cart.items.findIndex(item => item.variant_id === variantId && item.selling_plan === selling_plan) : index = this.cart.items.findIndex(item => item.variant_id === variantId), index !== -1 && (this.cart.items[index].qty = qty, this.cart.items[index].compare_at_price = compare_at_price, this.cart.items[index].qty <= 0 && this.cart.items.splice(index, 1)), this._saveCart(), $productQuantityAction?.removeClass("loading")
  }
  changeInToLocalCart(variantId, qty, $productQuantityAction = null) {
      console.log('removed');
      $productQuantityAction && $productQuantityAction?.addClass("loading"), this.updateItem(null, variantId, null, null, null, null, null, qty, null, null, $productQuantityAction)
      localCart.updateCartInfoFromLocal(".cart-item-loop")
  }
  clearCartDataLocal() {
      this.cart = {
          items: [],
          total_qty: 0,
          item_count: 0,
          total_price: 0,
          original_total_price: 0,
          original_keto_total_price: 0,
          original_t1_total_price: 0,
          original_t2_total_price: 0,
          original_t3_total_price: 0
      }, localStorage.removeItem(this.storageKey);
      this.updateCartInfoFromLocal(".cart-item-loop");
      clearCartData();
  }
  countLunchAndDinnerMeals(items = this.cart.items) {
      return Array.isArray(items) ? items.reduce((total_count, item) => item.product_type === "LUNCH & DINNER" ? total_count + (parseInt(item.qty || item.quantity, 10) || 0) : total_count, 0) : 0
  }
  getApplicableDiscountPercent(mealsCount, offers, minMeals = 0) {
    if (!offers || mealsCount < minMeals) return 0;
    
    let bestDiscount = 0;
    let highestMin = -1;

    Object.values(offers).forEach(offer => {
      const { min } = offer.mealRange || {};
      if (typeof min === 'number' && mealsCount >= min && min > highestMin) {
        highestMin = min;
        bestDiscount = offer.discounts;
      }
    });

    return bestDiscount;
  }
  validatedAddress() {
      const validAddress = localStorage.getItem("widgetAddress");
      if (validAddress !== null) {
          const addressResponse = JSON.parse(validAddress),
              {
                  address_line_combined,
                  locality_name,
                  state_territory,
                  postcode,
                  address2
              } = addressResponse;
          // Recipient name for the legacy /checkout?...  URL-param prefill (the classic web checkout
          // reads these; Shopify's one-page checkout ignores them, which is why the real fix lives in
          // pushDeliveryAddressToCart above — but on the legacy form the name still prefills). Guests:
          // customerData is null, so the empty name is dropped by the filter below (never pushed empty).
          const firstName = (userLoggedIn && customerData && customerData.firstName) ? customerData.firstName : "";
          const lastName  = (userLoggedIn && customerData && customerData.lastName)  ? customerData.lastName  : "";
          return Object.fromEntries(Object.entries({
              "checkout[shipping_address][first_name]": firstName,
              "checkout[shipping_address][last_name]": lastName,
              "checkout[shipping_address][country]": "AU",
              "checkout[shipping_address][address1]": address_line_combined,
              "checkout[shipping_address][address2]": address2,
              "checkout[shipping_address][city]": locality_name,
              "checkout[shipping_address][province]": state_territory,
              "checkout[shipping_address][zip]": postcode
          }).filter(([_, value]) => value))
      }
      return !1
  }

  /* NEW-CHECKOUT ADDRESS PREFILL (bug: in-cart Address Check didn't carry to checkout).
     Shopify's one-page checkout SILENTLY IGNORES the legacy checkout[shipping_address][...]
     URL params that validatedAddress() (above) appends to /checkout? — only the store's default
     country/province survive; the customer's street, suburb and postcode never prefill. The
     SUPPORTED mechanism for the new checkout is the Storefront cart's
     buyerIdentity.deliveryAddressPreferences. We set it on the CURRENT ajax cart (its /cart.js
     token already carries the ?key=), so the existing /checkout redirect lands on a checkout with
     the shipping address pre-populated. Best-effort + time-boxed: a slow or failed request can
     NEVER block checkout (mirrors the discount-attribute write pattern). */
  async pushDeliveryAddressToCart() {
    try {
      const raw = localStorage.getItem("widgetAddress");
      if (!raw) return;
      const a = JSON.parse(raw) || {};
      // Only worth doing when we actually have a street line (country/province default anyway).
      if (!a.address_line_combined) return;
      // NB:  renders EMPTY inside a .js.liquid asset on this store, which
      // collapsed the fetch URL to https://api/... — use the Shopify JS global (always the myshopify
      // domain on a storefront) with a hardcoded fallback.
      const SF_DOMAIN = (window.Shopify && window.Shopify.shop) || "thrive-meals-oppenheimer.myshopify.com";
      const SF_TOKEN  = ("6ff1d070c714073d7c5a8509427acab4" || "6ff1d070c714073d7c5a8509427acab4");
      if (!SF_TOKEN) return;
      const cart = await fetch("/cart.js").then(r => r.json()).catch(() => null);
      if (!cart || !cart.token) return;
      const cartId = "gid://shopify/Cart/" + cart.token;   // /cart.js token already includes ?key=
      // RECIPIENT NAME (root cause of the shop.app "Selected shipping address not valid" block):
      // Shopify's checkout negotiate returns DELIVERY_FIRST_NAME_REQUIRED / DELIVERY_LAST_NAME_REQUIRED
      // when the committed delivery address has no name, so the FIRST + LAST name must ride on the
      // pushed MailingAddressInput. Source it from the logged-in customer (customerData is exposed by
      // NDIS-common.liquid — this .js.liquid asset renders WITHOUT request context, so 
      // is unavailable here; the global is the reliable source). Guests have no name (customerData null).
      const firstName = (userLoggedIn && customerData && customerData.firstName) ? String(customerData.firstName).trim() : "";
      const lastName  = (userLoggedIn && customerData && customerData.lastName)  ? String(customerData.lastName).trim()  : "";
      const address = {
        firstName: firstName,
        lastName:  lastName,
        address1:  a.address_line_combined,
        address2:  a.address2,          // optional unit — not part of the required set below
        city:      a.locality_name,
        province:  a.state_territory,
        zip:       a.postcode,
        country:   "AU"
      };
      // REQUIRED-FIELD VALIDATION (Codex Finding #4): deliveryAddressValidationStrategy:COUNTRY_CODE_ONLY
      // makes Shopify ACCEPT an incomplete preference (a missing name/city/zip is silently dropped) and
      // only REJECT it later at checkout negotiate — i.e. it was standing in for real validation. So gate
      // the push on the fields Shopify actually requires. If ANY is missing (e.g. a guest with no name),
      // do NOT commit a partial address: instead CLEAR any stale preference so checkout collects the
      // address+name normally (a soft "no prefill" is strictly better than a hard checkout block).
      // We keep COUNTRY_CODE_ONLY for the COMPLETE case on purpose: the street/suburb come from
      // AddressFinder and serviceability is already decided by our own HDS API, so we don't want Shopify
      // rejecting a valid, serviceable address on minor canonical-format differences — the bug was never
      // address validity (rates were available, postcode serviceable), only the absent recipient name.
      const REQUIRED = ["firstName", "lastName", "address1", "city", "province", "zip", "country"];
      const complete = REQUIRED.every(k => address[k] && String(address[k]).trim() !== "");
      let query, variables;
      if (complete) {
        // Drop only optional-empty fields (address2); every REQUIRED key is present per the check above.
        const cleanAddr = Object.fromEntries(Object.entries(address).filter(([, v]) => v && String(v).trim() !== ""));
        query = "mutation($cartId:ID!,$addr:MailingAddressInput!){cartBuyerIdentityUpdate(cartId:$cartId,buyerIdentity:{deliveryAddressPreferences:[{deliveryAddress:$addr,deliveryAddressValidationStrategy:COUNTRY_CODE_ONLY}]}){userErrors{message}}}";
        variables = { cartId: cartId, addr: cleanAddr };
      } else {
        // Incomplete → clear any previously-committed (possibly nameless) cart delivery preference.
        query = "mutation($cartId:ID!){cartBuyerIdentityUpdate(cartId:$cartId,buyerIdentity:{deliveryAddressPreferences:[]}){userErrors{message}}}";
        variables = { cartId: cartId };
      }
      await Promise.race([
        fetch("https://" + SF_DOMAIN + "/api/2024-10/graphql.json", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": SF_TOKEN },
          body: JSON.stringify({ query: query, variables: variables })
        }).catch(() => null),
        new Promise(r => setTimeout(r, 1800))
      ]);
    } catch (e) { /* never block checkout */ }
  }

  hasDeliveryAndAddressFilled(orderType) {
    const windowState = JSON.parse(localStorage.getItem("window_state") || "{}");
    const widgetAddress = JSON.parse(localStorage.getItem("widgetAddress") || "{}");
    const deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    const addressFilled = !!(widgetAddress.address_line_combined || windowState.address) &&
      !!(widgetAddress.locality_name || windowState.suburb) &&
      !!(widgetAddress.state_territory || windowState.state) &&
      !!(widgetAddress.postcode || windowState.postcode);
    if (orderType === "OneTimePurchase") {
      return !!addressFilled;
    }
    const v = (val) => (typeof val === "string" ? val.trim() !== "" : val !== undefined && val !== null && (Array.isArray(val) ? val.length > 0 : !!val));
    const deliveryFilled = v(deliveryInfo.deliveryDate) && v(deliveryInfo.deliveryStart) &&
      v(deliveryInfo.deliveryEnd) && v(deliveryInfo.packingDate);
    return !!addressFilled && !!deliveryFilled;
  }
  openMiniCartToDeliveryStep(message) {
    // #finalflow deleted — the delivery step is the in-drawer Address Check (Claude Design).
    this.openAddressCheckInDrawer();
  }

  /* F1 cart-deferred — resolve a cart line's protein/calorie macros for the
     "Ng protein · N cal" line slot (screens-cart.jsx CartLine line 16).
     Primary source = the Liquid-built window.THR1VE_MEAL_MACROS map (keyed by
     product_id, from product custom.protein_perserve / calories_perserve metafields).
     Fallback = line-item properties _protein / _calories if a meal was added outside
     the mapped collections. Returns {} when there is no real value for a field so the
     slot stays hidden — NEVER fabricates a macro (CLAUDE.md #3). */
  getMealMacros(productId, properties) {
    const out = {};
    const toNum = (v) => {
      if (v == null || v === "") return null;
      const n = parseFloat(String(v).replace(/[^0-9.]/g, ""));
      return Number.isFinite(n) ? n : null;
    };
    const map = (typeof window !== "undefined" && window.THR1VE_MEAL_MACROS) || {};
    const entry = map[String(productId)] || map[productId] || {};
    const props = properties || {};
    const protein = toNum(entry.protein != null ? entry.protein : (props._protein ?? props.protein));
    const kcal = toNum(entry.kcal != null ? entry.kcal : (props._calories ?? props.calories));
    // Show as INTEGERS (Saahil): protein_perserve can be a decimal (e.g. 33.3) — round for the
    // "Ng protein · N cal" line; calories are already whole.
    if (protein != null) out.protein = Math.round(protein);
    if (kcal != null) out.kcal = Math.round(kcal);
    return out;
  }

  /* F3 cart-deferred — is this cart line a fixed-price bundle box (e.g. the Starter Box)?
     Marker = product_type "Bundle" OR a THR1VE_BUNDLE_INFO entry (built in NDIS-common.liquid
     from the product's custom.bundle_products metafield). Bundles are priced as a set and are
     excluded from the per-meal tier math (countLunchAndDinnerMeals counts only "LUNCH & DINNER"). */
  isBundleItem(item) {
    if (!item) return false;
    const pt = (item.product_type || "").toLowerCase();
    if (pt === "bundle") return true;
    const info = (typeof window !== "undefined" && window.THR1VE_BUNDLE_INFO) || {};
    return !!(info[String(item.product_id)] || info[item.product_id]);
  }

  /* F3 cart-deferred — render the distinct BundleLine (screens-cart.jsx BundleLine):
     image, name (800/14), the set-contents subtitle, set price + Remove, and the dashed
     disclosure "Priced as a set, doesn't count toward your meal tier or change your per-meal
     price." Subtitle source of truth = THR1VE_BUNDLE_INFO[product_id].summary — the product's
     real custom.bundle_summary metafield (e.g. "7 meals · 3 snacks · 3 drinks"), rendered as
     "{summary} · fixed-price set". Falls back to "{mealCount} meals · fixed-price set" (from the
     summed bundle_products_quantity) only when there is no summary, and to a bare
     "fixed-price set" when neither is known — never a guessed count. Remove decrements to 0 via
     the existing changeInToLocalCart path (same as a meal line reaching qty 0). */
  renderBundleLine(item) {
    const info = (typeof window !== "undefined" && window.THR1VE_BUNDLE_INFO) || {};
    const entry = info[String(item.product_id)] || info[item.product_id] || {};
    const summary = (typeof entry.summary === "string" && entry.summary.trim()) ? entry.summary.trim() : null;
    const mealCount = (entry.mealCount != null && entry.mealCount > 0) ? entry.mealCount : null;
    const setLabel = summary
      ? `${summary} · fixed-price set`
      : (mealCount != null ? `${mealCount} meals · ` : "") + "fixed-price set";
    const setPrice = this.formatMoney(item.price * (item.quantity || 1));
    const url = item.url || "#";
    const image = item.image || "";
    const title = item.title || "Bundle";
    const variantId = item.variant_id;
    return `
      <li class="cart-item cart-bundle-line bundle-line d-flex flex-column">
        <div class="cart-bundle-main d-flex align-items-center">
          <div class="cart-image position-relative border rounded">
            <a href="${url}"><img src="${image}" alt="${title}" class="img-fluid"></a>
          </div>
          <div class="cart-bundle-info flex-1">
            <a class="cart_item_title cart-bundle-title" href="${url}">${title}</a>
            <div class="cart-bundle-set-label">${setLabel}</div>
          </div>
          <div class="cart-bundle-pricecol text-end">
            <div class="cart-bundle-price fw-bold">${setPrice}</div>
            <button type="button" class="cart-bundle-remove" onclick="localCart.changeInToLocalCart(${variantId}, 0)">Remove</button>
          </div>
        </div>
        <div class="cart-bundle-note d-flex align-items-start">
          <i class="fa-solid fa-circle-info me-1"></i>
          <span>Priced as a set, doesn't count toward your meal tier or change your per-meal price.</span>
        </div>
      </li>
    `;
  }

  /* F4 cart-deferred — is this cart line a supplement (flat-price, never tier-counted)?
     Classified by product_type against window.THR1VE_SUPPLEMENT_TYPES (the existing B2/F10
     taxonomy seam — empty by default in Phase 1, so no false positives) PLUS the explicit
     literal types "Supplements"/"SUPPLEMENT". Never guesses from a meal type; a missing
     taxonomy simply means no supplement section renders. Doc5 §2c / §4: supplements are
     excluded from the $89 gate and the per-meal tier. */
  isSupplementItem(item) {
    if (!item) return false;
    const pt = (item.product_type || "");
    const ptl = pt.toLowerCase();
    if (ptl === "supplements" || ptl === "supplement") return true;
    const suppTypes = (typeof window !== "undefined" && Array.isArray(window.THR1VE_SUPPLEMENT_TYPES)) ? window.THR1VE_SUPPLEMENT_TYPES : [];
    return suppTypes.length > 0 && suppTypes.includes(pt);
  }

  /* F4 cart-deferred — the currently selected GLOBAL supplement cadence (Doc5 §2c: a single
     frequency across ALL supplements, cart-scoped). Persisted in localStorage so it survives
     re-renders. "onetime" | "monthly". Default one-time. */
  getSupplementCadence() {
    try {
      const v = localStorage.getItem("thr1ve_supp_cadence");
      return v === "monthly" ? "monthly" : "onetime";
    } catch (e) { return "onetime"; }
  }
  setSupplementCadence(cadence) {
    const v = cadence === "monthly" ? "monthly" : "onetime";
    try { localStorage.setItem("thr1ve_supp_cadence", v); } catch (e) {}
    return v;
  }

  /* F4 cart-deferred — render the "Supplements & extras · flat price" section
     (screens-cart.jsx): supplement rows (image, name, flat price, qty stepper) split out of
     the meal list, a GLOBAL One-time/Monthly pill toggle, and the "don't count toward tier"
     note. Supplements are NEVER added to the per-meal tier math (they're not "LUNCH & DINNER")
     and are excluded from the $89 food gate per Doc5 §4. The Monthly cadence only sets the
     UI/persisted preference here — the backend supplement selling-plan wiring is a flagged
     follow-up (we don't fake a recurring charge). suppItems are passed in from the render. */
  updateSupplementsSection(suppItems) {
    const section = document.querySelector(".cart-supplements-section");
    if (!section) return 0;
    const list = section.querySelector(".cart-supp-list");
    const items = Array.isArray(suppItems) ? suppItems : [];

    if (items.length === 0) {
      section.classList.add("d-none");
      section.style.display = "none";
      if (list) list.innerHTML = "";
      return 0;
    }

    // Reflect the persisted global cadence on the pills.
    const cadence = this.getSupplementCadence();
    section.querySelectorAll(".cart-supp-cadence-pill").forEach((pill) => {
      pill.classList.toggle("is-active", pill.getAttribute("data-cadence") === cadence);
    });

    let suppTotalCents = 0;
    if (list) {
      list.innerHTML = "";
      items.forEach((item) => {
        const qty = item.quantity || item.qty || 1;
        suppTotalCents += (item.price || 0) * qty;
        const id = item.variant_id;
        const row = `
          <li class="cart-supp-row d-flex align-items-center">
            <div class="cart-image position-relative border rounded">
              <a href="${item.url || "#"}"><img src="${item.image || ""}" alt="${item.title || ""}" class="img-fluid"></a>
            </div>
            <div class="cart-supp-row-info flex-1">
              <a class="cart_item_title cart-supp-row-title" href="${item.url || "#"}">${item.title || ""}</a>
              <div class="cart-supp-row-price">${this.formatMoney(item.price || 0)} each</div>
            </div>
            <div class="product-quantity-action cart-supp-row-qty d-flex align-items-center">
              <div class="product-quantity" data-variant="${id}">
                <div class="cart-plus-minus">
                  <div class="dec qtybutton" data-action="-"><i class="icon-minus fw-bolder"></i></div>
                  <input value="${qty}" type="text" class="qtyinputcs" name="quantity" min="1" pattern="[0-9]*">
                  <span class="cusqtyspan quantity-${id}">${qty}</span>
                  <div class="inc qtybutton" data-action="+"><i class="icon-plus fw-bolder"></i></div>
                </div>
              </div>
            </div>
          </li>`;
        list.insertAdjacentHTML("beforeend", row);
      });
    }
    section.classList.remove("d-none");
    // mini-cart.liquid stamps an inline `style="display:none"` () on this section
    // whenever the Shopify cart is empty at page load — which is the NORMAL LocalCart state. Removing
    // the d-none class alone doesn't beat the inline style, so the rendered supplement row stayed
    // hidden. Clear the inline display (same as the meal list does) so the section actually shows.
    section.style.display = "";
    return suppTotalCents;
  }

  getCartData() {
      let cartAttributes = {};
      try { cartAttributes = JSON.parse(localStorage.getItem("cartAttributes") || "{}"); } catch (e) { cartAttributes = {}; }
      return {
          items: this.cart.items.map(item => ({
              id: item.variant_id,
              product_id: item.product_id,
              variant_id: item.variant_id,
              title: item.title,
              image: item.image,
              price: item.price,
              keto_price: KETO_PRICE,   
              // Default compare-at to the item's own price — never a hardcoded $12.95 (was a false strikethrough on sub-$12.95 meals).
              compare_at_price:  item.product_type === "LUNCH & DINNER" ? (item.compare_at_price || item.price) : (item.compare_at_price || item.price),
              t1_price: KETO_PRICE_T1,  // cents
              t2_price: KETO_PRICE_T2,  
              t3_price: KETO_PRICE_T3,
              quantity: item.qty,
              selling_plan: item.selling_plan || null,
              qty_limit_enabled: item.qty_limit_enabled, 
              max_qty_per_order: item.max_qty_per_order,               
              bf_true: item.bf_true,
              url: item.url || "#",
              properties: item.properties || {},
              product_type: item.product_type || "",
              // F1 cart-deferred — meal macros for the "Ng protein · N cal" line slot.
              // Pulled from window.THR1VE_MEAL_MACROS (built in NDIS-common.liquid from the
              // product's custom.protein_perserve / calories_perserve metafields, keyed by
              // product_id). Returns null (NOT 0) when there's no value, so the render slot
              // stays hidden and never fabricates a macro. (CLAUDE.md #3.)
              ...this.getMealMacros(item.product_id, item.properties)
          })),
          original_total_price: this.cart.original_total_price || 0,
          original_keto_total_price: this.cart.original_keto_total_price || 0,
          original_t1_total_price: this.cart.original_t1_total_price || 0,
          original_t2_total_price: this.cart.original_t2_total_price || 0,
          original_t3_total_price: this.cart.original_t3_total_price || 0,
          total_price: this.cart.total_price,
          total_count: this.cart.total_qty,
          item_count: this.cart.item_count,
          attributes: cartAttributes
      }
  }    
  
  formatWithDelimiters(cents, precision = 2, thousands = ',', decimal = '.') { 
    if (cents == null || isNaN(cents)) return (0).toFixed(precision);

    // Convert "cents" to dollars
    const negative = Number(cents) < 0;
    const absoluteCents = Math.abs(Number(cents));
    const amount = (absoluteCents / 100).toFixed(precision);

    const [intPart, decPart = ''] = amount.split('.');
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (negative ? '-' : '') + withThousands + (precision ? decimal + decPart : '');
    
  }

  formatMoney(cents, format = "$") {
    // Accept strings like "1,195", "1195", "1195.00", "-1195"
    if (typeof cents === 'string') {
      // keep digits and optional leading minus
      const cleaned = cents.replace(/(?!^-)[^\d]/g, '');
      cents = Number(cleaned);
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    let formatString = format || "$";
    const match = placeholderRegex.exec(formatString);

    // Determine the token (e.g., "amount", "amount_with_comma_separator")
    // and whether the caller passed a full template ("$")
    // or just the token ("amount").
    const hasBraces = !!match;
    const token = hasBraces
      ? match[1]
      : (/^\w+$/.test(formatString) ? formatString : "amount");

    // Compute the formatted value based on the token
    let value;
    switch (token) {
      case 'amount':
        value = this.formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = this.formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = this.formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = this.formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = this.formatWithDelimiters(cents, 2);
    }

    // If the caller gave a template with , replace it.
    // If they passed only the token, return just the value.
    let result = hasBraces ? formatString.replace(placeholderRegex, value) : value;

    // Ensure it starts with $ if not already present
    if (!result.startsWith('$')) {
      result = '$' + result;
    }
    return result;
  }

  isShippingDeductedForTotal(orderType, mealsCount) {
    const shippingAmount = parseFloat(localStorage.getItem("shipping_amount") || 0);
    const windowState = JSON.parse(localStorage.getItem("window_state") || "{}");
    const hasAddress = !!(windowState?.address && String(windowState.address).trim() !== "");
    const isNDISCustomer = userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS");

    if (!shippingAmount || !hasAddress) return false;
    if (isNDISCustomer) return true;

    return ["WeeklySubscription", "FortnightlySubscription"].includes(orderType) && mealsCount >= 10;
  }

  updateTotalDiscountAmount(baseAmountDollars, showAmount = false, includeDeductedShipping = false) {
    const shippingAmount = includeDeductedShipping ? parseFloat(localStorage.getItem("shipping_amount") || 0) : 0;
    const originalAmount = (Number(baseAmountDollars) || 0) + (Number(shippingAmount) || 0);

    document.querySelectorAll(".total-discount-amount").forEach((el) => {
      el.textContent = showAmount && originalAmount > 0 ? this.formatMoney(originalAmount * 100) : "";
      el.classList.toggle("d-none", !(showAmount && originalAmount > 0));
    });
  }

  /* "À la carte meals · filled/target" eyebrow (screens-cart.jsx line 156).
     filled = live à-la-carte (LUNCH & DINNER) meal count; target = the next Doc5 §4
     tier boundary (10/14/18/25), capped at 25. Display-only — no pricing — so it is
     safe to read the locked Doc5 tier boundaries directly. Hidden when no meals. */
  updateAlaCarteEyebrow(isBluefit = false, orderType = "OneTimePurchase") {
    const eyebrow = document.querySelector(".alacarte-eyebrow");
    if (!eyebrow) return;
    const filled = this.countLunchAndDinnerMeals(this.cart.items);
    const filledEl = eyebrow.querySelector(".alacarte-filled");
    if (filledEl) filledEl.textContent = String(filled);

    // Next-CHEAPER-tier nudge on the header (e.g. at 18 meals → "7 more for $9.95/meal"). Same
    // logic as updateBreakNudge: skip same-rate tiers (the 10-tier is the entry $12.95). All Doc5 §4.
    const nudgeEl = eyebrow.querySelector(".alacarte-eyebrow-nudge");
    if (nudgeEl) {
      const tiers = LocalCart.DOC5_MEAL_TIERS;
      let boxTarget = 0;
      try { boxTarget = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
      nudgeEl.textContent = "";
      nudgeEl.classList.add("d-none");
      // T-0032: suppress the tier-break nudge for ANY flat-segment customer. `isBluefit` covers bluefit/conditn/club; the resolveSegmentPriceCents('LUNCH & DINNER') != null term ALSO covers WHOLESALE (NOT isBluefit — rides the shared resolver, same gate as the T-0020 per-meal sweep). Flat segment => fixed $/meal => the retail-ladder nudge must never show. Guests/retail (resolver null, isBluefit false) unchanged.
      // T-0027: ALSO suppress the tier-break nudge for NDIS customers. NDIS pricing is a per-customer co-pay % (customerData.ndisDiscountPercentage), NOT a quantity tier; NDIS is NOT in resolveSegmentPriceCents's SEGMENT_PRIORITY (bluefit/conditn/wholesale) nor isBluefit, so it fell through the T-0032 gate. Same inline idiom as the isNDISCustomer helper. Guests/retail (not NDIS, resolver null, not bluefit) unchanged.
      if (isBluefit || (typeof resolveSegmentPriceCents === "function" && resolveSegmentPriceCents("LUNCH & DINNER") != null) || (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS"))) {
        // no nudge for flat-rate segments (bluefit/conditn/club AND wholesale)
      } else if (boxTarget > 0) {
        // FIXED box: nudge to COMPLETE the box at the box-size tier (e.g. 25-box, 1 filled →
        // "24 more for $9.95/meal") — NOT the next flexible tier.
        if (filled < boxTarget) {
          const boxTier = this.getDoc5MealTier(boxTarget);
          const boxRate = this.capRateForOrder(boxTier.currentPerMealCents != null ? boxTier.currentPerMealCents : tiers[0].perMealCents, orderType);
          nudgeEl.textContent = `${boxTarget - filled} more for ${this.formatMoney(boxRate)}/meal`;
          nudgeEl.classList.remove("d-none");
        }
      } else {
        // FLEXIBLE: next CHEAPER tier ("price drops as you add"). One-time is capped at the 18-tier,
        // so the 25-tier ($9.95) offers no further drop → no nudge past $10.95 on one-time.
        const curTier = this.getDoc5MealTier(filled);
        const currentRate = this.capRateForOrder(curTier.currentPerMealCents != null ? curTier.currentPerMealCents : tiers[0].perMealCents, orderType);
        const nextTier = tiers.find(t => t.meals > filled && this.capRateForOrder(t.perMealCents, orderType) < currentRate);
        if (filled > 0 && nextTier) {
          nudgeEl.textContent = `${nextTier.meals - filled} more for ${this.formatMoney(this.capRateForOrder(nextTier.perMealCents, orderType))}/meal`;
          nudgeEl.classList.remove("d-none");
        }
      }
    }

    // Show the header when meals exist. Clear the  inline display:none (the normal
    // LocalCart state stamps it on load) — toggling d-none alone left the meals header hidden.
    const showIt = filled > 0;
    eyebrow.classList.toggle("d-none", !showIt);
    eyebrow.style.display = showIt ? "" : "none";
  }

  /* F2 cart-deferred — LOCKED Doc5 §4 per-meal tier table (absolute $/meal, NOT %-off).
     10 meals = $12.95 · 14 = $12.50 · 18 = $10.95 · 25 = $9.95 (cents). The 18-tier now runs
     18–24 ($10.95); the deepest tier is 25+ ($9.95) — was 24+ ($9.49) (Saahil 2026-07-04). This is
     the SAME ladder the B5 cart-transform backend charges, so anything DISPLAYED from it matches
     the real checkout price — never a number the cart can't honour. The front-end is display-only;
     it does NOT re-price line items here (the backend owns the charge). Single source of truth
     for the break-nudge ("Add N more to drop to $Y/meal") and the tier-card labels. */
  static get DOC5_MEAL_TIERS() {
    return [
      { meals: 10, perMealCents: 1295 },
      { meals: 14, perMealCents: 1250 },
      { meals: 18, perMealCents: 1095 },
      { meals: 25, perMealCents: 995 }
    ];
  }

  /* For a given live meal count, resolve the current per-meal price and the next tier.
     currentPerMealCents = the highest tier whose threshold is met (null below 10 meals);
     nextTier = the next threshold up, or null at the top (25). Display-only. */
  getDoc5MealTier(mealCount) {
    const tiers = LocalCart.DOC5_MEAL_TIERS;
    let current = null;
    for (const t of tiers) {
      if (mealCount >= t.meals) current = t;
    }
    const next = tiers.find(t => mealCount < t.meals) || null;
    return {
      currentTierMeals: current ? current.meals : null,
      currentPerMealCents: current ? current.perMealCents : null,
      nextTierMeals: next ? next.meals : null,
      nextPerMealCents: next ? next.perMealCents : null,
      atTopTier: !next
    };
  }

  /* Doc5 §4 ONE-TIME cap: a one-time order never prices BELOW the 18-tier ($10.95) — the 25-tier
     ($9.95) is subscriber-only (the box picker locks 25 on one-time). So a one-time box of 25 meals
     is charged/shown at $10.95/meal, not $9.95. Apply to EVERY displayed one-time per-meal rate so
     the meal-line, line items, plan strip and nudges all agree. Subscriptions are uncapped. */
  capRateForOrder(rateCents, orderType) {
    if (orderType === "OneTimePurchase" && rateCents != null) {
      const capTier = this.getDoc5MealTier(18);
      const cap = (capTier && capTier.currentPerMealCents != null) ? capTier.currentPerMealCents : 1095;
      if (rateCents < cap) return cap;
    }
    return rateCents;
  }

  /* B4 — the subscription selling plan for the cart's current meal-count TIER. 10–13 meals → the
     base Weekly/Fortnightly plan ($12.95); 14/18/25 → the tier plan whose PRICE policy bills the
     Doc5 §4 tier (the only way to charge the tier on a subscription — cart-transform can't reprice
     selling-plan lines). Re-resolves with the count (the theme re-selects at checkout). Falls back
     to the base plan if there's no tier map or no tier. */
  sellingPlanForTier(orderType, mealCount) {
    const base = orderType === "FortnightlySubscription" ? SELLING_PLAN_FS : SELLING_PLAN_S;
    try {
      const tierMeals = this.getDoc5MealTier(mealCount).currentTierMeals; // 10/14/18/25 or null
      if (!tierMeals || tierMeals < 14) return base; // 10–13 (or below) → base $12.95
      const map = (typeof SELLING_PLAN_TIERS !== "undefined") ? SELLING_PLAN_TIERS[orderType] : null;
      return (map && map[tierMeals]) ? map[tierMeals] : base;
    } catch (e) { return base; }
  }

  /* F2 cart-deferred — break-nudge (screens-cart.jsx breakNudge): "Add N more to drop to
     $Y/meal". DISPLAY ONLY — both N and $Y come straight from the locked Doc5 §4 table via
     getDoc5MealTier, so the promise equals what the backend charges at that tier. Hidden when
     there are no à-la-carte meals, the cart is already at the top tier (25), or the customer
     is on a flat-price segment (BlueFit $9.95) where tier breaks don't apply. */
  updateBreakNudge(mealCount, { isBluefit = false, orderType = "OneTimePurchase" } = {}) {
    const nudge = document.querySelector(".cart-break-nudge");
    if (!nudge) return;
    const textEl = nudge.querySelector(".cart-break-nudge-text");
    const subEl = nudge.querySelector(".cart-break-nudge-sub");
    const ctaEl = nudge.querySelector(".cart-break-nudge-cta");
    const show = () => { nudge.classList.remove("d-none"); nudge.style.display = "flex"; };
    const hide = () => { nudge.classList.add("d-none"); nudge.style.display = "none"; };

    // T-0032: also suppress for WHOLESALE (rides resolveSegmentPriceCents, NOT isBluefit) — the tier-break nudge must never show to a flat-segment customer. Guests/retail unchanged (resolver null).
    // T-0027: ALSO suppress for NDIS (co-pay %, not a quantity tier; not in resolveSegmentPriceCents nor isBluefit). Same inline NDIS idiom as the isNDISCustomer helper. Guests/retail unchanged.
    if (isBluefit || (typeof resolveSegmentPriceCents === "function" && resolveSegmentPriceCents("LUNCH & DINNER") != null) || (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS")) || mealCount <= 0) { hide(); return; }

    // Next CHEAPER tier — SKIP same-rate tiers (the 10-tier is the same $12.95 as the entry rate,
    // so completing to 10 saves nothing → no pointless nudge / no "save $0"). All Doc5 §4.
    const tiers = LocalCart.DOC5_MEAL_TIERS;
    const entryCents = tiers[0].perMealCents;
    const curTier = this.getDoc5MealTier(mealCount);
    // ONE-TIME caps at the 18-tier ($10.95) — the 25-tier ($9.95) is subscriber-only, so on one-time
    // there is NO cheaper tier past 18 and we must NOT nudge toward a 25-meal box.
    const currentRate = this.capRateForOrder(curTier.currentPerMealCents != null ? curTier.currentPerMealCents : entryCents, orderType);
    const nextTier = tiers.find(t => t.meals > mealCount && this.capRateForOrder(t.perMealCents, orderType) < currentRate);
    if (!nextTier) { hide(); return; }          // top tier / no cheaper tier ahead (incl. one-time at 18+)
    const nextRate = this.capRateForOrder(nextTier.perMealCents, orderType);
    const addN = nextTier.meals - mealCount;
    const noun = `meal${addN === 1 ? "" : "s"}`;

    // FLEXIBLE (Build-Your-Own, no target) vs FIXED (picker stored thr1ve_box_target).
    let boxTarget = 0;
    try { boxTarget = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
    const isFlexible = boxTarget <= 0;
    const isFull = !isFlexible && mealCount >= boxTarget;
    if (ctaEl) ctaEl.removeAttribute("data-upgrade-to");

    if (isFlexible) {
      // BREAK nudge (screens-cart.jsx breakNudge) — push toward the next cheaper tier.
      if (textEl) textEl.innerHTML = `Add <strong>${addN} more</strong> to drop to <strong class="nudge-rate">${this.formatMoney(nextRate)}/meal</strong> across your whole box`;
      if (subEl) subEl.textContent = "";
      if (ctaEl) { ctaEl.textContent = "Add more"; ctaEl.setAttribute("data-action", "add-meals"); }
      show();
      return;
    }

    if (isFull) {
      // SAVING nudge (screens-cart.jsx savingNudge) — box is full at its tier; upgrading the
      // WHOLE box to the next tier is the win. Never show a $0 saving.
      const savingCents = mealCount * (currentRate - nextRate);
      if (savingCents <= 0) { hide(); return; }
      const marginalEachCents = Math.round((nextTier.meals * nextRate - mealCount * currentRate) / addN);
      const totalDropCents = mealCount * currentRate - nextTier.meals * nextRate; // ≥0 in the cliff case
      const an = (nextTier.meals === 18 || nextTier.meals === 11) ? "n" : "";
      if (marginalEachCents > 0) {
        if (textEl) textEl.innerHTML = `Add ${addN} ${noun} · <strong>save ${this.formatMoney(savingCents)}</strong>`;
        if (subEl) subEl.textContent = `The ${addN} that complete a${an} ${nextTier.meals}-meal box are just ${this.formatMoney(marginalEachCents)} each.`;
      } else {
        if (textEl) textEl.innerHTML = `Add ${addN} ${noun} · <strong>pay less</strong>`;
        if (subEl) subEl.textContent = `Completing your ${nextTier.meals}-meal box drops your total by ${this.formatMoney(totalDropCents)}.`;
      }
      // "Add N" SWAPS the box selection up a tier (Saahil) — they then fill the bigger box.
      if (ctaEl) { ctaEl.textContent = `Add ${addN}`; ctaEl.setAttribute("data-action", "upgrade-box"); ctaEl.setAttribute("data-upgrade-to", String(nextTier.meals)); }
      show();
      return;
    }

    // FIXED box, not yet full → no nudge (the checkout gate shows "Add N more to complete").
    hide();
  }

  /* T-0148 — cart SAVINGS PROGRESS BAR (owner, issue #190). Display-only; every number comes from the
     LOCKED Doc5 §4 tier table (DOC5_MEAL_TIERS) + capRateForOrder, so it equals the checkout charge.
       one-time     → ladder 10 / 14 / 18   (the 25 tier is subscriber-only and is NOT shown)
       subscription → ladder 10 / 14 / 18 / 25
     Segments are equal width (0→10, 10→14, 14→18, …) so each rung is readable on a phone; the fill is
     linear inside the segment the meal count is in. Saving = (entry $/meal − current $/meal) × meals,
     the same definition the footer "Cart Discount" row uses. Hidden for an empty box and for flat-price
     segments (BlueFit / wholesale / NDIS) — same suppression as the break nudge. */
  updateSavingsBar(mealCount, { isBluefit = false, orderType = "OneTimePurchase" } = {}) {
    const bar = document.querySelector(".cart-savings-bar");
    if (!bar) return;
    const hide = () => { bar.classList.add("d-none"); bar.style.display = "none"; };
    if (isBluefit || (typeof resolveSegmentPriceCents === "function" && resolveSegmentPriceCents("LUNCH & DINNER") != null) || (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS")) || !(mealCount > 0)) { hide(); return; }

    const isOneTime = orderType === "OneTimePurchase";
    const entryCents = LocalCart.DOC5_MEAL_TIERS[0].perMealCents;
    // One-time: drop any rung whose rate is capped away (the subscriber-only 25 tier).
    const rungs = LocalCart.DOC5_MEAL_TIERS.filter(t => this.capRateForOrder(t.perMealCents, orderType) === t.perMealCents);
    const n = rungs.length;
    if (!n) { hide(); return; }

    let pct = 100;
    const j = rungs.findIndex(t => mealCount < t.meals);
    if (j >= 0) {
      const lo = j === 0 ? 0 : rungs[j - 1].meals;
      pct = ((j + (mealCount - lo) / (rungs[j].meals - lo)) / n) * 100;
    }
    pct = Math.max(0, Math.min(100, pct));

    const curTier = this.getDoc5MealTier(mealCount);
    const curRate = this.capRateForOrder(curTier.currentPerMealCents != null ? curTier.currentPerMealCents : entryCents, orderType);
    const savingCents = Math.max(0, entryCents - curRate) * mealCount;

    const titleEl = bar.querySelector(".csb-title");
    const modeEl = bar.querySelector(".csb-mode");
    const track = bar.querySelector(".csb-track");
    const fill = bar.querySelector(".csb-fill");
    const marks = bar.querySelector(".csb-marks");
    const labels = bar.querySelector(".csb-labels");
    if (titleEl) titleEl.textContent = savingCents > 0 ? `You're saving ${this.formatMoney(savingCents)}` : "The more meals you add, the more you save";
    if (modeEl) modeEl.textContent = orderType === "WeeklySubscription" ? "Weekly subscription" : orderType === "FortnightlySubscription" ? "Fortnightly subscription" : "One-time order";
    if (track) {
      track.setAttribute("aria-valuemax", String(rungs[n - 1].meals));
      track.setAttribute("aria-valuenow", String(mealCount));
      track.setAttribute("aria-valuetext", `${mealCount} meals in your box`);
    }
    if (fill) fill.style.width = `${pct}%`;
    if (marks) marks.innerHTML = rungs.map((t, k) => `<span class="csb-dot${mealCount >= t.meals ? " is-on" : ""}" style="left:${((k + 1) / n) * 100}%"></span>`).join("");
    if (labels) labels.innerHTML = rungs.map((t, k) => `<span class="csb-label${mealCount >= t.meals ? " is-on" : ""}" style="left:${((k + 1) / n) * 100}%"><b>${t.meals}</b> meals<em>${this.formatMoney(t.perMealCents)}<i>/meal</i></em></span>`).join("");
    bar.classList.remove("d-none");
    bar.style.display = "block";
  }

  /* #5 footer "{N} meals · {$/meal}/meal" line (the per-line price was removed, so the
     per-meal rate lives here) + #6 one-time shipping estimate "Est. $15–$20" + the address
     note. Meal rate is the LOCKED Doc5 §4 tier rate; subscription keeps the existing "FREE". */
  updateCartFooterExtras(mealCount, orderType) {
    const isOneTime = orderType === "OneTimePurchase";
    const isBluefit = this.isBluefit === true;
    const entryCents = LocalCart.DOC5_MEAL_TIERS[0].perMealCents;

    // #5 meals line
    const line = document.querySelector(".cart-meals-line");
    if (line) {
      if (mealCount > 0 && !isBluefit) {
        // FIXED box → the $/meal rate is the box-size tier (25-box → $9.95), not the live count.
        let _bt = 0;
        try { _bt = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
        const tier = this.getDoc5MealTier(_bt > 0 ? Math.max(mealCount, _bt) : mealCount);
        let rate = tier.currentPerMealCents != null ? tier.currentPerMealCents : entryCents;
        rate = this.capRateForOrder(rate, orderType);   // one-time caps at the 18-tier ($10.95)
        // T-0020 sweep: a priced segment (wholesale/conditn) pays a FLAT per-meal price, not the volume tier.
        // resolveSegmentPriceCents -> cents for a logged-in priced segment on L&D, else null (guest/untagged -> keep tier). No hardcoded value; no $9 leak.
        { const _segFooter = (typeof resolveSegmentPriceCents === "function") ? resolveSegmentPriceCents("LUNCH & DINNER") : null; if (_segFooter != null) rate = _segFooter; }
        const cEl = line.querySelector(".cart-meals-line-count");
        const rEl = line.querySelector(".cart-meals-line-rate");
        const tEl = line.querySelector(".cart-meals-line-total");
        if (cEl) cEl.textContent = `${mealCount} meal${mealCount === 1 ? "" : "s"}`;
        if (rEl) rEl.textContent = `· ${this.formatMoney(rate)}/meal`;
        if (tEl) tEl.textContent = this.formatMoney(mealCount * rate);
        line.classList.remove("d-none");
        line.style.display = "flex";
      } else {
        line.classList.add("d-none");
        line.style.display = "none";
      }
    }

    // #6 shipping ADDRESS NOTE — shown for ONE-TIME (the "Est. $15–$20" amount itself is set by
    // the shipping logic in the render); subscription ("FREE") hides the note.
    const note = document.querySelector(".shipping-est-note");
    if (note) {
      if (isOneTime && !isBluefit) { note.classList.remove("d-none"); note.style.display = "block"; }
      else { note.classList.add("d-none"); note.style.display = "none"; }
    }

    // #9 "Add more from the menu" — show at the bottom of the cart whenever there are meals
    // (clear any server item_style display:none baked in when the cart was empty at load).
    const addMore = document.querySelector(".cart-add-more-bottom");
    if (addMore) {
      if (mealCount > 0) { addMore.classList.remove("d-none"); addMore.style.display = "flex"; }
      else { addMore.style.display = "none"; }
    }
  }

  /* BOX-FILL GATE (Saahil + updated Claude Design): a FIXED box (picker stored a numeric
     window_state.boxSize) must be FILLED before checkout. Flexible / Build-Your-Own
     (boxSize null) is exempt — only the $89 gate applies. The checkout button is set to a
     ready state by ~5 different render branches, so this runs LAST (scheduled via setTimeout
     after the render) and overrides the button to a locked "Add N more to complete your box"
     when short. proceedToCheckout() carries the same guard for direct calls. */
  /* Guard: a stale localStorage state can pair freq=OneTimePurchase with a FIXED
     thr1ve_box_target of 25, but the 25 box is subscriber-only (the picker locks it on one-time).
     Coerce such a stale one-time target down to the one-time cap (18) so the cart, fill gate, and
     per-meal display never treat a one-time order as a 25-meal box. Mirrors the box-size-picker's
     own preselect/continue coercion, at the cart layer (readers of thr1ve_box_target bypass the
     picker when the customer never re-opens it). Writes back so all direct readers see the fix. */
  sanitizeBoxTargetForOrderType() {
    try {
      const freq = (JSON.parse(localStorage.getItem("window_state") || "{}").freq) || "WeeklySubscription";
      if (freq !== "OneTimePurchase") return;
      const bt = Number(localStorage.getItem("thr1ve_box_target")) || 0;
      if (bt >= 25) localStorage.setItem("thr1ve_box_target", "18"); // sub-only 25 box → one-time cap
    } catch (e) {}
  }

  enforceBoxFillGate() {
    this.sanitizeBoxTargetForOrderType();     // stale one-time+25 box → 18 before gating
    const btn = document.getElementById("continue_to_shipping");
    if (!btn) return;
    let boxSize = 0;
    try { boxSize = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
    if (boxSize <= 0) return;                 // flexible — no fill requirement
    const meals = this.countLunchAndDinnerMeals();
    if (meals >= boxSize) return;             // filled — leave the ready button alone
    const remain = boxSize - meals;
    btn.removeAttribute("onclick");
    btn.classList.remove("thr1ve-checkout-green", "bg-orange", "border-orange");
    btn.style.removeProperty("background");
    btn.style.removeProperty("border-color");
    btn.style.removeProperty("color");
    btn.setAttribute("aria-disabled", "true");
    btn.innerHTML = `Add ${remain} more to complete your ${boxSize}-meal box`;
  }

  /* SUPPLEMENT-ONLY checkout gate (AUTHORITATIVE rules — B1r frontend). A Case-3 supplements-only
     order (has supplements, ZERO non-supplement/food subtotal) is VALID — supplements are excluded
     from the $89 food minimum and the order ships Australia Post on its own, so it must NOT be
     blocked by the "Add N meals / $89" gate. Runs LAST (after enforceBoxFillGate + every render
     button-setter) and, when supplements-only, UNLOCKS the button to a ready Checkout state.
     Mixed carts (food present) are untouched — their food still has to clear $89/meal minimums. */
  enforceSupplementOnlyCheckout() {
    const btn = document.getElementById("continue_to_shipping");
    if (!btn) return;
    const s = this.supplementCartState(this.cart && this.cart.items);
    if (!s.hasSupplement || s.nonSuppSubtotalCents !== 0) return;  // only a supplements-only cart
    btn.removeAttribute("aria-disabled");
    btn.classList.remove("disabled");
    btn.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
    btn.style.setProperty("background", "#54B52A", "important");
    btn.style.setProperty("border-color", "#54B52A", "important");
    btn.style.setProperty("color", "#fff", "important");
    const t = (document.querySelector(".total-price-amount")?.textContent || "").trim();
    btn.innerHTML = "Checkout" + (t ? " · " + t : "") + ' <span aria-hidden="true" style="margin-left:5px">&rarr;</span>';
  }

  /* Menu sticky bar — Continue/Review button (design/screens-menu.jsx StickyBar).
     DISPLAY ONLY: reads the meal count / total units the render already computed and
     flips the bottom-bar button between two states. NO pricing/box/tier logic forked.
       - units > 0  → ENABLED "Review your box" (subscription) / "Review your order"
                      (one-time). Click is handled by the existing .cart-count handler
                      (main.js) which opens the mini-cart / review drawer.
       - units == 0 → DISABLED "Add meals to continue" (no fabricated {N} target — the
                      menu bar enables on ANY item; the $89/tier gate lives in Review).
     The per-design rule (screens-menu.jsx L47-48): the Continue button is enabled
     whenever the cart holds anything; dollar/tier gating is NOT applied here. */
  updateReviewButton(unitsInCart, orderType) {
    const btn = document.querySelector("[data-review-btn]");
    if (!btn) return;
    const labelEl = btn.querySelector(".review-btn-label");
    const countWrap = btn.querySelector(".review-btn-count");
    const units = Number(unitsInCart) || 0;
    const isOneTime = orderType === "OneTimePurchase";

    if (units > 0) {
      btn.classList.remove("is-empty");
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-disabled");
      if (labelEl) labelEl.textContent = isOneTime ? "Review your order" : "Review your box";
      if (countWrap) countWrap.classList.remove("d-none");
    } else {
      btn.classList.add("is-empty");
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-disabled", "true");
      if (labelEl) labelEl.textContent = "Add meals to continue";
      if (countWrap) countWrap.classList.add("d-none");
    }
  }

  /* Order-aware menu card "Add" label — design/screens-menu.jsx. product-menu-item.liquid
     server-renders the FIRST-paint label from cart.attributes.orderType, but the customer's
     real order type is chosen client-side and lives in window_state.freq (the picker writes
     it, never the server cart attribute) — so a One-Time selection kept showing "Add to
     subscription". Update every MENU card's label here from the same source the rest of the
     cart uses: window_state.freq (+ BlueFit, who is always one-time $9.95/meal).
       subscription → "Add to subscription"   ·   one-time / BlueFit → "Add to box"
     Scoped to the product grid so the cart-drawer upsell buttons are untouched. */
  updateMenuAddLabels(orderType) {
    const labels = document.querySelectorAll(".product-view .add-to-cart .cart-title, #product-grid .add-to-cart .cart-title");
    if (!labels.length) return; // only on the menu page
    // Saahil: the pill is narrower than "Add to subscription" at some widths (text clipped),
    // so every card uses the short "Add to box" regardless of order type.
    const text = "Add to box";
    labels.forEach(el => {
      // hideCartIcon:true on the menu cards means .cart-title has no icon child — just set
      // its text. Guard for an icon child anyway (replace only the trailing text node).
      if (el.childElementCount === 0) { el.textContent = text; }
      else if (el.lastChild && el.lastChild.nodeType === 3) { el.lastChild.textContent = text; }
      else { el.appendChild(document.createTextNode(text)); }
    });
  }

  /* Menu "meal-box chrome" (design/screens-menu.jsx) — the dark plan strip
     ("Building your box · {freq} · Flexible quantity") + the OpenPricing counter
     ("{N} meals in your box" + "{$/meal}/meal" / "price drops as you add" + the
     "You're at N, add M more to drop to $Y/meal" break nudge), rendered at the top of the
     menu by snippets/menu-box-chrome.liquid. DISPLAY ONLY — reuses countLunchAndDinnerMeals
     and the LOCKED Doc5 §4 tier table (getDoc5MealTier), so every number equals what the B5
     backend charges. No-ops when the chrome isn't on the page (e.g. the cart drawer). */
  updateMenuBoxChrome(orderType) {
    const root = document.getElementById("menu-box-chrome");
    if (!root) return; // only on the menu page
    const mealCount = this.countLunchAndDinnerMeals(this.cart.items);

    // Plan strip frequency label from window_state (falls back to the order type).
    let freq = "Weekly";
    try {
      const ws = JSON.parse(localStorage.getItem("window_state") || "{}");
      const f = ws.freq || orderType;
      if (f === "FortnightlySubscription") freq = "Fortnightly";
      else if (f === "OneTimePurchase") freq = "One-time";
      else freq = "Weekly";
    } catch (e) {}
    const freqEl = root.querySelector(".menu-plan-freq");
    if (freqEl) freqEl.textContent = freq;

    // Box-size label — keep in SYNC with the chosen box (thr1ve_box_target), the same source the
    // cart's plan strip + box-fill gate read. Was hardcoded "Flexible quantity", which mismatched a
    // FIXED box the cart enforces ("Add N more to complete your 14-meal box"). Flexible / Build-Your-
    // Own (no target) → "Flexible quantity"; a fixed tile → "{N}-meal box".
    let boxTarget = 0;
    try { boxTarget = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
    // Reflect the TIER actually reached, not just the picked box (picked 14, now at 18 → "18-meal
    // box") — same as the cart plan strip, so menu + cart never disagree.
    const reachedTier = this.getDoc5MealTier(mealCount).currentTierMeals || 0;
    const displayBox = Math.max(boxTarget, reachedTier);
    const mutedEl = root.querySelector(".menu-plan-strip-muted");
    if (mutedEl) mutedEl.textContent = displayBox > 0 ? `${displayBox}-meal box` : "Flexible quantity";

    // Count + per-meal price (or "price drops as you add" when the box is empty).
    const countEl = root.querySelector(".menu-op-count-n");
    if (countEl) countEl.textContent = mealCount;
    const ppmWrap = root.querySelector(".menu-op-ppm");
    const ppmVal = root.querySelector(".menu-op-ppm-val");
    const ppmTail = root.querySelector(".menu-op-ppm-tail");
    const emptyEl = root.querySelector(".menu-op-empty");
    // A FIXED box (picker stored thr1ve_box_target) gates checkout to that size, so the per-meal
    // tier is known up-front — price every meal at the box-size tier immediately. FLEXIBLE
    // (no target) still "drops as you add" from the live count.
    let _boxTarget = 0;
    try { _boxTarget = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
    const _isFixedBox = _boxTarget > 0;
    const _tierCount = _isFixedBox ? Math.max(mealCount, _boxTarget) : mealCount;
    const tier = this.getDoc5MealTier(_tierCount);

    // Problem 1 (Saahil) — update every meal CARD price to the LIVE tier $/meal, so the cards match
    // the plan strip and what checkout charges (one-time via cart-transform, subscription via the
    // tier selling plan). Empty/below-10 → the entry $12.95. Segment customers (BlueFit/keto/NDIS/
    // T1-T3) keep their own server-rendered segment price — never overwrite it with the Doc5 tier.
    {
      const _segFlat = (typeof resolveSegmentPriceCents === "function") ? resolveSegmentPriceCents("LUNCH & DINNER") : null;
      const _isSeg = (_segFlat != null) || this.isBluefit || (userLoggedIn && Array.isArray(customerData?.tags) &&
        (customerData.tags.includes("keto_customers") || customerData.tags.includes("NDIS") ||
         customerData.tags.includes("T1") || customerData.tags.includes("T2") || customerData.tags.includes("T3")));
      if (!_isSeg) {
        const _cardCents = this.capRateForOrder((tier.currentPerMealCents != null) ? tier.currentPerMealCents : LocalCart.DOC5_MEAL_TIERS[0].perMealCents, orderType);
        // ONLY re-price LUNCH & DINNER meal cards — snacks/drinks/supplements keep their own
        // server-rendered price (marked with .is-ld-meal in product-menu-item.liquid).
        document.querySelectorAll(".is-ld-meal .mc-price .price-now").forEach((el) => { el.textContent = this.formatMoney(_cardCents); });
      }
    }

    // BlueFit (and any future flat segment) shows its FLAT per-meal price here, not the
    // Doc5 tier — same as the plan strip, cart and cards. Without this the OpenPricing
    // card was the one spot still showing the tier $/meal to BlueFit customers.
    const _segFlatPpm = (typeof resolveSegmentPriceCents === "function") ? resolveSegmentPriceCents("LUNCH & DINNER") : null;
    const _segCents = (_segFlatPpm != null) ? _segFlatPpm : ((this.isBluefit && typeof BLUEFIT_PRICE !== "undefined") ? BLUEFIT_PRICE : null);
    const _ppmCents = (_segCents != null) ? _segCents
                    : (tier.currentPerMealCents != null ? this.capRateForOrder(tier.currentPerMealCents, orderType) : null);
    if ((mealCount > 0 || _isFixedBox) && _ppmCents != null) {
      if (ppmVal) ppmVal.textContent = this.formatMoney(_ppmCents);
      // BlueFit is free-shipping regardless of one-time/sub; otherwise free shipping shows on subs only.
      if (ppmTail) ppmTail.textContent = (orderType === "OneTimePurchase" && !this.isBluefit) ? "/meal" : "/meal · Free shipping";
      if (ppmWrap) ppmWrap.classList.remove("d-none");
      if (emptyEl) emptyEl.classList.add("d-none");
    } else {
      if (ppmWrap) ppmWrap.classList.add("d-none");
      if (emptyEl) emptyEl.classList.remove("d-none");
    }

    // Break nudge — "You're at N, add M more to drop to $Y/meal" (next LOCKED Doc5 §4 tier).
    const nudge = root.querySelector(".menu-op-nudge");
    const nudgeText = root.querySelector(".menu-op-nudge-text");
    if (nudge) {
      // Next CHEAPER tier (skip the same-rate 10-tier) + "across your whole box" wording.
      const tiersM = LocalCart.DOC5_MEAL_TIERS;
      const entryM = tiersM[0].perMealCents;
      // ONE-TIME caps at the 18-tier ($10.95); the 25-tier ($9.95) is subscriber-only, so on one-time
      // there's no cheaper tier past 18 → don't nudge toward a 25-meal box / $9.95.
      const curRateM = this.capRateForOrder(tier.currentPerMealCents != null ? tier.currentPerMealCents : entryM, orderType);
      const cheaperM = tiersM.find(t => t.meals > mealCount && this.capRateForOrder(t.perMealCents, orderType) < curRateM);
      // Fixed box → tier is locked to the box size; no "add more to drop" nudge.
      // T-0032: suppress the menu open-pricing tier-break nudge for flat-segment customers. `_segFlatPpm` (resolveSegmentPriceCents result, declared above) is non-null for WHOLESALE/conditn/bluefit on L&D; `this.isBluefit` backstops club. Guests/retail (resolver null, not bluefit) unchanged.
      // T-0027: also EXCLUDE NDIS from the menu open-pricing tier-break nudge (co-pay %, not a quantity tier; not covered by _segFlatPpm nor this.isBluefit). Guests/retail (not NDIS) unchanged.
      if (mealCount > 0 && cheaperM && !_isFixedBox && _segFlatPpm == null && !this.isBluefit && !(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS"))) {
        const need = cheaperM.meals - mealCount;
        if (nudgeText) {
          nudgeText.innerHTML = `Add <strong>${need} more</strong> to drop to <strong>${this.formatMoney(this.capRateForOrder(cheaperM.perMealCents, orderType))}/meal</strong> across your whole box`;
        }
        nudge.classList.remove("d-none");
      } else {
        nudge.classList.add("d-none");
      }
    }
  }

  /* F5 cart-deferred — NDIS 30/70 co-pay panel (screens-cart.jsx NDIS panel). Shown ONLY for
     NDIS-tagged customers. The split is PER-CUSTOMER: it reads the real
     customerData.ndisDiscountPercentage (the % NDIS covers, e.g. 70) — co-pay % = 100 − that
     (e.g. 30). NEVER hardcodes 30/70. Mirrors the render's existing NDIS pricing math
     (co-pay per line = full × (1 − ndisPct/100), where full = compare_at_price) so the panel
     numbers equal what the cart total shows. "covered" = full goods − co-pay (the NDIS-funded
     portion); shipping is NDIS-covered per the existing isShippingDeductedForTotal logic, so it
     is folded into the covered side, not the co-pay. Hidden for non-NDIS customers. */
  updateNdisPanel(coPayDollars) {
    const panel = document.querySelector(".cart-ndis-panel");
    if (!panel) return;

    const isNdis = (typeof userLoggedIn !== "undefined" && userLoggedIn)
      && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS")
      && typeof customerData.ndisDiscountPercentage === "number";

    if (!isNdis) {
      panel.classList.add("d-none");
      return;
    }

    const ndisPct = customerData.ndisDiscountPercentage;      // % NDIS covers (e.g. 70)
    const coPayPct = Math.max(0, 100 - ndisPct);              // % the customer pays (e.g. 30)

    // Full goods price (pre-NDIS) summed across lines using compare_at_price (the same base the
    // render's NDIS branch uses). Excludes nothing on the goods side — bundles/snacks included.
    const items = (this.cart && Array.isArray(this.cart.items)) ? this.cart.items : [];
    let fullGoodsCents = 0;
    items.forEach((it) => {
      const qty = it.qty || it.quantity || 1;
      const base = (it.compare_at_price && it.compare_at_price > 0) ? it.compare_at_price : it.price;
      fullGoodsCents += (base || 0) * qty;
    });

    const coPayCents = Math.round((coPayDollars || 0) * 100);
    const coveredCents = Math.max(0, fullGoodsCents - coPayCents);

    const setText = (sel, val) => { const el = panel.querySelector(sel); if (el) el.textContent = val; };
    setText(".cart-ndis-copay-pct", String(coPayPct));
    setText(".cart-ndis-covered-pct", String(ndisPct));
    setText(".cart-ndis-copay-amount", this.formatMoney(coPayCents));
    setText(".cart-ndis-covered-amount", this.formatMoney(coveredCents));
    setText(".cart-ndis-full-amount", this.formatMoney(fullGoodsCents));

    panel.classList.remove("d-none");
  }

  /* Next subscription charge falls on a MONDAY (billing 9:30am AEST). Compute the upcoming
     Monday in Sydney time; a Fortnightly plan charges the Monday one week later. Returns a
     label like "Monday 29 Jun" (DISPLAY ONLY — the contract's real anchor governs billing;
     this is a generic forward estimate for the cart note). */
  nextChargeMondayLabel(orderType) {
    const fmt = new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Sydney", year: "numeric", month: "2-digit", day: "2-digit" });
    const parts = fmt.formatToParts(new Date());
    const get = (t) => Number((parts.find(p => p.type === t) || {}).value);
    const y = get("year"), m = get("month"), d = get("day");
    // Build from the Sydney Y/M/D at midday UTC (avoids DST/midnight edges), then walk to Monday.
    const base = new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
    const dow = base.getUTCDay();          // 0 Sun … 1 Mon …
    let add = (1 - dow + 7) % 7;           // days until the next Monday
    if (add === 0) add = 7;                // today IS Monday → this week's charge has run; show next
    if (orderType === "FortnightlySubscription") add += 7;
    base.setUTCDate(base.getUTCDate() + add);
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `Monday ${base.getUTCDate()} ${months[base.getUTCMonth()]}`;
  }

  /* Dark ink plan strip (screens-cart.jsx "PLAN STRIP"): freq · $/meal · Change.
     Pure display — it reads values already computed by the render (mealsCount,
     mealsTotal) and never re-prices, so it cannot diverge from the cart total or
     invent a number. Hidden when no meals are in the box. The "Change" button
     re-opens the existing Delivery → Plan → Review flow (showFinalFlow path) —
     no commerce logic forked. Sub-only: shows a calendar disclosure note whose
     cut-off copy is the Doc5 §2 locked Tue 9:00pm. */
  updatePlanStrip({ mealsCount = 0, mealsTotal = 0, orderType = "OneTimePurchase", isSub = false, isNDIS = false, isBluefit = false } = {}) {
    const strip = document.querySelector(".cart-plan-strip");
    if (!strip) return;

    const hasMeals = mealsCount > 0;
    strip.classList.toggle("d-none", !hasMeals);
    // mini-cart.liquid stamps an inline display:none () on this strip whenever the
    // Shopify cart is empty at load (the normal LocalCart state), which beats the d-none toggle and
    // kept the plan strip hidden. Clear it when showing so customers actually SEE their plan.
    strip.style.display = hasMeals ? "" : "none";
    if (!hasMeals) return;

    const titleEl = strip.querySelector(".cart-plan-strip-title");
    const subEl = strip.querySelector(".cart-plan-strip-sub");
    const note = strip.querySelector(".cart-plan-strip-note");
    const noteText = strip.querySelector(".cart-plan-strip-note-text");

    const freqLabel = isBluefit
      ? "One-time"
      : orderType === "WeeklySubscription"
        ? "Weekly"
        : orderType === "FortnightlySubscription"
          ? "Fortnightly"
          : "One-time";

    // Per-meal price. BlueFit / conditn / club members pay a FLAT $9.95/meal segment price (Doc5 §4)
    // — NOT the volume tier. Everyone else gets the locked Doc5 tier rate for their meal count.
    const entryCents = LocalCart.DOC5_MEAL_TIERS[0].perMealCents;
    // Fixed box → price at the box-size tier up-front; flexible → live count (same rule as the cards).
    let boxTargetPS = 0;
    try { boxTargetPS = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
    const tier = this.getDoc5MealTier(boxTargetPS > 0 ? Math.max(mealsCount, boxTargetPS) : mealsCount);
    // T-0020 sweep: route the NON-club per-meal rate through the shared segment resolver so a
    // WHOLESALE customer (isBluefit=false — "wholesale" is NOT in `clubs`) shows their FLAT $9.00,
    // not the volume tier. bluefit/conditn/club (isBluefit=true) keep BLUEFIT_PRICE exactly (unchanged).
    // Guests/untagged -> resolver null -> tier price (no $9 leak). Value-agnostic (no hardcoded price).
    const _segPS = (!isBluefit && typeof resolveSegmentPriceCents === "function") ? resolveSegmentPriceCents("LUNCH & DINNER") : null;
    const rateCents = isBluefit
      ? (typeof BLUEFIT_PRICE !== "undefined" ? BLUEFIT_PRICE : 995)
      : (_segPS != null ? _segPS : this.capRateForOrder((tier.currentPerMealCents != null ? tier.currentPerMealCents : entryCents), orderType));
    const perMealStr = this.formatMoney(rateCents);

    // FLEXIBLE (Build-Your-Own, no target) vs FIXED (picker stored thr1ve_box_target). For a
    // flexible box the header is "Building your box · {freq}" (Saahil: it was wrongly showing
    // "{freq} · {N} meals" as if a fixed box) and the sub leads with the live meal count.
    let boxTarget = 0;
    try { boxTarget = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
    const isFlexible = boxTarget <= 0;
    // BlueFit/conditn/club members get FREE shipping (same as subscriptions). Other one-time orders
    // pay delivery at checkout.
    const shipTail = (isSub || isBluefit) ? " · free shipping" : " · + delivery at checkout";

    if (isFlexible) {
      if (titleEl) titleEl.textContent = `Building your box · ${freqLabel}`;
      if (subEl) subEl.textContent = `${mealsCount} meal${mealsCount === 1 ? "" : "s"} · ${perMealStr}/meal${shipTail}`;
    } else {
      // Fixed box: the label must reflect the TIER the customer has actually reached, not just the
      // box they picked. If they add past their box into a higher tier (e.g. picked 14, now at 18),
      // the bundle name upgrades 14 → 18 (Saahil). displayBox = max(picked box, reached tier).
      const displayBox = Math.max(boxTarget, tier.currentTierMeals || 0);
      if (titleEl) titleEl.textContent = `${freqLabel} · ${displayBox} meals`;
      if (subEl) subEl.textContent = `${perMealStr}/meal${shipTail}`;
    }

    // Sub-only disclosure (Saahil correction): a SUBSCRIPTION can be edited until Tuesday
    // 9:00pm (AEST); billing then occurs the following Monday at 9:30am. Surface the next
    // charge Monday (computed) + the edit cut-off.
    if (note && noteText) {
      if (isSub) {
        // Saahil 2026-06-30 (CONFIRMED two-cutoff model): the ONGOING subscription is editable until
        // the charge — Monday 9:30am (AEST). (The CURRENT order being placed has a different cutoff,
        // Tuesday 9:00pm — that's the top cutoff pill below, shared with one-off orders.) Fortnightly
        // resolves to the Monday a week later (nextChargeMondayLabel adds 7).
        noteText.textContent = `Next charge: ${this.nextChargeMondayLabel(orderType)}. Edit ongoing orders until Monday 9:30am (AEST) — reminders sent 48h before.`;
        note.classList.remove("d-none");
      } else {
        note.classList.add("d-none");
      }
    }

    // The "Edit until …" timer pill = the cutoff for the CURRENT order being placed (a one-off order
    // OR the subscription order they're checking out right now): Tuesday 9:00pm (AEST). This is
    // distinct from the ONGOING subscription's recurring cutoff (Monday 9:30am) shown in the plan-
    // strip note above. (Confirmed model, Saahil 2026-06-30.)
    const cutoffNote = document.querySelector("#mini-cart .cutoff-note, .timerContainer .cutoff-note, .cutoff-note");
    if (cutoffNote) {
      cutoffNote.innerHTML = 'Edit this order until <strong>Tuesday 9:00pm (AEST)</strong>';
    }
  }


  showHideReOrderBOX(have){

    const {
      promoOffer = "",
      contractId = "",
      orderNo = 0,
    } = JSON.parse(subscriptionContractId || "{}");

    let newContractId = contractId;

    if(!newContractId && state.email){
      newContractId = this.getContractIdFromCache(state.email);    
    }

    if(have){
      if(newContractId){        
        setDisplaySafe("#re-order", "none");
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "none";
        });
      }else if (userLoggedIn && !this.isExcluded_Global) {
        setDisplaySafe("#re-order", "flex");
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "block";
        });
      }else{
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "block";
        });
      }
    }else{ 
      if(userLoggedIn){
        if(newContractId){        
          setDisplaySafe("#re-order", "none");
          document.querySelectorAll(".discount-card").forEach(el => {
            el.style.display = "none";
          });
        }else if (!this.isExcluded_Global) {
          setDisplaySafe("#re-order", "none");
          document.querySelectorAll(".discount-card").forEach(el => {
            el.style.display = "block";
          });
        }
      }else{ 
        setDisplaySafe("#re-order", "none");
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "none";
        });
      }
    }

  }


  updateCartInfoFromLocal(cartCellId, reload = 0, welcomeApplied = false) {
      //this.formatMoney(1195); 
      const cart = this.getCartData();
      const cartCell = jQuery(cartCellId);
      let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
      const WELCOME25_APPLIED = localStorage.getItem("WELCOME25_APPLIED");
      jQuery(".upsell-desk-custom, .upsell-mob-custom").removeClass("display-none");
      jQuery(".main-cart-container").removeClass("w-100");
      if (typeof cartCellId !== "string" || !cartCell.length) {
        console.error("Invalid cartCellId provided or not found");
        return;
      }
      const { attributes = {}, items, total_price, item_count } = cart;
      const orderType = state_data.freq ? state_data.freq : "WeeklySubscription";
  
      cartCell.empty();
  
      const total_count = item_count;
      const mealsCount = this.countLunchAndDinnerMeals(items);
      const cart_show_count = item_count;
      let ISKETO = false;
      let ISNDIS = false;
      
      let hasAddressNew = !!(state_data?.address && String(state_data.address).trim() !== "");  
      
      const excludedTags = this.excludedTags_Global; 
      const isExcluded = this.isExcluded_Global;
      const isBluefitUser = this.isBluefit;
      const isPromoActive = this.additionalpromo && !isExcluded && (orderType === "OneTimePurchase" || orderType === "WeeklySubscription" || orderType === "FortnightlySubscription");   
  
      let totalPrice = 0;

  
      // F4 cart-deferred — supplements are split into their own flat-price section (below),
      // never rendered in the meal list and never tier-counted. Collect them here so the
      // main loop skips them and the supplements section can render them separately.
      const supplementItems = [];

      if (items.length > 0) {

        jQuery(".cart-item-loop, .subtotal-title-area").show();

        jQuery(".cart-tempty-title").hide();

        items.forEach(item => {
          const { price, compare_at_price, quantity, url, image, title, variant_id, product_type, id = variant_id, selling_plan = null, bf_true = false } = item;

          // F4 cart-deferred — supplement line → flat section, excluded from the meal list and
          // from the per-meal tier + $89 food math (Doc5 §2c/§4). Its price IS still part of
          // the cart total (added when the section renders below).
          if (this.isSupplementItem(item)) {
            supplementItems.push(item);
            return;
          }

          // F3 cart-deferred — Bundle (Starter Box) line (screens-cart.jsx BundleLine).
          // A bundle is marked by product_type "Bundle" (and carries a THR1VE_BUNDLE_INFO
          // entry built from custom.bundle_products). Render it as a DISTINCT fixed-price
          // line and add it to the running totalPrice at its set price — it is already
          // EXCLUDED from the per-meal tier math because countLunchAndDinnerMeals only
          // counts "LUNCH & DINNER" lines, never "Bundle". (Doc5 §4: bundle priced as a
          // set, doesn't change per-meal price.)
          if (this.isBundleItem(item)) {
            totalPrice += price * quantity / 100;
            cartCell.append(this.renderBundleLine(item));
            return;
          }

          let priceHTML = "", comparePriceHTML = "";
          let actualPrice = price;

          // Doc5 §4 PLAN tier (Saahil 2026-06-30): a normal meal's per-LINE price IS the meal-count
          // tier price — exactly what the cart-transform Function (B4) charges at checkout. Override
          // for L&D lines so the line display matches the charge (e.g. at 18 meals every line shows
          // $10.95, re-resolving as the count changes). Segments (BlueFit/keto/NDIS/T1-T3) set their
          // OWN per-meal price in their branches below, so they're excluded here.
          {
            const _isSeg = userLoggedIn && Array.isArray(customerData?.tags) &&
              (customerData.tags.includes("NDIS") || customerData.tags.includes("keto_customers") ||
               customerData.tags.includes("T1") || customerData.tags.includes("T2") || customerData.tags.includes("T3"));
            if (product_type === "LUNCH & DINNER" && !_isSeg && !isBluefitUser) {
              // A FIXED box (thr1ve_box_target) is gated to that size, so every meal is charged the
              // box-size tier immediately (e.g. a 25-box prices meals at $9.95 with 1 in the cart),
              // NOT the live-count "flexible" tier. Flexible → the live count.
              let _bt = 0;
              try { _bt = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
              const _tierCount = _bt > 0 ? Math.max(mealsCount, _bt) : mealsCount;
              const _tier = this.getDoc5MealTier(_tierCount);
              if (_tier.currentPerMealCents != null) actualPrice = _tier.currentPerMealCents;
              actualPrice = this.capRateForOrder(actualPrice, orderType);   // one-time caps at 18-tier ($10.95)
            }
          }

          /*if(this.additionalpromo && product_type === "LUNCH & DINNER"){
            actualPrice = PROMO_PROD_PRICE;
          }*/

          if (compare_at_price > actualPrice) {
            comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`;
          }
  
          if (orderType === "OneTimePurchase") {

            const minOtp = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
            const discountPercent = this.getApplicableDiscountPercent(mealsCount, typeof oneTimeOffers !== "undefined" ? oneTimeOffers : null, minOtp);
            let actualPrice2 = price;

            if(isBluefitUser) {
              console.log('price',price);
              actualPrice = BLUEFIT_PRICE;
            }
            // Segment price via the SHARED helper — honors run.js priority (bluefit>conditn>wholesale) and the
            // exact 'LUNCH & DINNER' gate; returns null => leave the normal price. Runs after the bluefit/club
            // pre-set so an exact priced tag (incl. conditn) refines to ITS own segment price and can never
            // show below checkout (fixes conditn+wholesale showing $9.00 while checkout charges conditn $9.95).
            var otpSegCents = (typeof resolveSegmentPriceCents === 'function') ? resolveSegmentPriceCents(product_type) : null;
            if (otpSegCents != null) {
              actualPrice = otpSegCents;
            }
            console.log('isBluefitUser',isBluefitUser);
            console.log('actualPrice',actualPrice);

            if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
              ISNDIS = true;
              actualPrice2 = compare_at_price;
              const discountCents = Math.floor(actualPrice2 * customerData.ndisDiscountPercentage / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = 1050;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                // Strikethrough ONLY when a genuine RRP exceeds the displayed price (never equal). CLAUDE.md #3 / Doc5 §6.
                comparePriceHTML = (compare_at_price > discountedPriceCents)
                  ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`
                  : "";
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = KETO_PRICE_T1;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                // Strikethrough ONLY when a genuine RRP exceeds the displayed price (never equal). CLAUDE.md #3 / Doc5 §6.
                comparePriceHTML = (compare_at_price > discountedPriceCents)
                  ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`
                  : "";
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = KETO_PRICE_T2;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                // Strikethrough ONLY when a genuine RRP exceeds the displayed price (never equal). CLAUDE.md #3 / Doc5 §6.
                comparePriceHTML = (compare_at_price > discountedPriceCents)
                  ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`
                  : "";
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = KETO_PRICE_T3;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                // Strikethrough ONLY when a genuine RRP exceeds the displayed price (never equal). CLAUDE.md #3 / Doc5 §6.
                comparePriceHTML = (compare_at_price > discountedPriceCents)
                  ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`
                  : "";
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
             
            } else if (userLoggedIn && Array.isArray(customerData.tags) && isBluefitUser) {

                totalPrice += actualPrice * quantity / 100;
                // BlueFit flat $9.95/meal (Doc5 §4). Strikethrough ONLY when a GENUINE RRP exists
                // and is strictly greater than the displayed $9.95 — never strike an equal value
                // (compare_at_price defaults to the item's own price when no real RRP is set, which
                // would otherwise render $9.95 struck-through over a live $9.95). CLAUDE.md #3 / Doc5 §6 ACL.
                comparePriceHTML = (compare_at_price > actualPrice)
                  ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`
                  : "";
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;

            } else if (product_type === "LUNCH & DINNER" && discountPercent > 0) {

              totalPrice += actualPrice * quantity / 100;

              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }

              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;

            } else {

              totalPrice += actualPrice * quantity / 100;
              
              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }

              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;

            }
          }

          if (orderType === "WeeklySubscription" || orderType === "FortnightlySubscription") {
            const minSubs = typeof MIN_SUBS_MEAL_LIMIT !== "undefined" ? MIN_SUBS_MEAL_LIMIT : 10;
            const subsDiscountPercent = this.getApplicableDiscountPercent(mealsCount, typeof promotionalOffers !== "undefined" ? promotionalOffers : null, minSubs);
            let actualPrice2 = price;

            if(isBluefitUser) {
              console.log('price',price);
              actualPrice = BLUEFIT_PRICE;
            }
            // Segment price via the SHARED helper — honors run.js priority (bluefit>conditn>wholesale) and the
            // exact 'LUNCH & DINNER' gate; returns null => leave the normal price. Runs after the bluefit/club
            // pre-set so an exact priced tag (incl. conditn) refines to ITS own segment price and can never
            // show below checkout (fixes conditn+wholesale showing $9.00 while checkout charges conditn $9.95).
            var subsSegCents = (typeof resolveSegmentPriceCents === 'function') ? resolveSegmentPriceCents(product_type) : null;
            if (subsSegCents != null) {
              actualPrice = subsSegCents;
            }

            if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
              actualPrice2 = compare_at_price;
              const discountCents = Math.floor(actualPrice2 * customerData.ndisDiscountPercentage / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const subscriptionPrice2 = 1050;
                totalPrice += subscriptionPrice2 * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(subscriptionPrice2)}</span>`;
                // Strikethrough ONLY when a genuine RRP exceeds the displayed price (never equal). CLAUDE.md #3 / Doc5 §6.
                comparePriceHTML = (compare_at_price > subscriptionPrice2)
                  ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`
                  : "";
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (product_type === "LUNCH & DINNER" && subsDiscountPercent > 0) {

              let discountCents = Math.floor(actualPrice * subsDiscountPercent / 100);              
              let discountedPriceCents = actualPrice - discountCents;
              totalPrice += actualPrice * quantity / 100;
                
              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }     

              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              
            } else {

              totalPrice += actualPrice * quantity / 100;

              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
            }
          }

          /* FIX #2 (Saahil, dev — menu-refine2): the design cart LINE ITEMS (screens-cart.jsx
             CartLine) carry NO per-line compare-at strikethrough — the box total + "you're saving
             X" lives in the FOOTER only. The per-segment branches above set comparePriceHTML once
             a tier discount makes compare_at_price > the displayed price (so it appeared
             inconsistently, "only when >1 item"). Blank it at this single render point so the
             strikethrough never shows on a line for ANY segment, WITHOUT touching pricing math:
             totalPrice / NDIS / keto / footer savings are all already computed above from the real
             prices and are left untouched. */
          comparePriceHTML = "";

          const listItem = `
            ${/* #9/#10 (Saahil): single-ROW cart line — [image] [name + "Ng protein · N cal"]
                 [qty stepper ~30%], all vertically centred. The stepper used to sit on its own
                 line below the text (wasted vertical space + left gap); it's now a sibling of
                 .cart-title so the row height is just name+macros. The image fills .cart-image
                 (object-fit:cover, no white space). */''}
            <li class="cart-item d-flex align-items-center">

              <div class="cart-image position-relative border rounded">
                <a href="${url}">
                  <img src="${image}" alt="${title}" class="img-fluid">
                </a>
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-orange px-2 py-1">${quantity}</span>
              </div>

              <div class="cart-title d-flex flex-column">
                <div class="cart-top-area">
                  <a class="cart_item_title" href="${url}">${title}</a>
                </div>
                ${(item.protein != null || item.kcal != null)
                  ? `<div class="cart-item-macros">${item.protein != null ? `${item.protein}g protein` : ""}${(item.protein != null && item.kcal != null) ? " · " : ""}${item.kcal != null ? `${item.kcal} cal` : ""}</div>`
                  : ""}
                <span class="quantity-${id} d-none">${quantity}</span>
              </div>

              <div class="product-quantity-action cart-qty-inline d-flex align-items-center justify-content-end">
                <div class="product-quantity" data-variant="${id}">
                  <div class="cart-plus-minus">
                    <div class="dec qtybutton" data-action="-"><i class="icon-minus fw-bolder"></i></div>
                    <input value="${quantity}" type="text" class="qtyinputcs" name="quantity" min="1" pattern="[0-9]*">
                    <span class="cusqtyspan quantity-${id}">${quantity}</span>
                    <div class="inc qtybutton" data-action="+"><i class="icon-plus fw-bolder"></i></div>
                  </div>
                </div>
                <span class="cart-loading load-anim d-none"><i class="ion-load-a"></i></span>
              </div>
            </li>
          `;
          cartCell.append(listItem);
        });

        // F4 cart-deferred — render the flat-price supplements section (screens-cart.jsx).
        // Its total IS part of the cart total (supplements are paid for) but it never feeds
        // the per-meal tier or the $89 food gate (Doc5 §4). Hidden when no supplement line.
        const suppTotalCents = this.updateSupplementsSection(supplementItems);
        totalPrice += suppTotalCents / 100;

      } else {

        jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").hide();
        jQuery(".cart-tempty-title").show();
        jQuery(".cart-item-title").hide();
        // F4 — no items → ensure the supplements section is hidden too.
        this.updateSupplementsSection([]);

        if (cartCell) {
          // Cart-audit (screens-cart.jsx EMPTY STATE): two browse buttons, matching the
          // static empty state in mini-cart.liquid.
          const li_empty = '<li><div class="cart-empty-title" ><i class="icon-handbag"></i><p class="text-center mb-4">You have no items in your cart</p><div class="empty-cart-actions"><a href="/pages/menu" class="btn btn-style3">Browse the menu</a><a href="/collections/snacks" class="btn btn-style3 btn-outline-empty">Browse supplements</a></div></div></li>';
          cartCell.append(li_empty);
        }

      }

      if(window.innerWidth < 999){
        jQuery(".upsell-desk-custom, .upsell-mob-custom").addClass("display-none");
      }
  
      this.updateTotalDiscountAmount(0, false);
      const cartCounter = jQuery(".bigcounter");
      const cartcountitem = jQuery(".cart-count-item");  
      
      // console.log(totalPrice);
  
      //if (!(subscriptionContractId && userLoggedIn)) {
        cartCounter.html(cart_show_count).addClass("added-cart-event");
        cartcountitem.html(cart_show_count);
      //}

      // À la carte meals · filled/target eyebrow (screens-cart.jsx).
      this.updateAlaCarteEyebrow(isBluefitUser, orderType);

      // F2 cart-deferred — $/meal break nudge (screens-cart.jsx breakNudge), display-only,
      // driven from the locked Doc5 §4 tier table (matches the backend charge).
      this.updateBreakNudge(mealsCount, { isBluefit: isBluefitUser, orderType });
      this.updateSavingsBar(mealsCount, { isBluefit: isBluefitUser, orderType });

      // Menu sticky bar — Continue/Review button label + enabled state (display-only).
      // Enabled on ANY units in the box; the $89/tier gate lives in the Review screen.
      this.updateReviewButton(total_count, orderType);
      this.updateMenuBoxChrome(orderType);
      this.updateMenuAddLabels(orderType);
      // #5 cart footer "{N} meals · {$/meal}/meal" line, #6 one-time shipping est, #9 add-more.
      this.updateCartFooterExtras(mealsCount, orderType);

      setTimeout(() => cartCounter.removeClass("added-cart-event"), 2000);
      jQuery(".currency .active").trigger("click");
      // console.log({cart, totalPrice});

      //console.log('totalPrice',totalPrice);
      
      let url = new URL(window.location.href);
      let hasFlag = url.searchParams.has("open-mini-cart");
      
      if(hasFlag){
        this.hasFlag = true;
        if(state_data.postcode && state_data.suburb){
          listSuburbsBasedOnPostCode(state_data.postcode, state_data.suburb);
          applyShippingAmount();
        }
      }
      
      let shipping_amount_get = (localStorage.getItem("shipping_amount") || 0);
      let selected_Frequency_New = state_data?.freq || "OneTimePurchase";
      let shipping_aa = parseFloat(shipping_amount_get);
      // Saahil: the drawer "Total Amount" = ALL cart items (meals + supplements + bundles + drinks +
      // snacks) WITHOUT shipping — the same as Weekly. Shipping stays the separate "Est. $15–$20"
      // line and is charged at ACTUAL checkout (Shopify/Function), so the drawer total isn't
      // inflated (and can't be inflated by a DEFAULTED zone amount). Previously one-time added the
      // zone shipping into the total, making the subtotal ≠ the Total Amount.
      let totalwithshipping = totalPrice;

      let isSubscription = ["WeeklySubscription", "FortnightlySubscription"].includes(selected_Frequency_New);

      // Dark ink plan strip (screens-cart.jsx PLAN STRIP) — freq · $/meal · Change.
      // Display-only: reads the render's already-computed totalPrice/mealsCount,
      // never re-prices (Doc5 §4 tiers drive totalPrice through the existing path).
      this.updatePlanStrip({
        mealsCount,
        mealsTotal: totalPrice,
        orderType: selected_Frequency_New,
        isSub: isSubscription,
        isNDIS: ISNDIS,
        isBluefit: isBluefitUser
      });

      // F5 cart-deferred — NDIS 30/70 co-pay panel (screens-cart.jsx). Display-only, shown
      // only for NDIS-tagged customers; reads the real per-customer ndisDiscountPercentage.
      // totalPrice here is the NDIS co-pay sum (the render applied the per-line NDIS discount).
      this.updateNdisPanel(totalPrice);

      /*console.log('welcomeApplied', welcomeApplied);
      console.log('shipping_aa', shipping_aa);
      console.log('welcome25',this.welcome25);
      console.log('totalPrice--',totalPrice);
      console.log('totalwithshipping--',totalwithshipping);
      if(this.welcome25){
        totalPrice = totalPrice - 25;
      }*/

      this.generateOfferDOM(cart, totalPrice, totalwithshipping, welcomeApplied);
      // Box-fill gate runs LAST (after every button-setter in this render task) so a short
      // FIXED box can't reach checkout. setTimeout(0) defers past all synchronous render code.
      // The supplement-only gate runs right after it (also last) to UNLOCK checkout for a valid
      // Case-3 supplements-only order that the meal/$89 minimum render would otherwise block.
      setTimeout(() => { this.enforceBoxFillGate(); this.enforceSupplementOnlyCheckout(); }, 0);

      if(Object.keys(state_data).length){
        state_data = state;
      }
      let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      
      const {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");


      let newContractId = contractId;

      if(!newContractId && state_data.email){
        newContractId = this.getContractIdFromCache(state_data.email);    
      }

      //let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
      //let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

      const finalflow = document.getElementById("finalflow");
      const borderTop = document.getElementById("border-topbg-white");
      const cartWrap = document.getElementById("cart-item-wrap");
      const continueBtn = document.querySelector("#continue_to_shipping");

      const hasStateData = Object.keys(state_data).length > 0;

      const hasDeliveryInfo =
        deliveryInfoNew.deliveryDate &&
        deliveryInfoNew.deliveryStart &&
        deliveryInfoNew.deliveryEnd &&
        state_data.address &&
        state_data.suburb &&
        state_data.state &&
        state_data.postcode;

      // #finalflow is DELETED — guarded so the cart still renders. showFinalFlow is now only used
      // to keep the cart body hidden while the in-drawer Address Check is open.
      const showCartFlow = () => {
        if (finalflow) finalflow.style.display = "none";
        if (borderTop) borderTop.style.display = "block";
        if (cartWrap) cartWrap.style.display = "block";
        this.showHideReOrderBOX(1);
      };

      const showFinalFlow = () => {
        if (borderTop) borderTop.style.display = "none";
        if (cartWrap) cartWrap.style.display = "none";
        if (finalflow) finalflow.style.display = "block";
        this.showHideReOrderBOX(0);
      };

      // Cart-drawer redesign (screens-cart.jsx) — drawer DEFAULTS to the meal list.
      // The drawer's primary view is the meal list + summary + Checkout button
      // (showCartFlow). The #finalflow Delivery→Plan steps are a CHECKOUT stage, entered
      // ONLY by an explicit user action — localCart.proceedToCheckout() ->
      // openMiniCartToDeliveryStep(), or the plan-strip "Change" handler — each of which
      // shows #finalflow itself and sets window.__thr1veInFinalFlow so the step survives
      // the cart re-renders that follow (address entry, etc.).
      //
      // The legacy state machine here auto-jumped to #finalflow on every fresh open when
      // saved delivery info was missing — which is ALWAYS true for a new box — so the meal
      // list was hidden and the customer saw an empty Delivery step with their meals
      // nowhere in sight (Saahil: "meals are not showing in the cart drawer" + a stray
      // "finalflow section showing"). We now render the meal list by default and only stay
      // in #finalflow while the customer is actively in that checkout step. Every former
      // reload/login branch already wanted showCartFlow at render time, so this is
      // behaviour-preserving for them and only removes the unwanted auto-jump.
      if (window.__thr1veInFinalFlow) {
        showFinalFlow();
      } else {
        showCartFlow();
      }

      if (hasFlag) {
        console.log("phase", "64");

        document.querySelector(".cart-count")?.click();
        url.searchParams.delete("open-mini-cart");

        this.showHideReOrderBOX(1);

        if (state_data.postcode && state_data.suburb) {
          listSuburbsBasedOnPostCode(state_data.postcode, state_data.suburb);
        }

        console.log("isExcluded", isExcluded);
        console.log("newContractId", newContractId);
        console.log("isLogin", isLogin);        

        if (!isExcluded && !newContractId && isLogin) {

          console.log("phase", "65");
          console.log("deliveryInfoNew", deliveryInfoNew);
          console.log("state_data 65", state_data);
          
          setDisplaySafe("#pre_selected_data", "block"); /* cart-audit: element removed with its wrap — guard */
          setDisplaySafe("#pre_selected_data_wrap", "block");

          if (hasDeliveryInfo) {

            console.log("phase", "651");
            this.showHideReOrderBOX(1);

          }else{

            document.getElementById("step2")?.classList.remove("hidden");
            console.log("phase", "652");
            this.showHideReOrderBOX(1);
            setDisplaySafe("#re-order", "none");
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });

          }

          this.updateTierDiscountCard();

          console.log('hasFlag1', hasFlag);

        } else if (newContractId && isLogin) {

          console.log("phase", "66");

          setDisplaySafe("#pre_selected_data", "none");  /* cart-audit: element removed with its wrap — guard */
          setDisplaySafe("#pre_selected_data_wrap", "none");
          showCartFlow();
          this.showHideReOrderBOX(0);
          console.log('hasFlag2', hasFlag);

        }else if (isLogin){

          console.log("phase", "67");
          
          if(isExcluded){

            console.log("phase", "671");

            document.getElementById("step2")?.classList.remove("hidden"); 
            setDisplaySafe("#re-order", "none");
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });

          }else{
            
            setDisplaySafe("#pre_selected_data", "block"); /* cart-audit: element removed with its wrap — guard */
            setDisplaySafe("#pre_selected_data_wrap", "block");

            if (hasDeliveryInfo) {

              console.log("phase", "672");

              setDisplaySafe("#re-order", "flex");
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "block";
              });

            }else{

              console.log("phase", "673");

              document.getElementById("step2")?.classList.remove("hidden");
              setDisplaySafe("#re-order", "none");
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "none";
              });
              
            }

          }
          console.log('hasFlag3', hasFlag);

        }

        //checkWELCOME25FromCart();
        
        window.history.replaceState({}, document.title, url.toString());
        

      } else {

        console.log("isExcluded1", isExcluded);
        console.log("newContractId1", newContractId);
        console.log("isLogin1", isLogin);
        console.log("hasDeliveryInfo", hasDeliveryInfo);

        console.log("phase", "68");

        if (!isExcluded && !newContractId && isLogin) {  

          console.log("phase", "69");
          
          setDisplaySafe("#pre_selected_data", "block"); /* cart-audit: element removed with its wrap — guard */
          setDisplaySafe("#pre_selected_data_wrap", "block");        

          if (hasDeliveryInfo) {

            console.log("phase", "691");

            this.showHideReOrderBOX(1);

          }else{

            document.getElementById("step2")?.classList.remove("hidden");
            console.log("phase", "692");
            this.showHideReOrderBOX(1);
            setDisplaySafe("#re-order", "none");
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });
            
          }
          
          this.updateTierDiscountCard();
          console.log('hasFlagNon1');

        } else if (newContractId && isLogin) {

          console.log("phase", "70");
          setDisplaySafe("#pre_selected_data", "none");  /* cart-audit: element removed with its wrap — guard */
          setDisplaySafe("#pre_selected_data_wrap", "none");
          showCartFlow();
          this.showHideReOrderBOX(0);
          console.log('hasFlagNon2');

        }else if (isLogin){

          console.log("phase", "71");
          
          if(isExcluded){

            document.getElementById("step2")?.classList.remove("hidden"); 
            setDisplaySafe("#re-order", "none");
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });

          }else{
            
            setDisplaySafe("#pre_selected_data", "block"); /* cart-audit: element removed with its wrap — guard */
            setDisplaySafe("#pre_selected_data_wrap", "block");

            if (hasDeliveryInfo) {

              setDisplaySafe("#re-order", "flex");
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "block";
              });

            }else{

              document.getElementById("step2")?.classList.remove("hidden");
              setDisplaySafe("#re-order", "none");
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "none";
              });
              
            }

          }

          console.log('hasFlagNon3');

        }else{

          console.log("phase", "72");
          let new_step = parseInt(state_data.step || 0, 10);

          if (Object.keys(state_data).length === 0 || (new_step < 2)) {

            console.log("phase", "721");

            // Cart-drawer redesign: a GUEST with an incomplete box (step < 2) used to be
            // force-jumped into the #finalflow Delivery step here, hiding their meals.
            // Default to the meal list instead; #finalflow is shown only once the customer
            // explicitly proceeds to checkout (window.__thr1veInFinalFlow). Same fix as the
            // primary render decision above.
            if (window.__thr1veInFinalFlow) { showFinalFlow(); } else { showCartFlow(); }

          }else{

            console.log("phase", "722");
          
            setDisplaySafe("#pre_selected_data", "block"); /* cart-audit: element removed with its wrap — guard */
            setDisplaySafe("#pre_selected_data_wrap", "block");
            showCartFlow();

          }
        }
      }

      if (items.length > 0) {

        if(!isExcluded && (newContractId != '' || !newContractId)){
          this.updateTierDiscountCard();
        }
        this.checkAllVariantsOnLoad();

      }else{

        setDisplaySafe("#re-order", "none");
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "none";
        });
      }

        continueBtn?.classList.remove("d-none");


  }


  getShippingAmount(appiled = true){
      const statenew = JSON.parse(localStorage.getItem("window_state") || "{}");
      const locaDelInit = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

      let shipping_amount = localStorage.getItem("shipping_amount") || 0;
      let selected_frequency = statenew?.freq;

      let amountEl = document.querySelector(".free-shipping-amount");
      let freeTextEl = document.querySelector(".free-shipping-text");
      let deliveryShippingEl = document.querySelector(".delivery-text-shippingamount");
      let mealsCountS = this.countLunchAndDinnerMeals(this.cart.items);

      if (!amountEl) return;

      const format = (cents) => this.formatMoney(cents);
      const defaultShippingCents = 1500; // $15.00 default
      const currentShippingCents = Math.round(parseFloat(shipping_amount || 0) * 100);

      const hasAddress = !!(statenew?.address && String(statenew.address).trim() !== "");      

      const setShippingText = (text) => {
        amountEl.textContent = text;
      };

      amountEl.classList.add("fw-bold");

      // AUTHORITATIVE supplement shipping (see supplementCartState). Per ORDER:
      //   Case 3 (supplements only / no qualifying ≥$89 food) → Australia Post standalone (~$10)
      //   Case 1 (qualifying SUBSCRIPTION food)               → FREE (supplements ride free)
      //   Case 2 (qualifying ONE-TIME food) / meal OTP        → meal zone shipping "Est. $15–$20"
      // (the real shipping_amount used at checkout still comes from localStorage / zone logic.)
      const { hasSupplement, nonSuppSubtotalCents } = this.supplementCartState();
      // Doc5 §line 322: the THREE shipping cases are keyed on whether a MEAL ORDER EXISTS (food in
      // the cart), NOT on the $89 threshold. Case 3 ($10 Aus Post) is ONLY a supplements-ONLY order
      // (no food at all). If ANY food is present, supplements RIDE WITH the order → FREE (subscription)
      // or the meal zone shipping "Est. $15–$20" (one-time). (The $89 is the checkout gate, not the
      // shipping key.)
      const supplementOnly = hasSupplement && nonSuppSubtotalCents === 0;
      const isOneTimeShip = selected_frequency === "OneTimePurchase";
      amountEl.classList.remove("text-decoration-line-through");
      freeTextEl?.classList.add("d-none");
      if (supplementOnly) {
        // Case 3 — supplements-only order ships Australia Post on its own (~$10, pending final).
        setShippingText("Est. $10");
        amountEl.classList.remove("free_amount", "shipping-free-green");
        amountEl.style.textTransform = "none";
        amountEl.style.removeProperty("color");
        if (deliveryShippingEl) deliveryShippingEl.textContent = "Est. $10";
      } else if (isOneTimeShip && this.isBluefit !== true) {
        // One-time, NON-segment food order → meal zone shipping. (BlueFit/conditn/club members are
        // one-time too but get FREE shipping — they fall through to the FREE branch below.)
        setShippingText("Est. $15–$20");
        amountEl.classList.remove("free_amount", "shipping-free-green");
        amountEl.style.textTransform = "none";
        amountEl.style.removeProperty("color");
        if (deliveryShippingEl) deliveryShippingEl.textContent = "Est. $15–$20";
      } else {
        setShippingText("FREE");
        amountEl.classList.add("free_amount", "shipping-free-green");
        amountEl.style.setProperty("color", "#3F8F1F", "important"); // green
        amountEl.style.textTransform = "uppercase";
        if (deliveryShippingEl) deliveryShippingEl.textContent = "FREE";
      }

      // F2 — keep the shipment-disclosure block in sync with the current cart.
      this.updateShipmentDisclosure();
  }

  /* THR1VE supplement shipping model (AUTHORITATIVE rules, 2026-06-19). Keyed PER ORDER on whether
     a QUALIFYING FOOD ORDER exists = non-supplement subtotal (meals+snacks+drinks+bundles) ≥ $89.
     FREQUENCY-INDEPENDENT (One-Time vs Monthly does not change shipping). NEVER "2 parcels": a
     supplement EITHER rides inside the food order (ONE shipment) OR ships Australia Post ALONE.
       Case 1  supplements + qualifying SUBSCRIPTION food → FREE, ride WITH the order (one shipment)
       Case 2  supplements + qualifying ONE-TIME food     → meal zone shipping, ride WITH (one shipment)
       Case 3  supplements only / no qualifying food order → Australia Post, standalone (~$10) */
  supplementCartState(items = (this.cart && this.cart.items)) {
    const suppTypes = Array.isArray(window.THR1VE_SUPPLEMENT_TYPES) ? window.THR1VE_SUPPLEMENT_TYPES : [];
    const list = Array.isArray(items) ? items : [];
    const isSupp = (it) => !!it && suppTypes.length > 0 && suppTypes.includes(it.product_type);
    const hasSupplement = list.some(isSupp);
    const nonSuppSubtotalCents = list.reduce(
      (sum, it) => (it && !isSupp(it)) ? sum + (Number(it.price) || 0) * (parseInt(it.qty || it.quantity, 10) || 0) : sum, 0);
    const minOtp = typeof MIN_OTP_CART_AMOUNT !== "undefined" ? MIN_OTP_CART_AMOUNT : 89;
    const qualifyingFood = nonSuppSubtotalCents >= minOtp * 100;
    return { hasSupplement, nonSuppSubtotalCents, qualifyingFood };
  }

  // Shipment disclosure (AUTHORITATIVE supplement shipping rules — see supplementCartState).
  // ONE shipment always: supplements ride WITH a qualifying food order, or ship Australia Post
  // ALONE when there's no qualifying food order. The old "2 parcels / ships separately" mixed-cart
  // copy was WRONG (per-shipment model replaced split-fulfilment) and is removed.
  updateShipmentDisclosure() {
    const wrap = document.querySelector(".shipment-disclosure");
    if (!wrap) return;

    const { hasSupplement, qualifyingFood, nonSuppSubtotalCents } = this.supplementCartState();

    const single = wrap.querySelector(".shipment-single");
    const rideWith = wrap.querySelector(".shipment-ridewith");
    const suppsLine = wrap.querySelector(".shipment-supps");
    const show = (el) => el && el.classList.remove("d-none");
    const hide = (el) => el && el.classList.add("d-none");
    wrap.setAttribute("data-shipments", "1"); // never 2

    // Keyed on whether a MEAL ORDER EXISTS (food present), NOT the $89 threshold (Doc5 §line 322).
    const supplementOnly = hasSupplement && nonSuppSubtotalCents === 0;
    if (hasSupplement && !supplementOnly) {
      // Case 1 & 2 — food is present, so supplements ride WITH the order, ONE chilled delivery.
      hide(single); show(rideWith); hide(suppsLine);
    } else if (supplementOnly) {
      // Case 3 — supplements ONLY (no meal order) → standalone Australia Post.
      hide(single); hide(rideWith); show(suppsLine);
    } else {
      // Food only → single chilled shipment.
      show(single); hide(rideWith); hide(suppsLine);
    }

    // Doc5 §line 99–103: explain that supplements are EXCLUDED from the $89 — but only when it's
    // actually confusing: a supplement is in the cart AND food is still under $89 (so the total can
    // be large yet the cart still says "$X to go"). Hidden once food clears $89 (qualifyingFood).
    const hasFood = nonSuppSubtotalCents > 0;
    const minNote = document.querySelector(".supp-min-note");
    if (minNote) minNote.classList.toggle("d-none", !(hasSupplement && hasFood && !qualifyingFood));
  }

  getPromoForMeals(mealCount, total_price = 0.00) {
    let matchedPromo = false;
    let highestMin = -1;

    if (typeof promotionalOffers === "undefined") {
      return matchedPromo;
    }

    for (const [promoName, offer] of Object.entries(promotionalOffers)) {
      const { min, max } = offer.mealRange || {};

      const minMatched = typeof min === "number" && mealCount >= min;
      const maxMatched = max === null || typeof max === "undefined" || mealCount < max;

      if (minMatched && maxMatched && min > highestMin) {
        highestMin = min;
        matchedPromo = promoName;
      }
    }

    // If matched promo is promo0, return empty string
    if (matchedPromo === "promo0") {
      return false;
    }

    return matchedPromo;
  }

  createFormData(deliveryInfo, isSubscription) {
      //const deliveryDateISO = this.getSelectedDeliveryDateISO();
      const cartData = this.getCartData(),
          filteredCart = cartData.items.map(item => ({
              id: item.variant_id,
              properties: item.properties,
              quantity: item.quantity
          }));
      
      let { attributes = {}, items, total_price, item_count } = cartData;
      let order_type = attributes?.orderType?.type ?? "WeeklySubscription";   

      let applicableOffer = !1;
      if (!(userLoggedIn && customerData?.tags?.includes("NDIS") && typeof customerData.ndisDiscountPercentage == "number")) {
          const responseMeals = this.countLunchAndDinnerMeals(cartData.items);
          applicableOffer = this.getPromoForMeals(responseMeals);
          //console.log('responseMeals', responseMeals); 
          //console.log('applicableOffer1', applicableOffer);   
      }

      const formatTime = (timeStr) => {
        return timeStr && timeStr.length === 5 ? `${timeStr}:00` : timeStr;
      };

      //console.log('applicableOffer', applicableOffer);  
      //console.log('order_type', order_type);  

      const {
          deliveryDate,
          deliveryEnd,
          deliveryStart,
          packingDate
      } = JSON.parse(deliveryInfo || "{}"), deliveryAttributes = {
          DeliveryDate: deliveryDate || "",
          PackingDate: packingDate || "",
          DeliveryStart: formatTime(deliveryStart) || "",
          DeliveryEnd: formatTime(deliveryEnd) || "",
          AddressType: "residential",
          promotional: false, //((order_type === "WeeklySubscription") || (order_type === "FortnightlySubscription")) ? applicableOffer : false,
          orderType: isSubscription.type
      };
      return {
          items: filteredCart,
          attributes: deliveryAttributes
      }
  }

  applicableDiscount(cartData, orderTypeN) {

    const { attributes = {}, total_price, items, original_total_price } = cartData;
    
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
      orderTypeN = "OneTimePurchase";
    }else{
      orderTypeN = state.freq ? state.freq : (attributes?.orderType?.type || "WeeklySubscription");
    }
    console.log('orderTypeN',orderTypeN);
    if (orderTypeN === "OneTimePurchase") {
      //alert(11);
      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          //alert(12);
          return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else{
          // MEAL TIER PRICING IS NOT A DISCOUNT CODE (Saahil 2026-06-30). The per-meal tier
          // (10/$12.95 · 14/$12.50 · 18/$10.95 · 25/$9.95) is PLAN pricing applied by the
          // cart-transform Function (B4), NOT via SAVE10/SAVE15 codes. Returning null here so no
          // tier code is appended to checkout — the Function sets the tier base price, and real
          // discount codes (first-order ladder / FIRST10) flow separately to the B5 engine.
          return null;
      }
    } else if (orderTypeN === "WeeklySubscription" || orderTypeN === "FortnightlySubscription") {
      //alert(12);
      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          //alert(0);
          return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(1);
          return null;
      } else {
        // MEAL TIER PRICING IS NOT A DISCOUNT CODE (Saahil 2026-06-30). Subscription per-meal tier
        // pricing is PLAN pricing applied by the cart-transform Function (B4), NOT promotionalOffers
        // SAVE10/SAVE15 codes. Return null so no tier code is appended — the Function re-resolves the
        // tier on every cart change and competes better-of with any real code in the B5 engine.
        return null;
      }
    }
    return null;
  }

  updateCartAttrFromLocal(attributes){
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    })
    .then(res => res.json())
    .then(data => {
      //console.log('Cart attributes updated:', data);
    })
    .catch(err => {
      console.error('Error updating cart attributes:', err);
    });
  }
  

  // BOX-FILL GATE message (Saahil + updated Claude Design): non-empty when a FIXED box (numeric
  // thr1ve_box_target) isn't filled yet. Flexible / Build-Your-Own (no target) is exempt. Shared by
  // proceedToCheckout() AND the Cart Confirmation Continue button (T-0145 L1) — the confirmation can
  // change the box target (25 <-> 18) after the drawer's own gate has already passed.
  boxFillMessage() {
    try {
      const _box = Number(localStorage.getItem("thr1ve_box_target")) || 0;
      if (_box > 0) {
        const _meals = this.countLunchAndDinnerMeals();
        if (_meals < _box) {
          const _remain = _box - _meals;
          return `Add ${_remain} more meal${_remain === 1 ? "" : "s"} to complete your ${_box}-meal box before checkout.`;
        }
      }
    } catch (e) {}
    return "";
  }

  proceedToCheckout(requestPath) {

    // BOX-FILL GATE — see boxFillMessage().
    {
      const _fillMsg = this.boxFillMessage();
      if (_fillMsg) {
        const _msg = document.querySelector(".show_error_checkout");
        if (_msg) _msg.textContent = _fillMsg;
        return;
      }
    }

    let threeHours = 4 * 60 * 60 * 1000;
    let loca_del_n = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    let window_state_NEW = JSON.parse(localStorage.getItem("window_state") || "{}");
    if (loca_del_n.timestamp && (Date.now() - loca_del_n.timestamp > threeHours)) {
      console.log("🕒 Delivery selection expired (3 hours). Clearing.");
      localStorage.setItem("deliveryInfo", JSON.stringify({}));
      loca_del_n = {};
      if (typeof state !== 'undefined') {      
        state.date = "";
        state.time = "";
        state.state = "";
        state.suburb = "";
        state.postcode = "";
        window_state_NEW = state;
        localStorage.setItem("window_state", JSON.stringify(window_state_NEW));
      }
    }

    const stateData = JSON.parse(localStorage.getItem("window_state") || "{}");
    const cartAttrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
    const orderType = stateData.freq || cartAttrs?.orderType?.type || "WeeklySubscription";
    /*if (!this.hasDeliveryAndAddressFilled(orderType)) {
      this.openMiniCartToDeliveryStep("Please enter your delivery address to continue.");
      return;
    }*/

    // ROLLBACK (window.THR1VE_CART_CONFIRMATION === false, set in snippets/mini-cart.liquid): the
    // original ADDRESS CHECK path — a pre-checked / saved address (thr1ve_address_validated) skips
    // straight through, otherwise the in-drawer delivery step (snippets/address-check-flow.liquid).
    if (!this.cartConfirmationOn()) {
      try {
        if (localStorage.getItem("thr1ve_address_validated") !== "1") {
          this.openAddressCheckInDrawer();
          return;
        }
      } catch (e) {}
      this.continueToShipping(requestPath);
      return;
    }

    // T-0145: the pre-checkout delivery step (address + date + time window) is GONE. The drawer's
    // Checkout button now opens the Cart Confirmation step (snippets/cart-confirmation.liquid) where
    // the customer reviews the order, confirms Subscription / One-time + frequency and sees live
    // pricing; its Continue button calls continueToShipping() -> /checkout, where the address and the
    // delivery date + time are chosen (checkout UI extension `delivery-details-checkout`).
    // The gates above passed, so any older message left in the drawer's own error slots is stale —
    // clear it so the confirmation (which mirrors those slots) doesn't open with a leftover error.
    try {
      const _e1 = document.querySelector(".show_error_checkout"); if (_e1) { _e1.textContent = ""; }
      const _e2 = document.getElementById("min-response"); if (_e2) { _e2.textContent = ""; }
    } catch (e) {}
    this.openCartConfirmation();
  }

  // T-0145 rollback switch. Cart Confirmation is ON unless the page sets window.THR1VE_CART_CONFIRMATION
  // to exactly false (one line in snippets/mini-cart.liquid) — which restores the original pre-checkout
  // delivery step (#acheck-drawer: address + date + time window) end to end.
  cartConfirmationOn() { return window.THR1VE_CART_CONFIRMATION !== false; }

  // Open an in-drawer step (#cart-confirmation = Cart Confirmation, or #acheck-drawer = the legacy
  // delivery step when rolled back): ensure the drawer is open, hide the cart body, reveal the step.
  _openDrawerStep(rootId, openHook) {
    const reveal = () => {
      const ns = document.querySelector(".nonStickyBOttom");
      if (ns) Array.from(ns.children).forEach((ch) => { if (ch.id !== rootId) ch.classList.add("acheck-hidden"); });
      document.getElementById("border-topbg-white")?.classList.add("acheck-hidden");
      // The plan strip + cart header live ABOVE #cart-confirmation in the SAME scroll body. Hide them
      // too so the confirmation sits at the TOP of a clean body. Previously (when this hosted the
      // delivery form) they stayed visible and scrollIntoView() scrolled the (now-scrollable) body,
      // dragging the plan strip up and leaving the body scrolled when you went back. The step has its
      // own appbar/back, so no nav is lost. Reset the scroll to 0 instead of scrollIntoView.
      document.querySelector("#mini-cart .cart-plan-strip")?.classList.add("acheck-hidden");
      document.querySelector("#mini-cart .cartHead")?.classList.add("acheck-hidden");
      const ff = document.getElementById("finalflow"); if (ff) ff.style.display = "none";
      window.__thr1veInFinalFlow = true;
      if (typeof window[openHook] === "function") window[openHook]();
      const _body = document.querySelector("#mini-cart .main-cart-container > .flex-grow-1");
      if (_body) _body.scrollTop = 0;
    };
    const shown = document.querySelector("#mini-cart.show, .mini-cart.show");
    if (!shown) { document.querySelector(".cart-count")?.click(); setTimeout(reveal, 350); }
    else reveal();
  }
  _closeDrawerSteps() {
    document.querySelectorAll(".acheck-hidden").forEach((el) => el.classList.remove("acheck-hidden"));
    ["cart-confirmation", "acheck-drawer"].forEach((id) => { const dr = document.getElementById(id); if (dr) dr.style.display = "none"; });
    if (typeof window.thr1veCloseCartConfirmation === "function") window.thr1veCloseCartConfirmation();
    // Reset the scroll so the cart returns to the TOP (a step had scrolled the body; it used to stay
    // scrolled, so the whole cart looked shifted up on the way back).
    const _body = document.querySelector("#mini-cart .main-cart-container > .flex-grow-1");
    if (_body) _body.scrollTop = 0;
    window.__thr1veInFinalFlow = false;
  }

  // Open the in-drawer Cart Confirmation (snippets/cart-confirmation.liquid).
  openCartConfirmation() {
    // Empty cart: never open the step (spec §2) — the drawer's own empty state stays up.
    if (!(this.cart && Array.isArray(this.cart.items) && this.cart.items.length > 0)) return;
    return this._openDrawerStep("cart-confirmation", "thr1veOpenCartConfirmation");
  }
  // Legacy name (older call sites + cached snippets still use it): the delivery step it used to open
  // is gone, so it opens Cart Confirmation — unless rolled back, when it opens the original step.
  openAddressCheckInDrawer() {
    if (this.cartConfirmationOn()) return this.openCartConfirmation();
    return this._openDrawerStep("acheck-drawer", "thr1veOpenAddressCheck");
  }
  closeCartConfirmation() { return this._closeDrawerSteps(); }
  closeAddressCheckInDrawer() { return this._closeDrawerSteps(); }

  async checkVariantAvailability(variantId) {
    try {
      const res = await fetch('/variants/' + variantId + '.js');

      if (!res.ok) {
        console.warn("❌ Variant not found:", variantId);
        return false;
      }

      const data = await res.json();

      console.log("🔍 Variant:", data.name);
      //console.log("Available:", data.available);
      //console.log("Inventory:", data.inventory_quantity);
      return data.available === true;

    } catch (err) {
      console.error("❌ Fetch error for variant:", variantId, err);
      return false;
    }
  }

  checkUnavailableCount() {
    const errorBox = document.querySelector(".show_error_checkout");

    // count remaining invalid items
    const remaining = document.querySelectorAll(".cart-item.have-variant-error").length;

    console.log("Remaining invalid items:", remaining);

    if (remaining === 0) {
      if (errorBox) {
        errorBox.style.display = "none";
        errorBox.innerHTML = "";
      }

      console.log("✅ All invalid items cleared → hide error box");
    }
  }
  
  async checkAllVariantsOnLoad(force = false) {
    const cartData = this.getCartData();
    const errorBox = document.querySelector(".show_error_checkout");

    // ✅ API Check: Only once a day
    const lastCheckDate = localStorage.getItem("last_availability_check");
    const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    if (!force && lastCheckDate === today) {
      console.log("✅ Availability check already performed today.");
      return true;
    }

    if (errorBox) errorBox.innerHTML = "";

    const uniqueItems = [];
    const seen = new Set();

    cartData.items.forEach(item => {
      if (!seen.has(item.variant_id)) {
        seen.add(item.variant_id);
        uniqueItems.push({
          id: item.variant_id,
          name: item.title
        });
      }
    });

    if (uniqueItems.length === 0) {
       localStorage.setItem("last_availability_check", today);
       return true;
    }

    // Run availability checks CONCURRENTLY. This was a sequential await-in-loop,
    // which made the checkout button wait on N back-to-back /variants/{id}.js
    // requests (≈ N × latency). Promise.all preserves array order, so the
    // downstream results/unavailable logic is unchanged.
    const results = await Promise.all(
      uniqueItems.map(async (item) => ({
        ...item,
        available: await this.checkVariantAvailability(item.id),
      }))
    );

    const unavailable = results.filter(r => !r.available);

    if (unavailable.length > 0) {
      // ✅ Automatically remove unavailable items from local cart
      let itemsRemoved = false;
      const removedNames = [];

      unavailable.forEach(u => {
        const initialLength = this.cart.items.length;
        // Remove ALL instances of this variant
        this.cart.items = this.cart.items.filter(item => item.variant_id !== u.id);
        
        if (this.cart.items.length < initialLength) {
          removedNames.push(u.name);
          itemsRemoved = true;
        }
      });

      if (itemsRemoved) {
        this._saveCart();
        // Mark as checked today so it doesn't re-trigger on the refresh call
        localStorage.setItem("last_availability_check", today);
        
        // Update the cart UI
        this.updateCartInfoFromLocal(".cart-item-loop");
      }

      if (errorBox && removedNames.length > 0) {
        errorBox.innerHTML = `
          <div class="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-2" role="alert">
            <div class="fs-5 text-danger">
              <i class="fa-solid fa-triangle-exclamation"></i>
            </div>
            <div class="flex-grow-1">
              <div class="small">
                The following items were removed because they are currently unavailable: <strong>${removedNames.join(", ")}</strong>.
              </div>
            </div>
          </div>
        `;

        errorBox.scrollIntoView({ behavior: "smooth", block: "center" });

        // ✅ Fade out after 15 seconds
        setTimeout(() => {
          jQuery(errorBox).fadeOut(1000, function() {
            jQuery(this).empty().show();
          });
        }, 15000);
      }

      console.warn("❌ Unavailable items removed:", unavailable);
      return false;
    }

    // ✅ Mark as checked today
    localStorage.setItem("last_availability_check", today);
    return true;
  }

  goToStep(step, message = "") {
    // #finalflow is RETIRED. The Address Check page (Claude Design) collects the delivery address +
    // schedule (date/time), and the plan/freq is set at the bundle picker. Resolve anything still
    // missing and route to the Address Check — NEVER show the old #finalflow UI.
    try {
      // Plan/freq — normally set by the picker; fall back to the cart order type, then Weekly.
      const _ws = JSON.parse(localStorage.getItem("window_state") || "{}");
      if (!_ws.freq) {
        const _ca = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
        _ws.freq = (_ca && _ca.orderType && _ca.orderType.type) || "WeeklySubscription";
        localStorage.setItem("window_state", JSON.stringify(_ws));
      }
      // Shipping — subscriptions are free; the OTP zone rate is computed at native checkout. Ensure
      // a truthy value so the checkout validation never blocks on it. (Handles "" and "null".)
      const _sh = localStorage.getItem("shipping_amount");
      if (!_sh || _sh === "" || _sh === "null") localStorage.setItem("shipping_amount", "0");

      if (this.cartConfirmationOn()) {
        // T-0145: address + delivery date/time are chosen at CHECKOUT now, so only a missing plan/freq
        // can still send the customer back. Cart Confirmation shows the Weekly/Fortnightly/One-time
        // choice with the cart's own default pressed (and persists it on Continue) — open it instead
        // of looping into checkout.
        if (!_ws.freq) {
          this.openCartConfirmation();
          return;
        }
      } else {
        // Rollback (window.THR1VE_CART_CONFIRMATION === false): the original pre-checkout delivery gate.
        const _di = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
        const _deliveryOk = !!(_di.deliveryDate && _di.deliveryStart && _di.deliveryEnd);
        const _validated = localStorage.getItem("thr1ve_address_validated") === "1";
        if (!_validated || !_deliveryOk) {
          if (!_deliveryOk) { try { localStorage.removeItem("thr1ve_address_validated"); } catch (e) {} }
          this.openAddressCheckInDrawer();
          return;
        }
      }

      // Plan + shipping set → continue straight to checkout (no finalflow).
      if (!this._checkoutResolving) {
        this._checkoutResolving = true;
        setTimeout(() => { this._checkoutResolving = false; }, 4000);
        this.continueToShipping("mini-cart");
      }
      return;
    } catch (e) { return; }

    try {
      // open mini cart first
      document.querySelector(".cart-count")?.click();
      setDisplaySafe("#re-order", "none");
      setDisplaySafe(".discount-card-minicart", "none");

      setTimeout(() => {
        const flow = document.getElementById("finalflow");
        // Cart-drawer redesign: this is an explicit "advance to checkout step" action
        // (validateBeforeCheckout failed → collect delivery). Set the sticky flag so the
        // cart re-renders that follow keep #finalflow shown instead of snapping back to the
        // meal-list default. (Runs after the .cart-count click above, which clears it.)
        window.__thr1veInFinalFlow = true;
        if (flow) flow.style.display = "block";

        // hide other sections (same as your code)
        ["border-topbg-white", "cart-item-wrap", "cart-item-title"].forEach(id => {
          const el = document.getElementById(id);
          if (el) el.style.display = "none";
        });

        // update step
        if (window.state) {
          window.state.step = step;
        }

        if (typeof show === "function") {
          show(`#step${step}`);
        }

        // scroll
        flow?.scrollIntoView({ behavior: "smooth", block: "start" });

        // show error
        if (message) {
          console.warn("⚠️ Step Redirect:", message);

          if (step === 2) {
            const el = document.getElementById("address_12Text");
            const el_address_12 = document.getElementById("address_12");
            const el12 = document.getElementById("address_text_12");
            if (el) {
              el.textContent = message;
              el.style.display = "block";
              el.classList.add("error");

              // ✅ Fade out after 15 seconds
              setTimeout(() => {
                jQuery(el).fadeOut(1000, function() {
                  jQuery(this).empty().hide().removeClass("error");
                });
              }, 15000);
            }
            if (el12) {
              el12.style.display = "none";
            }
            if (el_address_12) {
              el_address_12.value = "";
            }
          }
        }

      }, 100);

    } catch (err) {
      console.error("Step navigation error:", err);
    }
  }
  
  validateBeforeCheckout() {

      let state = {};
      try { state = JSON.parse(localStorage.getItem("window_state") || "{}"); } catch (e) { state = {}; }
      let delivery = {};
      try { delivery = JSON.parse(localStorage.getItem("deliveryInfo") || "{}"); } catch (e) { delivery = {}; }
      const cartData = this.getCartData();

      /* -------------------------
      STEP 3 FIRST (HIGH PRIORITY)
      ------------------------- */

      // ❌ Frequency missing
      if (!state.freq) {
        return {
          valid: false,
          step: 3,
          message: "Please select subscription type"
        };
      }

      // ❌ Shipping missing
      const shipping = localStorage.getItem("shipping_amount");
      if (!shipping || shipping === "" || shipping === "null") {

        return {
          valid: false,
          step: 3,
          message: "Shipping not calculated"
        };
      }

      /* T-0145: STEP 2 (delivery date + address) is no longer a pre-checkout requirement. The delivery
         address and the delivery date/time are chosen AT CHECKOUT (checkout UI extension
         delivery-details-checkout), whose buyerJourney.intercept refuses to complete without a valid
         DeliveryDate. Only the order type + shipping default are validated here — unless the rollback
         flag (window.THR1VE_CART_CONFIRMATION === false) restores the original pre-checkout step. */

      /* T-0149 (owner, #193): the Renewed Order Flow page goes DIRECT to checkout after "Review your
         box". Address + delivery date/time are chosen at checkout, so this pre-checkout requirement is
         skipped ONLY while that page holds window.THR1VE_DIRECT_CHECKOUT === true (set for the single
         hand-off call, then cleared). Every other caller is unchanged. Plan + shipping above still apply. */
      if (window.THR1VE_DIRECT_CHECKOUT === true) return { valid: true };

      if (!this.cartConfirmationOn()) {
        const _msg2 = "Please enter delivery address after then select delivery date and time slot.";
        if (!delivery.deliveryDate || !delivery.deliveryStart || !delivery.deliveryEnd) return { valid: false, step: 2, message: _msg2 };
        if (!state.address || !state.suburb || !state.state || !state.postcode) return { valid: false, step: 2, message: _msg2 };
      }

      return { valid: true };
    }

  async continueToShipping(requestPath) { 
    
    //document.getElementById("loading-screen").style.display = "block";
    const button = document.getElementById("continue_to_shipping");
    button?.classList.add("loading");

    const validation = await this.validateBeforeCheckout();

    if (!validation.valid) {

      console.log("❌ Validation:", validation);

      this.goToStep(validation.step, validation.message);

      return;
    }

    /* 🔥 CALL HERE */
    const isValidVariants = await this.checkAllVariantsOnLoad(true);

    if (!isValidVariants) {
      button?.classList.remove("loading");
      //document.getElementById("loading-screen").style.display = "block";
      return; // ⛔ STOP checkout
    }

    // ── Doc5 §2b duplicate-subscription GUARD (F-sub-guard, Phase-1 minimal cut) ──
    // A logged-in customer who ALREADY has an active subscription must never be able to
    // create a SECOND one via the create-order → native-checkout (selling_plan) path.
    // We only guard the recurring (subscription) order type — one-time orders are fine.
    {
      let guardState = {};
      try { guardState = JSON.parse(localStorage.getItem("window_state") || "{}"); } catch (e) { guardState = {}; }
      const guardCart = this.getCartData() || {};
      const guardIsKeto = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
      // Derive the guard's order type the SAME way the create-order path decides
      // whether it will actually create a recurring subscription. The authoritative
      // value the create path consumes is the cart attribute `attributes.orderType.type`
      // (read directly in `createFormData()` — `let order_type = attributes?.orderType?.type ?? "WeeklySubscription"`).
      // The previous guard preferred `window_state.freq`, which can go STALE (e.g. left
      // on "WeeklySubscription" from an earlier session while the cart attribute is now
      // "OneTimePurchase"). That over-blocked genuine one-time orders. Prioritise the cart
      // attribute and only fall back to `freq` when the cart attribute is ABSENT, so the
      // guard runs on a recurring order EXACTLY when the create path would create a
      // recurring subscription — and never on a real one-time order.
      // Classify order-type IDENTICALLY to the create path (createFormData: `order_type =
      // attributes?.orderType?.type ?? "WeeklySubscription"`) so the guard and create path can
      // never disagree. A MISSING cart attribute defaults to WeeklySubscription (guard fires/blocks),
      // matching how the create path builds a subscription — closes the stale-state.freq fail-open.
      const guardOrderType = guardIsKeto
        ? "OneTimePurchase"
        : (guardCart.attributes?.orderType?.type ?? "WeeklySubscription");

      if (userLoggedIn && (guardOrderType === "WeeklySubscription" || guardOrderType === "FortnightlySubscription")) {
        const activeContractId = await this.findActiveContractIdForGuard();
        if (activeContractId) {
          document.getElementById("loading-screen") && (document.getElementById("loading-screen").style.display = "none");
          button?.classList.remove("loading");

          if (activeContractId === "__GUARD_LOOKUP_FAILED__") {
            // Fail safe: we could not confirm there is no existing subscription.
            return this._showMinResponse(
              "We couldn't verify your subscription status just now. Please refresh and try again, or contact support.",
              button
            );
          }

          // Real active subscriber: route the changes onto their EXISTING box instead of
          // creating a duplicate. updateSubscriptionLocal() syncs the cart to the existing
          // contract and opens the subscription-update flow (it never creates a new contract).
          this._showMinResponse(
            "You already have an active subscription — these changes will be applied to your existing box, not a new subscription.",
            button
          );
          return this.updateSubscriptionLocal();
        }
      }
    }
    // ── end guard ──

    try {
      // STEP 1: Clear Shopify cart first
      fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
      
    .then(res => res.json())
    .then(data => {
        
        document.getElementById("loading-screen").style.display = "block";    
        const cartData = this.getCartData(); 
        let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
        const { attributes, total_price, original_total_price } = cartData;
        const isNDIS = userLoggedIn && customerData?.tags?.includes("NDIS") && typeof customerData?.ndisDiscountPercentage === "number";
        const isKeto = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
        const T1 = userLoggedIn && customerData?.tags?.includes("T1") && typeof customerData?.ketoCustDiscountFixed === "number";
        const T2 = userLoggedIn && customerData?.tags?.includes("T2") && typeof customerData?.ketoCustDiscountFixed === "number";
        const T3 = userLoggedIn && customerData?.tags?.includes("T3") && typeof customerData?.ketoCustDiscountFixed === "number";
        //const conditn = userLoggedIn && customerData?.tags?.includes("conditn") && typeof customerData?.ketoCustDiscountFixed === "number";
        const bluefit = this.isBluefit;
        // BlueFit/conditn/special_pricing are one-time only (see selectedFrequency guard below) — force
        // OneTimePurchase here too so discount/subscription-guard logic never treats them as a sub.
        const orderType = (isKeto || bluefit) ? "OneTimePurchase" : (state_data.freq ? state_data.freq : (attributes?.orderType?.type || "WeeklySubscription"));
        let discountCode = '';
        if(!bluefit){
          discountCode = this.applicableDiscount(cartData, orderType);
        }
        // A promo code entered in the cart drawer is stored (not applied via Shopify's destructive
        // /discount path) — carry it to checkout here so the B5 Function applies the better-of rule.
        try { var _manualCode = localStorage.getItem("thr1ve_manual_discount"); if (_manualCode && !bluefit) discountCode = _manualCode; } catch (e) {}

        const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
        // Supplements-only carts have no meal-style selector — guard so .value can't throw
        // (an unhandled throw here silently aborts checkout before /cart/add.js).
        const mealStyle = selectedMeal ? selectedMeal.value : "";

        const sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
        const {
          promoOffer = "",
          contractId = "",
          orderNo = 0,
        } = JSON.parse(subscriptionContractId || "{}");        

        let newContractId = contractId;

        if(!newContractId){
          // Was `state.email` (often undefined here) which silently failed and left
          // subscribers un-detected — use the freshly-parsed window_state / customer email.
          newContractId = this.getContractIdFromCache(sdata_new.email || customerData?.email);
        }

        //const frequencySelect = document.getElementById("order-frequency");
        let selectedFrequency = state_data?.freq || (frequencySelect?.value || "OneTimePurchase");
        // BlueFit / conditn / special_pricing are ONE-TIME ONLY. Their flat $9.95 comes from the
        // cart-transform Function, which CANNOT reprice subscription (selling-plan) lines — so if such
        // a customer ever reached checkout with a stale subscription freq, a selling plan would attach
        // and they'd silently lose the $9.95. Force one-time here so the segment price always holds
        // (same hard guard keto already gets via orderType).
        if (this.isBluefit === true) selectedFrequency = "OneTimePurchase";
        // Supplements are ONE-TIME (no selling plan). A supplements-only order MUST check out as
        // OneTimePurchase, else a subscription selling_plan is attached to a supplement that can't
        // take one and /cart/add.js silently fails (checkout never completes).
        {
          const _ssFreq = this.supplementCartState(this.cart && this.cart.items);
          if (_ssFreq.hasSupplement && _ssFreq.nonSuppSubtotalCents === 0) selectedFrequency = "OneTimePurchase";
        }

        //this.applicableDiscount(cartData, orderType);
        //return false; 

        const deliveryInfo = localStorage.getItem("deliveryInfo");
  
        // Create form data from localCart
        var formData = localCart.createFormData(deliveryInfo, {
          selling: !isKeto,
          type: isKeto ? "OneTimePurchase" : selectedFrequency
        });
  
        const cartItems = formData.items;
        // B4 tier pricing for subscriptions: meals get the meal-count TIER plan (its PRICE policy
        // bills the Doc5 tier at checkout); non-meal lines (supplements) keep the BASE plan so the
        // tier price can never land on a supplement. formData.items only carry {id}, so match meals
        // by variant_id against the live cart.
        const _subFreq = (selectedFrequency === "WeeklySubscription" || selectedFrequency === "FortnightlySubscription");
        const _mealsForTier = this.countLunchAndDinnerMeals(localCart.getCartData().items);
        const _mealVariantIds = new Set((localCart.getCartData().items || [])
          .filter(it => it && it.product_type === "LUNCH & DINNER").map(it => it.variant_id));
        // --- Better-of discount, checkout side (Doc5 §4 "greater of code vs tier; no stacking") ---
        // The cart drawer stores `thr1ve_manual_discount` + validated `_meta` ONLY when the code BEATS
        // the tier. For a ONE-TIME cart the unified cart-transform Function computes better-of per meal
        // line FROM these cart attributes and applies the winner — so we feed it the code here and do
        // NOT also carry the native &discount= (that would double-apply: Function price + native code).
        // SUBSCRIPTION carts are unchanged here (the Function can't reprice selling-plan lines); their
        // better-of is applied by the subscription app as a first-order discount (separate change).
        let _discMeta = null;
        try { _discMeta = JSON.parse(localStorage.getItem("thr1ve_manual_discount_meta") || "null"); } catch (e) {}
        const _isOneTimeCart = !_subFreq;
        // Only a MANUAL code (typed into the drawer, which overrides discountCode above) participates in
        // the better-of swap; the auto first-order ladder/promo from applicableDiscount keeps its
        // existing behaviour. A code is "validated" only when it's a manual code AND the drawer stored a
        // FINITE, positive value BOUND to this exact code (meta.code === discountCode). Gating on
        // _isManualCode means a stale meta that happens to match the LADDER code can never feed the
        // Function or swap a subscription's meal lines to the base plan (Codex L2 re-review). Unvalidated
        // codes are never fed to the Function and never swap the sub meal plan.
        const _isManualCode = !!(_manualCode && !bluefit);
        const _hasValidatedCode = !!(
          _isManualCode && _discMeta &&
          Number.isFinite(_discMeta.offCents) && _discMeta.offCents > 0 &&
          String(_discMeta.code || "").toUpperCase() === String(discountCode).toUpperCase()
        );
        // Always defined so we CLEAR any stale attributes from a prior code on every checkout.
        const _discountAttrs = {
          "_thr1ve_discount_code": "", "_thr1ve_discount_kind": "",
          "_thr1ve_discount_amount": "", "_thr1ve_discount_percent": ""
        };
        if (_hasValidatedCode && _isOneTimeCart) {
          const _units = Math.max(1, _mealsForTier || 0);
          _discountAttrs["_thr1ve_discount_code"] = String(discountCode);
          if (_discMeta.isFixed) {
            // The Function reads `_thr1ve_discount_amount` as PER-MEAL $ off (evaluateLine subtracts it
            // per unit), so split the whole-order $ off across the meal units. FLOOR to whole cents so
            // the per-meal × units total can never EXCEED the code's value (business-safe; a fixed $ that
            // doesn't divide evenly by the meal count under-discounts by ≤(units−1) cents, never over).
            _discountAttrs["_thr1ve_discount_kind"] = "fixed";
            _discountAttrs["_thr1ve_discount_amount"] = (Math.floor(_discMeta.offCents / _units) / 100).toFixed(2);
          } else {
            // Percent code: % off base, derived from the validated allocation vs subtotal.
            const _pct = (_discMeta.subCents > 0) ? (_discMeta.offCents / _discMeta.subCents) * 100 : 0;
            _discountAttrs["_thr1ve_discount_kind"] = "percent";
            _discountAttrs["_thr1ve_discount_percent"] = Math.max(0, Math.min(100, _pct)).toFixed(4);
          }
        }
        const _tierPlan = _subFreq ? this.sellingPlanForTier(selectedFrequency, _mealsForTier) : null;
        const _basePlan = selectedFrequency === "FortnightlySubscription" ? SELLING_PLAN_FS : SELLING_PLAN_S;
        // Option X (subscription better-of, Doc5 §4): when a validated code BEATS the tier, put the
        // sub's MEAL lines on the BASE plan so the FIRST-ORDER-ONLY promo code applies OFF BASE at
        // checkout — order 1 = base − code = better-of, not stacked on the tier. The subscription app
        // re-resolves the TIER onto the contract on CONTRACTS_CREATE, so every RECURRING charge bills
        // the tier (never base). REQUIRES the promo code to be configured first-order-only in Shopify.
        // When the tier wins, the drawer never stores the code (_hasValidatedCode false) → meal lines
        // stay on the tier plan (unchanged). Only manual validated codes swap; the auto ladder/promo
        // path is untouched.
        const _subMealPlan = (_subFreq && _hasValidatedCode) ? _basePlan : _tierPlan;
        const items = cartItems.map(item => {
          const cartItem = item;
          if (_subFreq) {
            cartItem.selling_plan = _mealVariantIds.has(cartItem.id) ? _subMealPlan : _basePlan;
          }

          // REMOVED (T-0118, owner decision): do NOT stamp DeliveryDate onto per-line properties.
          // Delivery date is cart-level only — createFormData() already sends it as formData.attributes
          // (DeliveryDate/PackingDate/DeliveryStart/DeliveryEnd), which is what the checkout extensions,
          // subscription-svc billing, and aws-sls all read. T-0060 previously restored this same write
          // because its removal was unverifiable at the time (see git blame); the owner has since
          // confirmed products should carry product info only — do not re-add this without a new
          // explicit owner decision.
          return cartItem;
        });

        //console.log(items); return;   

        //var all_attributes = formData.attributes;
        
        const mealsCount = this.countLunchAndDinnerMeals(localCart.getCartData().items);     
        // console.log({formData});
        // return false;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(async (data) => {
            // Persist the better-of discount to the CART (the cart-transform Function reads cart-level
            // attributes at checkout). Awaited so the attributes are on the cart before we navigate to
            // /checkout; the 2.5s timeout race guarantees a slow/hung request can never block checkout,
            // and any failure is swallowed so checkout always proceeds.
            // Write (or CLEAR) the discount cart attributes; retry briefly so a transient failure does
            // not leave STALE _thr1ve_discount_* attributes from a prior checkout on the cart (the
            // Function would otherwise re-apply an old discount — Codex L2). Each attempt is bounded so
            // checkout can never hang; the drawer also clears these proactively on code removal.
            for (var _daTry = 0; _daTry < 2; _daTry++) {
              var _daOk = false;
              try {
                _daOk = await Promise.race([
                  fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ attributes: _discountAttrs })
                  }).then(function (r) { return !!(r && r.ok); }).catch(function () { return false; }),
                  new Promise(function (r) { setTimeout(function () { r(false); }, 1800); })
                ]);
              } catch (e) { _daOk = false; }
              if (_daOk) break;
            }
            // NEW-CHECKOUT PREFILL: push the saved delivery address onto THIS cart's buyerIdentity
            // so the /checkout redirect below prefills the shipping address (the legacy
            // checkout[shipping_address][...] URL params are ignored by Shopify's one-page checkout).
            // Awaited but time-boxed inside so it can never block checkout (see pushDeliveryAddressToCart).
            await this.pushDeliveryAddressToCart();
            // STEP 4: Build redirect URL
            const addressParams = this.validatedAddress();
            const queryString = Object.entries(addressParams)
              .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
              .join("&");
            const checkoutUrl = `${shopUrl}/checkout?${queryString}`;
            // Native &discount= is carried ONLY when it cannot stack with the tier/Function:
            //  - a NON-manual code (the auto first-order ladder/promo from applicableDiscount) — existing
            //    behaviour, unchanged;
            //  - a VALIDATED code on a SUBSCRIPTION cart — meal lines are on the BASE plan, so it applies
            //    off base (= better-of).
            // A validated ONE-TIME code is applied by the Function via the cart attributes (no native).
            // An UNVALIDATED manual code (Storefront validation failed → no bound meta) is NOT carried:
            // natively it would STACK on the tier (sub) or on the Function's tier (one-time). It simply
            // doesn't apply this attempt; the customer re-applies once validation succeeds (Codex L2).
            // _isManualCode is computed once in the checkout scope above (closure).
            let _carryNative;
            if (!_isManualCode) _carryNative = !!discountCode;             // auto ladder/promo, unchanged
            else if (_hasValidatedCode && _subFreq) _carryNative = true;   // validated sub → off BASE plan
            else _carryNative = false;                                     // one-time validated (Function) OR any unvalidated manual code
            let redirectUrl = _carryNative ? `${checkoutUrl}&discount=${discountCode}` : checkoutUrl;

            //console.log(all_attributes); return;
            //this.updateCartAttrFromLocal(all_attributes);
          
            console.log('discountCode==',discountCode);
            //alert(discountCode);
            //console.log(orderType);
          
            // AUTHORITATIVE supplement rule (Case 3): a SUPPLEMENTS-ONLY order (no qualifying food —
            // non-supplement subtotal $0) is valid and is NOT subject to the meal-count / $89 FOOD
            // minimum (supplements are excluded from the $89). Skip the food gates → checkout.
            const _suppState = this.supplementCartState(this.cart && this.cart.items);
            if (_suppState.hasSupplement && _suppState.nonSuppSubtotalCents === 0) {
              window.location.href = redirectUrl;
              return;
            }

            // STEP 5: Apply cart validation
            if (orderType === "OneTimePurchase") {
              // const minOtpMeals = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
              // if (mealsCount < minOtpMeals) {
              //   document.getElementById("loading-screen").style.display = "none";
              //   return this._showMinResponse(`Min Order. ${minOtpMeals} meals`, button);
              // }
              if(isKeto || isNDIS || T1 || T2 || T3){
                //isNDIS users                             
                let acctual_total_price = original_total_price - ((original_total_price / 100) * customerData.ndisDiscountPercentage);
                acctual_total_price = acctual_total_price.toFixed(2);
                if (isNDIS && (acctual_total_price < MIN_NDIS_OTP_CART_AMOUNT)) { 
                  // console.log(`You need minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`);
                  document.getElementById("loading-screen").style.display = "none";
                  return this._showMinResponse(`Minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`, button);
                }  
                //isKeto users
                acctual_total_price = original_total_price - ((original_total_price / 100) * customerData.ketoCustDiscountFixed);
                acctual_total_price = acctual_total_price.toFixed(2);
                if (isKeto &&  (acctual_total_price < MIN_OTP_CART_AMOUNT)) {
                  
                  // console.log(`You need minimum $${MIN_OTP_CART_AMOUNT} to checkout`);
                  document.getElementById("loading-screen").style.display = "none";
                  return this._showMinResponse(`Minimum $${MIN_OTP_CART_AMOUNT} to checkout`, button);
                }
              }

              //Normal User — $89 minimum is on the NON-SUPPLEMENT (food) subtotal; supplements are
              // excluded (AUTHORITATIVE rule). Supplements-only carts already returned above.
              if (!isKeto && !isNDIS && _suppState.nonSuppSubtotalCents / 100 < MIN_OTP_CART_AMOUNT){
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Minimum $${MIN_OTP_CART_AMOUNT} to checkout`, button);
              }
              
              if (requestPath === "mini-cart") {
                window.location.href = redirectUrl; //isKeto ? redirectUrl : `${shopUrl}/pages/extras`;
              } else {
                window.location.href = redirectUrl;
              }
              
            } else if (orderType === "WeeklySubscription" || orderType === "FortnightlySubscription") {
              
              if (isNDIS && ((total_price / 100) < MIN_NDIS_SUBS_CART_AMOUNT)){
                // console.log(`You need minimum $${MIN_NDIS_SUBS_CART_AMOUNT} to subscribe`);
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Min Order. $${MIN_NDIS_SUBS_CART_AMOUNT} meals`, button);
              }
              // FLAT $89: subscriptions gate on the same $89 FOOD subtotal as one-time orders
              // (supplements excluded — they can't be subscribed anyway). Replaces the old
              // "minimum 10 meals" count gate. _suppState is in scope from the supplement-only
              // bypass above; nonSuppSubtotalCents is the non-supplement (food) subtotal in cents.
              if ((_suppState.nonSuppSubtotalCents / 100) < MIN_SUBS_CART_AMOUNT){
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Min Order. $${MIN_SUBS_CART_AMOUNT}`, button);
              }
               // console.log(redirectUrl);
              window.location.href = redirectUrl;

            }
        });
    });
      //document.getElementById("loading-screen").style.display = "none";
    } catch (error) {
      console.error("Checkout Error:", error);
      document.getElementById("loading-screen").style.display = "none";
    } finally {
      //button?.classList.remove("loading");
      document.getElementById("loading-screen").style.display = "none";
    }
  }
  _showMinResponse(message, button) {
      if (message) {
          const responseEl = document.getElementById("min-response");
          responseEl && (responseEl.innerHTML = message), button?.classList.remove("loading")
      }
  }
  updateSubscription() {
      const cart = this.getCartData();

      const { total_price = 0, items = [] } = cart || {};
      
      const cartAmountInDollars = total_price / 100;
      
      const mealsCount = this.countLunchAndDinnerMeals(items);

      const { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");
      
      const normalizedPromoOffer = typeof promoOffer === "string" ? promoOffer.trim() : null;
      const isPromoOfferValid =
        normalizedPromoOffer &&
        normalizedPromoOffer !== "false" &&
        Object.prototype.hasOwnProperty.call(promotionalOffers, normalizedPromoOffer);

      document.querySelector(".minimum-text-info")?.classList.remove("d-none");
      if (isPromoOfferValid && (orderNo > 0 && orderNo < 5)) {
        const result = promotionalOffers[normalizedPromoOffer];
        if (result) {
          const { min = 0, max } = result.mealRange || {};
          const minRequired = max === null ? min : max;
          if (mealsCount < minRequired) {
            document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                  el.textContent = `Min Order. ${minRequired} meals`;                    
            });
            return;
          } else {  
            document.querySelector(".minimum-text-info")?.classList.add("d-none");
          }
        }
      } else if (mealsCount < MIN_SUBS_MEAL_LIMIT) { 
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;                    
        });
        return;
      } else {
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
  
      // Contract ID check
      if (!contractId) {
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Something went wrong while subscription update. Please contact our support team.`;                    
        });
        return;
      }else{
        let preWrapNew = document.querySelector("#pre_selected_data_wrap");
        preWrapNew?.classList.add("hidden");
      } 

      const localItems = localCart.getCartData().items || [];
      const formData = {
        items: localItems.map(item => ({
          id: item.variant_id,
          quantity: item.quantity         
        }))
      };
      
      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then(() => {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
      })
      .then(() => {
        // console.log({ localItems, formData });
        // alert("Cart synced successfully.");
        localStorage.setItem("proxy-contract-id", contractId);
        localStorage.removeItem("contractInfo");
        localStorage.removeItem("sub_cart_added");
        window.location.href = `/apps/account/contract/${contractId}/subscription-callback`;
      })
      .catch(err => {
        console.error("❌ Cart sync failed:", err);
      });
    
  }

  updateSubscriptionLocal() {

      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");

      let cart = this.getCartData();

      let { total_price = 0, items = [] } = cart || {};
      
      let cartAmountInDollars = total_price / 100;
      
      let mealsCount = this.countLunchAndDinnerMeals(items);

      let { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");

      document.querySelector(".minimum-text-info")?.classList.remove("d-none");

      document.getElementById("loading-screen").style.display = "block";

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);
        console.log('newContractId1',newContractId);          
      }

      if (mealsCount < MIN_SUBS_MEAL_LIMIT) { 
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;                    
        });
        return;
      } else {
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
  
      // Contract ID check
      if (!newContractId) {
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Something went wrong while subscription update. Please contact our support team.`;                    
        });
        return;
      }else{
        let preWrapNew = document.querySelector("#pre_selected_data_wrap");
        preWrapNew?.classList.add("hidden");
      } 

      const localItems = localCart.getCartData().items || [];

      const formData = {
        items: localItems.map(item => {

          let payload = {
            id: item.variant_id,
            quantity: item.qty || item.quantity
          };

          // ✅ add selling_plan if exists OR fallback
          if (item.selling_plan) {
            payload.selling_plan = item.selling_plan;
          } else {
            // fallback based on frequency
            if (item.properties?.selectedFrequency === "WeeklySubscription") {
              payload.selling_plan = SELLING_PLAN_S;
            } else if (item.properties?.selectedFrequency === "FortnightlySubscription") {
              payload.selling_plan = SELLING_PLAN_FS;
            }
          }

          // ✅ add properties (merge safely)
          payload.properties = {
            ...(item.properties || {}),
          };
          return payload;
        })
      };
      
      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then(() => {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
      })
      .then(() => {
        // console.log({ localItems, formData });
        // alert("Cart synced successfully.");
        localStorage.setItem("proxy-contract-id", newContractId);
        localStorage.removeItem("contractInfo");
        localStorage.removeItem("sub_cart_added");
        //document.getElementById("loading-screen").style.display = "block";
        window.location.href = `/apps/account/contract/${newContractId}/subscription-callback`;
      })
      .catch(err => {
        console.error("❌ Cart sync failed:", err);
      });
    
  }

  displayCartTotal() {
      this.updateCartInfoFromLocal(".cart-item-loop");
  }
  getOrdinalSuffix(number) {
      const lastDigit = number % 10,
          lastTwoDigits = number % 100;
      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${number}th`;
      switch (lastDigit) {
          case 1:
              return `${number}st`;
          case 2:
              return `${number}nd`;
          case 3:
              return `${number}rd`;
          default:
              return `${number}th`
      }
  }

  subscriptionUpdateOffers(cart, totalPrice = null, getContractIdFromCache = null) { //alert('ss');
      
      let button = document.getElementById("continue_to_shipping");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
    
      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
      let {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");         

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);    
      }

      $(".guest-order").remove();
      document.querySelectorAll(".frequency-selector").forEach(el => el.remove());
      
      $(".update-subscription-btn").addClass("active");
      const mealsCount = this.countLunchAndDinnerMeals(cart.items);
      const cartAmountInDollars = totalPrice;
      
      const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
      const mealStyle = selectedMeal.value;

      //console.log('totalPrice', totalPrice);
    
      if (promoOffer && orderNo < 5) {
        
        const result = promotionalOffers[promoOffer] || null;
        if (result) {
            const { min = 0, max } = result.mealRange || {};
            const minRequired = max === null ? min : max;
            if (mealsCount < minRequired) {
                document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                    el.textContent = `Min Order. ${minRequired} meals`;
                });
                document.querySelector(".minimum-text-info")?.classList.remove("d-none");
            }else{
              document.querySelector(".minimum-text-info")?.classList.add("d-none");
            }
          const offerList = document.querySelector(".offer-bar-footer .offer-list");
          offerList.innerHTML = "";
          const cartCounter = jQuery(".bigcounter");
          cartCounter.html(cart.item_count).addClass("added-cart-event"); 
          if (typeof result.discounts === "number") {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center","position-relative","custom-offerd-clc");
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded","h2","color-orange","d-block","mb-2","mt-3");
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `${result.discounts}% off`;
            discountContentDiv.appendChild(iconElement);
            discountContentDiv.appendChild(discountDiv);
            offerList?.appendChild(discountContentDiv);
          } else if (Array.isArray(result.discounts)) {
            result.discounts.forEach((discount, index) => {
              const discountContentDiv = document.createElement("div");
              discountContentDiv.classList.add("text-center","position-relative","custom-offerd-clc");
              const badgeSpan = document.createElement("span");
              badgeSpan.classList.add("badge", (index >= orderNo) ? "bg-secondary" : "bg-orange", "d-block","mb-2","position-absolute","right-0","small");
              badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
              const iconElement = document.createElement("i");
              iconElement.classList.add("icon-basket-loaded","h2", (index >= orderNo) ? "text-secondary" : "color-orange", "d-block","mb-2","mt-3");
              const discountDiv = document.createElement("div");
              discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
              discountDiv.textContent = `${this.formatMoney(discount * 100)} off`;
              const dashDiv = document.createElement("div");
              dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
              discountContentDiv.appendChild(badgeSpan);
              discountContentDiv.appendChild(iconElement);
              discountContentDiv.appendChild(discountDiv);
              offerList?.appendChild(discountContentDiv);
              offerList?.appendChild(dashDiv);
            });
          }
        }
      }else if(mealsCount < MIN_SUBS_MEAL_LIMIT ) {

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        
      }else if (!newContractId && userLoggedIn && !mealStyle) { 

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Please select choose your goal`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        document.getElementById("continue_to_shipping").innerText = "Please select choose your goal";

      }else{
        
        document.querySelector(".minimum-text-info")?.classList.add("d-none");

      }

        document.querySelectorAll(".sub-total-amount, .total-price-amount").forEach((el) => {
          el.textContent = this.formatMoney(cartAmountInDollars * 100);
        });
  }

  renderQuantitySelector(cart) {
      const productElements = document.querySelectorAll(".product-all"),
          items = cart.items;
      productElements.forEach(productElement => {
          const dataVariant = productElement.dataset.productId,
              quantitySelector = productElement.querySelector(".quantity-selector"),
              addToCartSelector = productElement.querySelector(".add-cart-button"),
              matchedItem = items.find(item => item.product_id === Number(dataVariant));
          if (matchedItem) {
              const quantity = matchedItem.quantity,
                  variantId = matchedItem.variant_id,
                  quantityText = productElement.querySelector(`.quantity-${variantId}`),
                  quantityInput = productElement.querySelector("input.qtyinputcs");
              quantityText && (quantityText.textContent = quantity), quantityInput && (quantityInput.value = quantity), quantitySelector && quantitySelector.classList.remove("d-none"), addToCartSelector && addToCartSelector.classList.add("d-none")
          } else addToCartSelector && addToCartSelector.classList.remove("d-none"), quantitySelector && quantitySelector.classList.add("d-none")
      })
  }

  backToSetDelivery(){
    // #finalflow is DELETED — the delivery step is now the in-drawer Address Check (Claude Design).
    this.openAddressCheckInDrawer();
  }

  loadCartData(btnADD=null) {
    this.overwriteFromRemoteCart();
    return this.getCartData();
  }
  
  
  generateOfferDOM(cart, totalPrice, totalwithshipping, welcomeApplied = false) {
      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
      const cartData = cart;
      const orderType = sdata_new?.freq ? sdata_new?.freq : (cartData.attributes?.orderType?.type || "WeeklySubscription");
      //console.log(orderType+'====');
      let cartDataNew;
      this.renderQuantitySelector(cartData);

      let {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);    
      }

      console.log('newContractId-DOM',newContractId);
      console.log('subscriptionContractId-DOM',subscriptionContractId);
  
      if (newContractId && userLoggedIn) {  
          const { total_price = 0, items = [] } = cart;
          this.subscriptionUpdateOffers(cart, totalPrice);
      } else {
          //console.log('Applying standard offers');
          document.querySelector(".menu-banner")?.classList.remove("d-none");
          $(".subtotal-title-area li:first-child").show();
          $(".subsciption-update").remove();
          $(".create-order-btn").addClass("active");
          localStorage.removeItem("contractInfo");
  
          // NDIS customer check
          if (
              userLoggedIn &&
              Array.isArray(customerData.tags) &&
              customerData.tags.includes("NDIS") &&
              typeof customerData.ndisDiscountPercentage === "number"
          ) {
              if (orderType === "OneTimePurchase") {
                  //console.log(cartData);
                  //console.log(totalPrice);
                  this.NDISoneTimePurchaseOffers(cartData, totalPrice, totalwithshipping);
              } else if (["WeeklySubscription", "FortnightlySubscription"].includes(orderType)) {
                  this.NDISsubscriptionOffers(cartData, totalPrice, totalwithshipping);
              }
          }
  
          // Keto customer check
          else if (
              userLoggedIn &&
              Array.isArray(customerData.tags) &&
              ((customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") || customerData.tags.includes("T1") || customerData.tags.includes("T2")  || customerData.tags.includes("T3") || this.isBluefit)
              
          ) {
              //console.log(totalPrice);
              this.KetoOneTimePurchaseOffers(cartData, totalPrice, totalwithshipping);
          }
  
          // Regular offers
          else {
              if (orderType === "OneTimePurchase") {
                  this.oneTimePurchaseOffers(cartData, totalPrice, totalwithshipping, welcomeApplied);
              } else if (["WeeklySubscription", "FortnightlySubscription"].includes(orderType)) {
                  this.subscriptionOffers(cartData, totalPrice, totalwithshipping);
              }
          }
      }

      document.getElementById("mini-cart").style.display = "block";
  }

    // ----------------------------------------
  // Show discount code row (REUSABLE)
  // ----------------------------------------
  showDiscountCodeRow({
    code,
    amount,
    orderTypeHave,
    container = ".discount-section",
    currency = "AUD",
  }) {
    if (!code) return;

    amount = Math.abs(amount);

    const discountSectionNEW = document.querySelector(container);
    if (!discountSectionNEW) return;

    let extraRow = document.querySelector(".welcome25-extra-row");

    if (!extraRow) {
      extraRow = document.createElement("div");
      extraRow.className =
        "welcome25-extra-row d-flex justify-content-between mt-1 small";

      // insert right after discount section
      discountSectionNEW.insertAdjacentElement("afterend", extraRow);
    }

    const formatted = Number(amount).toLocaleString("en-AU", {
      style: "currency",
      currency,
    });

    extraRow.innerHTML = `
      <label class="fs-12">Discount code (${code})</label>
      <span class="badge rounded-pill text-green-discount fw-bold discount-amount">
        -${formatted}
      </span>
    `;

    // Optional visual emphasis
    //discountSectionNEW.classList.add("strick_through");
    //document.querySelector(".offer-list-section")?.classList.add("shadow_row");
    discountSectionNEW?.classList.add("d-none");
  }


  getActivePromoOfferAppiled(mealsCount) {
    for (const [promo, offer] of Object.entries(promotionalOffers)) {
      const { min, max } = offer.mealRange || {};
      if (mealsCount >= min && mealsCount < max) {
        return { promo, offer };
      }
    }
    return null;
  }


  oneTimePurchaseOffers({
      original_total_price,
      items
  }, totalPrice, totalwithshipping, welcomeApplied) {

      let button = document.getElementById("continue_to_shipping");
      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
      const offerLists = document.querySelectorAll(".offer-list");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".per-serving-section")?.classList.add("d-none");
      
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".free-shipping-text")?.classList.add("d-none");
      document.querySelector(".minicart-msg-section")?.classList.add("d-none");
      document.querySelector(".offer-list-section ")?.classList.add("d-none");  
      
      const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
      const mealStyle = selectedMeal.value;

      let {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);    
      }
      
      
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerLists) {
        //console.error('Element with id "offer-list" not found');
        //return;
      }
      const cartAmountInDollars = original_total_price / 100;
      const mealsCount = this.countLunchAndDinnerMeals(items);
      const minOtpMeals = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
      // The $89 minimum is on the NON-supplement (food) subtotal — meals/snacks/drinks/bundles —
      // matching the checkout enforcement + Claude Design ("supplements don't count toward it").
      const foodForMin = (typeof this.supplementCartState === "function")
        ? (this.supplementCartState(items).nonSuppSubtotalCents / 100) : cartAmountInDollars;
       if (foodForMin < MIN_OTP_CART_AMOUNT) {
         if (primaryButton) {
            primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
            primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
            primaryButton.innerHTML = `${this.formatMoney((MIN_OTP_CART_AMOUNT - foodForMin) * 100)} to go to reach the $${MIN_OTP_CART_AMOUNT} minimum`;
         }
        // B1: surface the $89 FOOD minimum in the dedicated mini-cart banner
        // (.minimum-text-info / .total-minimum-limit). Copy per Claude Design "Your Box" drawer.
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `${this.formatMoney((MIN_OTP_CART_AMOUNT - foodForMin) * 100)} to go to reach the $${MIN_OTP_CART_AMOUNT} minimum`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");

        // } else if (mealsCount < minOtpMeals) {
        //   if (primaryButton) {
        //       primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
        //       primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        //       primaryButton.innerHTML = `Add ${minOtpMeals - mealsCount} more meals to your cart`;
        //   }
        //   document.querySelectorAll(".total-minimum-limit").forEach((el) => {
        //         el.textContent = `Min Order. ${minOtpMeals} meals`;
        //   });
        //   document.querySelector(".minimum-text-info")?.classList.remove("d-none");

      }else if (!newContractId && userLoggedIn && !mealStyle) { 

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Please select choose your goal`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");

      } else {
         if (primaryButton) {
            const deliveryDate = getCookie("expecting-delivery");
            //if (deliveryDate !== null) {
                primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
                primaryButton.classList.add("bg-orange","border-orange","thr1ve-checkout-green");
                primaryButton.style.setProperty("background","#54B52A","important");primaryButton.style.setProperty("border-color","#54B52A","important");primaryButton.style.setProperty("color","#fff","important");
                primaryButton.innerHTML = 'Checkout' + ((document.querySelector('.total-price-amount')?.textContent || '').trim() ? ' · ' + document.querySelector('.total-price-amount').textContent.trim() : '') + ' <span aria-hidden="true" style="margin-left:5px">&rarr;</span>';
            /*} else {
                primaryButton.removeAttribute("onclick");
                primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
                primaryButton.classList.add("checkPostalBtn2");
                primaryButton.innerHTML = 'Select Delivery Date and Checkout';
            }*/
         }
      }
      
      let notificationMessage = "Save up to 15% on Meals";
      let activeOffer=null;
      const basePrice = cartAmountInDollars.toFixed(2);
     
      offerLists.forEach((list) => (list.innerHTML = ""));
      if (offerListDetails) {
        offerListDetails.innerHTML = "";
      }
      let bestOffer = false;
      let totalDiscount = 0;
      let prevPromo=null;
      if (typeof oneTimeOffers !== "undefined") {
      Object.entries(oneTimeOffers).forEach(([promo, offer]) => {
        const { min, max } = offer.mealRange;
        totalDiscount = offer.discounts;
        const li = document.createElement("li");
        const isBestOffer = max === null ? mealsCount >= min : mealsCount >= max;
        li.classList.add("me-2","d-flex","align-items-center","rounded-pill", isBestOffer ? "bg-gradient-success" : "bg-off-grey");
        bestOffer = isBestOffer;
        if (mealsCount >= min && (max === null || mealsCount < max)) {
          notificationMessage= `${notificationMessage} <br><span class="small text-muted fs-12">${offer.notify}</span>`;
          const maxRange = max === null ? Math.max(mealsCount, min) : max;
          const widthPercentage = maxRange > 0 ? Math.min((mealsCount / maxRange) * 100, 100) : 100;
    
          const progressDiv = document.createElement("div");
          progressDiv.classList.add("d-flex","align-items-center","justify-end","rounded-pill","bg-gradient-success-secondary");
          progressDiv.style.transition = "width 1s";
          progressDiv.style.minWidth = "max-content";
          progressDiv.style.zIndex = "1";
          progressDiv.style.width = `${widthPercentage}%`;
    
          const innerDiv = document.createElement("div");
          innerDiv.classList.add("d-flex","align-items-center","justify-center","rounded-pill","bg-white","color-green","border-green","px-2","dynamic-margin","py-sm-0","py-1");
          innerDiv.textContent = `${mealsCount}/${max === null ? "17+" : maxRange}`;
    
          progressDiv.appendChild(innerDiv);
          li.style.width = "100%";
          li.classList.add("position-relative", "bg-off-grey");
          li.appendChild(progressDiv);
    
          const span = document.createElement("span");
          span.classList.add("position-absolute","right-0","text-dark","px-1","py-sm-0","py-1");
          span.textContent = `${totalDiscount}%OFF`;
          li.appendChild(span);
         
          if (prevPromo && typeof prevPromo.discounts === "number") {
            activeOffer = prevPromo;
          } else {
            const saveSpan = document.createElement("span");
            saveSpan.classList.add("fw-bold", "text-black", "py-2");
            saveSpan.textContent = "Save up to 15% on Meals";
            offerListDetails?.appendChild(saveSpan);
          }
        } else {
          const span = document.createElement("span");
          span.classList.add("rounded-pill","top-0","right-0","text-dark","p-1","text-white","text-center");
          span.textContent = `${totalDiscount}%${!isBestOffer ? 'OFF' : ''}`;
          li.appendChild(span);
        }
        prevPromo = offer;
        offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
      });
      }

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");

      //console.log(localStorage.getItem("WELCOME25_APPLIED"));

      if (bestOffer) {

        offerLists.forEach((list) => (list.innerHTML = "")); // Clear the list before appending the best offer
        const li = document.createElement("li");
        li.classList.add("me-2","d-flex","align-items-center","rounded-pill","bg-gradient-success");
        li.style.width = "100%";
        const span = document.createElement("span");
        span.classList.add("px-2","py-1","rounded-pill","top-0","right-0","text-dark","p-1","text-white","text-center");
        span.textContent = "You're saving 15% on Meals";
        li.appendChild(span);
        activeOffer = typeof oneTimeOffers !== "undefined" ? oneTimeOffers.promo3 : null;
        offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
      }
      document.querySelector(".offer-details-bar")?.classList.remove("d-none");
    
      document.querySelectorAll(".notification-message-mini-cart").forEach((el) => {
        el.innerHTML = notificationMessage;  // Use textContent if it's plain text
      });
      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = this.formatMoney(totalPrice * 100);

      const minOtpN = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 10;
      // Tier pricing is the BASE price now (Function B4 + per-line tier) — do NOT subtract the legacy
      // oneTimeOffers %-off on top (that double-discounted the tier). Savings are already in the price.
      const totalDiscountPercent = 0;

      let lunchdinnerItems = this.cart.items.filter(item => item.product_type === "LUNCH & DINNER");
      
      let offApplied = 0;
      lunchdinnerItems.forEach(item => {
        let itemPrice = item.price;

        if (this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined') {
          itemPrice = PROMO_PROD_PRICE;
        }

        let itemDiscount = (itemPrice / 100) * (totalDiscountPercent / 100);

        // floor to 2 decimal places
        let finalDiscount = Math.floor(itemDiscount * 100) / 100;

        offApplied += finalDiscount * item.qty;

      });
      offApplied = offApplied.toFixed(2);
      
      if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit){
        offApplied = 0;          
        document.querySelector(".minicart-msg-section")?.classList.add("d-none");
        document.querySelector(".offer-list-section ")?.classList.add("d-none"); 
      }else if(userLoggedIn && Array.isArray(customerData.tags) && !newContractId){
        document.querySelector(".minicart-msg-section")?.classList.remove("d-none");
        document.querySelector(".offer-list-section ")?.classList.remove("d-none"); 
      }

      document.querySelectorAll(".total-price-amount").forEach((el) => {
          el.textContent = this.formatMoney((totalwithshipping - offApplied) * 100);
      });
      this.updateTotalDiscountAmount(totalwithshipping, Number(offApplied) > 0);

      // #7 (Saahil + screens-cart.jsx): keep the green Checkout button label in sync with the
      // total — "Checkout · $XX →". Only when the button is in the ready/checkout state (carries
      // a proceedToCheckout onclick); the under-minimum lock label is left untouched.
      (function (self) {
        const btn = document.getElementById("continue_to_shipping");
        if (!btn) return;

        // BOX-FILL GATE (Saahil + updated Claude Design): a FIXED box (picker stored a numeric
        // window_state.boxSize) must be FILLED before checkout. "Build Your Own"/flexible
        // (boxSize null) is exempt — only the $89 gate applies. Runs LAST so it overrides the
        // ready/green state when the box is short.
        let boxSize = 0;
        try { boxSize = Number(localStorage.getItem("thr1ve_box_target")) || 0; } catch (e) {}
        const mealsNow = self.countLunchAndDinnerMeals();
        if (boxSize > 0 && mealsNow < boxSize) {
          const remain = Number(boxSize) - mealsNow;
          btn.removeAttribute("onclick");
          btn.classList.remove("thr1ve-checkout-green", "bg-orange", "border-orange");
          btn.style.removeProperty("background");
          btn.style.removeProperty("border-color");
          btn.style.removeProperty("color");
          btn.setAttribute("aria-disabled", "true");
          btn.innerHTML = `Add ${remain} more to complete your ${boxSize}-meal box`;
          return;
        }

        const ready = (btn.getAttribute("onclick") || "").indexOf("proceedToCheckout") !== -1;
        if (!ready) return;
        const t = (document.querySelector(".total-price-amount")?.textContent || "").trim();
        btn.innerHTML = "Checkout" + (t ? " · " + t : "") + ' <span aria-hidden="true" style="margin-left:5px">&rarr;</span>';
        btn.classList.add("thr1ve-checkout-green");
        // GREEN via inline !important — a same-specificity legacy `.bg-orange !important` rule
        // was tying and winning on source order, so beat it at the inline layer.
        btn.style.setProperty("background", "#54B52A", "important");
        btn.style.setProperty("border-color", "#54B52A", "important");
        btn.style.setProperty("color", "#fff", "important");
      })(this);

      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }

      /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew);     

      this.getShippingAmount();

      console.log('codeLabel',codeLabel);
      console.log('offApplied',offApplied);
      console.log('totalDiscountPercent',totalDiscountPercent);

      if(codeLabel && (total_price >= MIN_OTP_CART_AMOUNT)){ 

        if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit) { 

        }else{ 

          if (typeof codeLabel === "string") {
            codeLabel = codeLabel
              .split(",")          // split by comma
              .map(v => v.trim())  // trim spaces
              .filter(Boolean)     // remove empty values
              .join(" + ");        // join
          }          
          
          this.showDiscountCodeRow({
            code: codeLabel,
            amount: offApplied,
            orderTypeHave: orderTypeNew
          });
        }


      }else{

        let extraRow = document.querySelector(".welcome25-extra-row");
        /*let discountSection = document.querySelector(".discount-section");        
        if (discountSection) {
          discountSection?.classList.add("d-none");
        }*/
        if (extraRow) {
          extraRow.remove();
        }

      }
  }
  

  subscriptionOffers({ original_total_price, items, total_count }, totalPrice, totalwithshipping) {
    const offerLists = document.querySelectorAll(".offer-list");
    const offerListDetails = document.getElementById("offer-list-details");
  
    document.querySelector(".free-shipping-section")?.classList.remove("d-none");
    this.getShippingAmount();
    document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    if (!offerLists) {
      console.error('Element with class "offer-list" not found');
      return;
    }
  
    const cartAmountInDollars = totalPrice;
    const mealsCount = this.countLunchAndDinnerMeals(items);
    // $89 minimum is on the NON-supplement (food) subtotal (matches enforcement + Claude Design).
    const foodForMin = (typeof this.supplementCartState === "function")
      ? (this.supplementCartState(items).nonSuppSubtotalCents / 100) : cartAmountInDollars;

    let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");

    let { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");

    let newContractId = contractId;
      
    const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
    const mealStyle = selectedMeal.value;

    if(!newContractId){
      newContractId = this.getContractIdFromCache(sdata_new.email);
      console.log('newContractId1',newContractId);          
    }
      
    // console.log('cartAmountInDollars',cartAmountInDollars);
    // console.log('original_total_price',original_total_price);  
    // console.log('mealsCount',mealsCount);
    // console.log('MIN_SUBS_MEAL_LIMIT',MIN_SUBS_MEAL_LIMIT);
    // console.log('MIN_SUBS_CART_AMOUNT',MIN_SUBS_CART_AMOUNT);          
  
    // FLAT $89 for subscriptions too (Claude Design "Your Box" drawer): gate on the $89 dollar
    // minimum only — the old "minimum N meals" COUNT requirement is gone (MIN_SUBS_MEAL_LIMIT = 0).
    if (foodForMin < MIN_SUBS_CART_AMOUNT) {
      if (primaryButton) {
        primaryButton.removeAttribute("onclick", "javascript:void(0);");
        primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        // Locked CTA copy per the design: "$X to go to reach the $89 minimum".
        primaryButton.innerHTML = `${this.formatMoney((MIN_SUBS_CART_AMOUNT - foodForMin) * 100)} to go to reach the $${MIN_SUBS_CART_AMOUNT} minimum`;
      }
      // Populate + SHOW the $89-minimum banner (.minimum-text-info / .total-minimum-limit) so the
      // "ⓘ Why?" popover appears — same as the one-time path. (Previously hidden for subscriptions.)
      document.querySelectorAll(".total-minimum-limit").forEach((el) => {
        el.textContent = `${this.formatMoney((MIN_SUBS_CART_AMOUNT - foodForMin) * 100)} to go to reach the $${MIN_SUBS_CART_AMOUNT} minimum`;
      });
      document.querySelector(".minimum-text-info")?.classList.remove("d-none");

    } else if (!newContractId && userLoggedIn && !mealStyle) {

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Please select choose your goal`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        document.getElementById("continue_to_shipping").innerText = "Please select choose your goal";

      } else {
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      const deliveryDate = getCookie("expecting-delivery");
      if (primaryButton) {
        //if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.innerHTML = 'Checkout' + ((document.querySelector('.total-price-amount')?.textContent || '').trim() ? ' · ' + document.querySelector('.total-price-amount').textContent.trim() : '') + ' <span aria-hidden="true" style="margin-left:5px">&rarr;</span>';
          primaryButton.classList.add("bg-orange", "border-orange", "thr1ve-checkout-green");
          primaryButton.style.setProperty("background","#54B52A","important");primaryButton.style.setProperty("border-color","#54B52A","important");primaryButton.style.setProperty("color","#fff","important");
        /*} else {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
          primaryButton.innerHTML = 'Select Delivery Date and Checkout';
        }*/
      }
    }
  
    let notificationMessage = "Save up to 15% on Meals";
    let activeOffer = null;
    const basePrice = cartAmountInDollars.toFixed(2);
  
    offerLists.forEach(list => (list.innerHTML = ""));
    if (offerListDetails) offerListDetails.innerHTML = "";
  
    let bestOffer = false;
    let validForCount = false;
    let totalDiscount = 0;
    let prevPromo = null;

    console.log(promotionalOffers);
  
    Object.entries(promotionalOffers).forEach(([promo, offer]) => {
      const { min, max } = offer.mealRange || {};
      totalDiscount = typeof offer.discounts === "number" ? `${offer.discounts}%OFF` : (promo === "promo1" ? "FREE SHIPPING" : offer.discounts);
      if (typeof totalDiscount !== "string" && Array.isArray(offer.discounts)) {
        totalDiscount = `$${Math.round(offer.discounts.reduce((a, b) => a + b, 0))}`;
      }
  
      const li = document.createElement("li");
      const isBestOffer = max === null ? mealsCount >= min : mealsCount >= max;
      li.classList.add("me-2", "d-flex", "align-items-center", "rounded-pill",
        isBestOffer ? "bg-gradient-success" : "bg-off-grey");
      bestOffer = isBestOffer;
      if (mealsCount >= min && (max === null || mealsCount < max)) {
        notificationMessage += `<br><span class="small text-muted fs-12">${offer.notify}</span>`;
        const maxRange = max === null ? Math.max(mealsCount, min) : max;
        const widthPercentage = maxRange > 0 ? Math.min((mealsCount / maxRange) * 100, 100) : 100;
  
        const progressDiv = document.createElement("div");
        progressDiv.classList.add("d-flex", "align-items-center", "justify-end", "rounded-pill", "bg-gradient-success-secondary");
        progressDiv.style.transition = "width 1s";
        progressDiv.style.minWidth = "max-content";
        progressDiv.style.zIndex = "1";
        progressDiv.style.width = `${widthPercentage}%`;
  
        const innerDiv = document.createElement("div");
        innerDiv.classList.add("d-flex", "align-items-center", "justify-center", "rounded-pill", "bg-white", "color-green", "border-green", "px-2", "dynamic-margin", "py-sm-0", "py-1");
        innerDiv.textContent = `${mealsCount}/${max === null ? "17+" : maxRange}`;
  
        progressDiv.appendChild(innerDiv);
        li.style.width = "100%";
        li.classList.add("position-relative", "bg-off-grey");
        li.appendChild(progressDiv);
  
        const span = document.createElement("span");
        span.classList.add("position-absolute", "right-0", "text-dark", "px-1", "py-sm-0", "py-1");
        span.textContent = totalDiscount;
        li.appendChild(span);
  
        if (prevPromo && typeof prevPromo.discounts === "number") {
          activeOffer = prevPromo;
        } else if (prevPromo?.discounts?.length) {
          activeOffer = prevPromo;
          prevPromo.discounts.forEach((discount, index) => {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
            const badgeSpan = document.createElement("span");
            badgeSpan.classList.add("badge", "bg-orange", "d-block", "mb-2", "position-absolute", "right-0", "small");
            badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `${this.formatMoney(discount * 100)} off`;
            const dashDiv = document.createElement("div");
            dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
            discountContentDiv.append(badgeSpan, iconElement, discountDiv);
            offerListDetails?.append(discountContentDiv, dashDiv);
          });
        } else {
          const span = document.createElement("span");
          span.classList.add("fw-bold", "text-black", "py-2");
          span.textContent = "Save up to 15% on Meals";
          offerListDetails?.appendChild(span);
        }
      } else {
        const span = document.createElement("span");
        span.classList.add("rounded-pill", "top-0", "right-0", "text-dark", "p-1", "text-white", "text-center");
        span.textContent = totalDiscount;
        li.appendChild(span);
      }
  
      prevPromo = offer;
      offerLists.forEach(list => list.appendChild(li.cloneNode(true)));
    });

    let extraRow = document.querySelector(".welcome25-extra-row");
    let totalEls = document.querySelectorAll(".total-price-amount");
    let discountSectionPrev = document.querySelector(".discount-section");
    let offerListSection = document.querySelector(".offer-list-section");
    if (extraRow) extraRow.remove();    
    
    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
  
    if (bestOffer) {
      this.renderlastOffer(promotionalOffers.promo3);
      offerLists.forEach(list => (list.innerHTML = ""));
      const li = document.createElement("li");
      li.classList.add("me-2", "d-flex", "align-items-center", "rounded-pill", "bg-gradient-success");
      li.style.width = "100%";
  
      const span = document.createElement("span");
      span.classList.add("px-2", "py-1", "rounded-pill", "top-0", "right-0", "text-dark", "p-1", "text-white", "text-center");
      span.textContent = `You’re saving 15% on Meals`;
      li.appendChild(span);
  
      activeOffer = promotionalOffers.promo3;
      offerLists.forEach(list => list.appendChild(li.cloneNode(true)));
    }

    if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit){      
      document.querySelector(".minicart-msg-section")?.classList.add("d-none");
      document.querySelector(".offer-list-section ")?.classList.add("d-none"); 
    }else if(userLoggedIn && Array.isArray(customerData.tags) && !newContractId){
      document.querySelector(".minicart-msg-section")?.classList.remove("d-none");
      document.querySelector(".offer-list-section ")?.classList.remove("d-none"); 
    }
  
    document.querySelector(".offer-details-bar")?.classList.remove("d-none");
  
    const minSubsN = typeof MIN_SUBS_MEAL_LIMIT !== "undefined" ? MIN_SUBS_MEAL_LIMIT : 10;
    // Tier pricing is now the BASE price (cart-transform Function B4 + the per-line tier above), so
    // the legacy promotionalOffers %-off must NOT be subtracted on top — that double-discounted the
    // tier (e.g. 14 meals showed $156.94 = $175 tier − 10%). Tier savings are already IN the price.
    const totalDiscountPercent = 0;

    //let offApplied = (cartAmountInDollars * (totalDiscountPercent / 100)).toFixed(2);

    let lunchdinnerItems = this.cart.items.filter(item => item.product_type === "LUNCH & DINNER");
    
    let offApplied = 0;
    lunchdinnerItems.forEach(item => {
      let itemPrice = item.price;

      if (this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined') {
        itemPrice = PROMO_PROD_PRICE;
      }

      let itemDiscount = (itemPrice / 100) * (totalDiscountPercent / 100);

      // floor to 2 decimal places
      let finalDiscount = Math.floor(itemDiscount * 100) / 100;

      offApplied += finalDiscount * item.qty;
      
    });
    offApplied = offApplied.toFixed(2);

    let discountedPrice = (totalwithshipping - offApplied).toFixed(2);
    const selectedOrderType = sdata_new?.freq || "WeeklySubscription";
    const shippingDeducted = this.isShippingDeductedForTotal(selectedOrderType, mealsCount);
    
    document.querySelectorAll(".total-price-amount").forEach(el => {
      el.textContent = this.formatMoney(discountedPrice * 100);
    });
    this.updateTotalDiscountAmount(totalwithshipping, Number(offApplied) > 0 || shippingDeducted, shippingDeducted);
  
    document.querySelector(".total-applied-section")?.classList.toggle("d-none", !activeOffer);
    document.querySelectorAll(".notification-message-mini-cart").forEach(el => {
      el.innerHTML = notificationMessage;
    });
  
    document.querySelector(".sub-total-section")?.classList.remove("d-none");
    document.querySelector(".sub-total-amount").textContent = this.formatMoney(totalwithshipping * 100);
  
    const discountSection = document.querySelector(".discount-section");
    const discountAmountEl = document.querySelector(".discount-amount");
  
    if (offApplied > 0) {
      discountSection?.classList.remove("d-none");
      discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
    } else {
      discountSection?.classList.add("d-none");
      discountAmountEl && (discountAmountEl.textContent = "");
    }

    /* Show Discount Code*/
    let subTotalNew = (original_total_price || 0) / 100;
    let totalNowNew = Number(totalPrice || 0);
    let cartDataNew = this.getCartData(); 
    let { attributes, total_price } = cartDataNew;
    let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
    let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

    // Decide code label
    let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

    console.log('codeLabel',codeLabel);
    console.log('offApplied',offApplied);

    if(codeLabel && (mealsCount >= 10)){ 
      if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit) { 
      }else{     
        if (typeof codeLabel === "string") {
          codeLabel = codeLabel
            .split(",")          // split by comma
            .map(v => v.trim())  // trim spaces
            .filter(Boolean)     // remove empty values
            .join(" + ");        // join
        } 
        this.showDiscountCodeRow({
          code: codeLabel,
          amount: offApplied,
          orderTypeHave: orderTypeNew
        });
      }
    }
  }

  
  renderlastOffer(prevPromo) {
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerListDetails || !prevPromo) return;
      if (typeof prevPromo.discounts === "number") {
        const discountContentDiv = document.createElement("div");
        discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
        const iconElement = document.createElement("i");
        iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
        const discountDiv = document.createElement("div");
        discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
        discountDiv.textContent = `${prevPromo.discounts}% off`;
        discountContentDiv.appendChild(iconElement);
        discountContentDiv.appendChild(discountDiv);
        offerListDetails.appendChild(discountContentDiv);
      } else if (Array.isArray(prevPromo.discounts)) {
        prevPromo.discounts.forEach((discount, index) => {
          const discountContentDiv = document.createElement("div");
          discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
          const badgeSpan = document.createElement("span");
          badgeSpan.classList.add("badge", "bg-orange", "d-block", "mb-2", "position-absolute", "right-0", "small");
          badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
          const iconElement = document.createElement("i");
          iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
          const discountDiv = document.createElement("div");
          discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
          discountDiv.textContent = `$${discount} off`;
          const dashDiv = document.createElement("div");
          dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
          discountContentDiv.appendChild(badgeSpan);
          discountContentDiv.appendChild(iconElement);
          discountContentDiv.appendChild(discountDiv);
          offerListDetails.appendChild(discountContentDiv);
          offerListDetails.appendChild(dashDiv);
        });
      }
  }

  KetoOneTimePurchaseOffers({
      original_total_price,
      original_keto_total_price,
      original_t1_total_price,
      original_t2_total_price,
      original_t3_total_price,
      items,
      item_count,
      total_count
  }, totalPrice, totalwithshipping) {
      const offerLists = document.querySelectorAll(".offer-list");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      document.querySelectorAll(".frequency-selector").forEach(el => el.remove());
    
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerListDetails) {
        //console.error('Element with id "offer-list-details" not found');
        //return;
      }      

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");
      
      if (extraRow) extraRow.remove();
      discountSectionPrev?.classList.remove('strick_through');
      offerListSection?.classList.remove('shadow_row');
    
      const cartAmountInDollars = totalPrice;
    
      if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
        if (primaryButton) {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.remove("checkPostalBtn2", "bg-orange", "border-orange");
          primaryButton.innerHTML = `${this.formatMoney((MIN_OTP_CART_AMOUNT - cartAmountInDollars) * 100)} to go to reach the $${MIN_OTP_CART_AMOUNT} minimum`;
        }
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      } else {
        if (primaryButton) {
          const deliveryDate = getCookie("expecting-delivery");
          //if (deliveryDate !== null) {
            primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
            primaryButton.classList.add("bg-orange", "border-orange");
            primaryButton.innerHTML = "Checkout Now";
          /*} else {
            primaryButton.removeAttribute("onclick");
            primaryButton.classList.add("checkPostalBtn2");
            primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
            primaryButton.innerHTML = "Select Delivery Date and Checkout";
          }*/
        }
      }

      console.log('original_total_price', original_total_price);
      console.log('original_keto_total_price', original_keto_total_price);
      console.log('original_t1_total_price', original_t1_total_price);
      console.log('original_t2_total_price', original_t2_total_price);
      console.log('original_t3_total_price', original_t3_total_price);
      console.log('totalwithshipping', totalwithshipping);


      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")) {
        totalPrice = original_keto_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1")) {
        totalPrice = original_t1_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2")) {
        totalPrice = original_t2_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3")) {
        totalPrice = original_t3_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit) {
        totalPrice = original_total_price / 100;
      }
      const offApplied = (totalPrice - totalPrice).toFixed(2);
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
    
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-text")?.classList.add("d-none");
    
      document.querySelector(".sub-total-section")?.classList.remove("d-none");

      document.querySelector(".sub-total-amount").textContent = this.formatMoney(totalPrice * 100);
    
      document.querySelectorAll(".total-price-amount").forEach(el => {
        el.textContent = this.formatMoney(totalwithshipping * 100);
      });
      this.updateTotalDiscountAmount(totalwithshipping, false);

      /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

      console.log('codeLabel', codeLabel);
      console.log('offApplied', offApplied);
      console.log('orderTypeNew', orderTypeNew);

      this.getShippingAmount();

  }

  NDISoneTimePurchaseOffers({
      original_total_price,
      items
  }, totalPrice, totalwithshipping) {
    const cartAmountInDollars = (totalPrice).toFixed(2);
    //console.log(cartAmountInDollars, MIN_NDIS_OTP_CART_AMOUNT);
    const offerLists = document.querySelectorAll(".offer-list");
  
    document.querySelector(".total-applied-section")?.classList.add("d-none");
  
    document.querySelector(".free-shipping-section")?.classList.remove("d-none");
    document.querySelector(".free-shipping-text")?.classList.remove("d-none");
    document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
    //document.querySelector(".free-shipping-text")?.classList.remove("fw-bold");
  
    document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    const offerListDetails = document.getElementById("offer-list-details");
    if (!offerLists) {
      //console.error('Element with class "offer-list" not found');
      return;
    }
  
    // Conditional CTA button logic
    if (cartAmountInDollars < MIN_NDIS_OTP_CART_AMOUNT) { 
      if (primaryButton) {
        primaryButton.removeAttribute("onclick");
        primaryButton.classList.remove("checkPostalBtn2", "bg-orange", "border-orange");
        primaryButton.innerHTML = `${this.formatMoney((MIN_NDIS_OTP_CART_AMOUNT - cartAmountInDollars) * 100)} to go to reach the $${MIN_NDIS_OTP_CART_AMOUNT} minimum`;
      }
  
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    } else {
      if (primaryButton) {
        const deliveryDate = getCookie("expecting-delivery");
  
        //if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.classList.add("bg-orange", "border-orange");
          primaryButton.innerHTML = "Checkout Now";
        /*} else {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
          primaryButton.innerHTML = "Select Delivery Date and Checkout";
        }*/
      }
    }

    let extraRow = document.querySelector(".welcome25-extra-row");
    let totalEls = document.querySelectorAll(".total-price-amount");
    let discountSectionPrev = document.querySelector(".discount-section");
    let offerListSection = document.querySelector(".offer-list-section");    
    if (extraRow) extraRow.remove();

    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
  
    // Subtotal + Total price display
    document.querySelector(".sub-total-section")?.classList.remove("d-none");
    document.querySelector(".sub-total-amount").textContent = this.formatMoney(original_total_price);
  
     document.querySelectorAll(".total-price-amount").forEach((el) => {
            el.textContent = this.formatMoney(totalwithshipping * 100);
    });
    const discountSection = document.querySelector(".discount-section");
    const discountAmountEl = document.querySelector(".discount-amount");
    const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
    const shippingDeducted = this.isShippingDeductedForTotal("OneTimePurchase", this.countLunchAndDinnerMeals(items));
    this.updateTotalDiscountAmount(original_total_price / 100, Number(offApplied) > 0 || shippingDeducted, shippingDeducted);
    if (offApplied > 0) {
      discountSection?.classList.remove("d-none");
      discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
    } else {
      discountSection?.classList.add("d-none");
      discountAmountEl && (discountAmountEl.textContent = "");
    }

    /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

      console.log('codeLabel', codeLabel);
      console.log('offApplied', offApplied);
      console.log('orderTypeNew', orderTypeNew);
      console.log('totalPrice', totalPrice);

      this.getShippingAmount(false);

      codeLabel = (codeLabel || "")
      .split(",")
      .filter(c => c.trim() !== "NDIS-FREESHIPPING")
      .join(",");

      if(codeLabel && (totalPrice >= MIN_NDIS_OTP_CART_AMOUNT)){ 

        if (typeof codeLabel === "string") {
          codeLabel = codeLabel
            .split(",")          // split by comma
            .map(v => v.trim())  // trim spaces
            .filter(Boolean)     // remove empty values
            .join(" + ");        // or " " or "-" as you prefer
        } 
        this.showDiscountCodeRow({
          code: codeLabel,
          amount: offApplied,
          orderTypeHave: orderTypeNew
        });

      }
  }

  
  NDISsubscriptionOffers({
      original_total_price,
      items
  }, totalPrice, totalwithshipping) {
      
      const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      let mealsCount = this.countLunchAndDinnerMeals(items);
      
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-text")?.classList.remove("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
      //document.querySelector(".free-shipping-text")?.classList.remove('fw-bold');
      document.querySelector("#min-response")?.classList.remove("d-none");
      
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerLists) {
        //console.error('Element with id "offer-list" not found');
        return;
      }
      const cartAmountInDollars = totalPrice;
      if ((cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) || (mealsCount < MIN_SUBS_MEAL_LIMIT)) {
        if (primaryButton) {
          //primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.removeAttribute("onclick", "javascript:void(0);");
          primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        }
        let frist_have = 0;
        if (mealsCount < MIN_SUBS_MEAL_LIMIT){
          if (primaryButton) {
              primaryButton.innerHTML = `Add ${MIN_SUBS_MEAL_LIMIT - mealsCount} meals to reach the order minimum`;
          }
          document.querySelector(".minimum-text-info")?.classList.add("d-none");
          frist_have = 1;
        } else{
          frist_have = 0;
        }
        
        if((cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) && !frist_have){
          if (primaryButton) {
            primaryButton.innerHTML = `${this.formatMoney((MIN_NDIS_SUBS_CART_AMOUNT - cartAmountInDollars) * 100)} to go to reach the $${MIN_NDIS_SUBS_CART_AMOUNT} minimum`;
          }
          document.querySelector(".minimum-text-info")?.classList.add("d-none");
        }

        //console.log(mealsCount+' ===11 '+MIN_SUBS_MEAL_LIMIT);
        
        if (mealsCount < MIN_SUBS_MEAL_LIMIT){
          document.querySelector(".minimum-text-info")?.classList.add("d-none"); 
          //this._showMinResponse(`You need minimum ${MIN_SUBS_MEAL_LIMIT} meals to subscribe`, primaryButton);
        } 
        
      } else {
        
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
        //console.log(mealsCount+' ===12 '+MIN_SUBS_MEAL_LIMIT);        
        
        if (primaryButton) {
          const deliveryDate =  getCookie("expecting-delivery");
          //if (deliveryDate !== null) {
              primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
              primaryButton.innerHTML = 'Checkout Now';
              primaryButton.classList.add("bg-orange","border-orange");
          /*} else {
              primaryButton.removeAttribute("onclick");
              primaryButton.classList.add("checkPostalBtn2");
              primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
              primaryButton.innerHTML = 'Select Delivery Date and Checkout';
          }*/
        }
      }

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");
      
      if (extraRow) extraRow.remove();
      discountSectionPrev?.classList.remove('strick_through');
      offerListSection?.classList.remove('shadow_row');

      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = this.formatMoney(original_total_price);
     
      document.querySelectorAll(".total-price-amount").forEach((el) => {
              el.textContent = this.formatMoney(totalwithshipping * 100);
      });
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
      const selectedOrderType = JSON.parse(localStorage.getItem("window_state") || "{}")?.freq || "WeeklySubscription";
      const shippingDeducted = this.isShippingDeductedForTotal(selectedOrderType, mealsCount);
      this.updateTotalDiscountAmount(original_total_price / 100, Number(offApplied) > 0 || shippingDeducted, shippingDeducted);
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
      /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

      console.log('codeLabel', codeLabel);
      console.log('offApplied', offApplied);
      console.log('orderTypeNew', orderTypeNew);
      console.log('totalPrice', totalPrice);
      console.log('mealsCount', mealsCount);

      codeLabel = (codeLabel || "")
      .split(",")
      .filter(c => c.trim() !== "NDIS-FREESHIPPING")
      .join(",");

      this.getShippingAmount();

      if(codeLabel && (mealsCount >= 10)){
        if (typeof codeLabel === "string") {
          codeLabel = codeLabel
            .split(",")          // split by comma
            .map(v => v.trim())  // trim spaces
            .filter(Boolean)     // remove empty values
            .join(" + ");        // or " " or "-" as you prefer
        } 
        //alert(codeLabel);
        this.showDiscountCodeRow({
          code: codeLabel,
          amount: offApplied,
          orderTypeHave: orderTypeNew
        });
      }
  }


  // -----------------------------
  // DISCOUNT APPLY / REMOVE (Shopify)
  // -----------------------------
  async applyDiscountCode(code) {
    if (!code) return false;
    try {
      // Shopify discount apply endpoint
      await fetch(`/discount/${encodeURIComponent(code)}`, {
        method: "GET",
        credentials: "same-origin",
      });

      if (String(code).toUpperCase() === "WELCOME25") {
        localStorage.removeItem("WELCOME25_REMOVED");
      }

      await this.overwriteFromRemoteCart(); // sync local cart
      this.updateCartInfoFromLocal(".cart-item-loop", 1);
      return true;
    } catch (e) {
      console.error("applyDiscountCode error:", e);
      return false;
    }
  }

  async removeDiscountCode(code) {
    if (!code) return false;
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          discount: ""
        })
      });

      const cart = await res.json();
      console.log("Discount removed", cart);
      
      localStorage.removeItem("WELCOME25_APPLIED");        
      console.log("Discount removed WELCOME25");

      location.reload(); // optional

    } catch (err) {
      console.error("Error removing discount:", err);
    }
  }

  // -----------------------------
  // Convert your applicableDiscount() → codes array
  // -----------------------------
  getApplicableCodesArray(cartData, orderType) {
    const raw = this.applicableDiscount(cartData, orderType); // may be null or "CODE1,CODE2,"
    if (!raw) return [];
    return String(raw)
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  }

}

const localCart = new LocalCart;
// `const` does NOT create a window property — expose it so code that guards on window.localCart
// (snippets/address-check-flow.liquid: proceedToCheckout / supplementCartState / closeAddressCheckInDrawer)
// can actually reach the engine. Without this the in-drawer Address Check never completes checkout.
window.localCart = localCart;

// Self-heal the green Checkout button's "· $X →" amount (Saahil 2026-07-06). A bundle-only first
// add can set the button BEFORE `.total-price-amount` settles, leaving a stale "Checkout · $0.00"
// with no follow-up mutation to correct it (the prominent total is right; only the button label
// lags). This observes the (stable, updated-in-place) total section and re-syncs the button label
// whenever the total changes — but ONLY when the button is in the ready/checkout state (carries a
// proceedToCheckout onclick), so it never overwrites the "$X to go" $89-lock or box-fill copy.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".total-price-section").forEach(function (section) {
    if (section.__thr1veLabelSync) return;
    section.__thr1veLabelSync = true;
    var sync = function () {
      var btn = document.getElementById("continue_to_shipping");
      if (!btn) return;
      if ((btn.getAttribute("onclick") || "").indexOf("proceedToCheckout") === -1) return; // ready state only
      var t = (section.querySelector(".total-price-amount") && section.querySelector(".total-price-amount").textContent || "").trim();
      if (!t) return; // don't clobber with an empty/not-yet-computed total
      var want = "Checkout · " + t + ' <span aria-hidden="true" style="margin-left:5px">&rarr;</span>';
      if (btn.innerHTML !== want) btn.innerHTML = want;
    };
    new MutationObserver(sync).observe(section, { childList: true, characterData: true, subtree: true });
  });
});

// Resume checkout after the Address Check page returns (it saved a validated address). One-shot:
// re-trigger the checkout the customer was on — the address intercept now passes, so it continues.
try {
  if (sessionStorage.getItem("thr1ve_resume_checkout") && localStorage.getItem("thr1ve_address_validated") === "1") {
    const _resumePath = sessionStorage.getItem("thr1ve_resume_checkout");
    sessionStorage.removeItem("thr1ve_resume_checkout");
    setTimeout(() => { try { localCart.proceedToCheckout(_resumePath || "mini-cart"); } catch (e) {} }, 900);
  }
} catch (e) {}


function getLocalCartItemByVarId(variantId, allItems) {
  if (!variantId) return null;
  const vId = Number(variantId);
  return (allItems || []).find(
    item => Number(item.variant_id) === vId
  ) || null;
}  

// Open your modal with message (simple)
function openQtyLimitModal(message) {
  const modal = document.getElementById("myModalQty");
  if (!modal) {
    alert(message); // fallback
    return;
  }
  const p = modal.querySelector(".modal-contentxxxx p");
  if (p) p.textContent = message;
  modal.style.display = "flex";
}

document.addEventListener("click", async (e) => {
  // Remove the applied discount. Cart-drawer restructure (CLAUDE.md #3): use the ACTUAL
  // applied code carried on data-discount-code — never a hardcoded 'WELCOME25' literal.
  const removeBtn = e.target.closest(".remove-welcome25");
  if (removeBtn) {
    e.preventDefault();
    const liveCode = (removeBtn.getAttribute("data-discount-code") || "").trim();
    await localCart.removeDiscountCode(liveCode);
  }
});

/* Populate the discount-removal button + label with the ACTUAL applied code from
   cart.discount_codes (Shopify), so the drawer never shows or removes a hardcoded
   demo code. Safe no-op when the row/button is absent. */
async function syncAppliedDiscountCodeUI() {
  try {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await res.json();
    const applied = (cart.discount_codes || [])
      .filter(d => d && d.applicable && d.code)
      .map(d => String(d.code));
    const code = applied[0] || "";
    document.querySelectorAll(".remove-welcome25").forEach(btn => {
      btn.setAttribute("data-discount-code", code);
    });
    document.querySelectorAll(".welcome-discount-code-label").forEach(el => {
      el.textContent = code ? ` ${code}` : "";
    });
  } catch (e) {
    console.error("syncAppliedDiscountCodeUI error:", e);
  }
}
document.addEventListener("DOMContentLoaded", syncAppliedDiscountCodeUI);


async function checkWELCOME25FromCart() {
  const loader = document.getElementById("loading-screen");
  if (loader) {
    loader.style.display = "block";
  }

  try {

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    console.log(cart.discount_codes);

    // Check discount_codes
    const hasWELCOME25 = cart.discount_codes?.some(
      d => d.code?.toUpperCase() === "WELCOME25"
    );
    let WELCOME25_A = localStorage.getItem("WELCOME25_APPLIED");

    if (hasWELCOME25 && !localCart.isExcluded_Global) {
      if (WELCOME25_A != "1") {
        localStorage.setItem("WELCOME25_APPLIED", "1");
        await applyDiscountCodeOnlyWELCOME25();        
        console.log("Applied WELCOME25");
      }
      localCart.updateCartInfoFromLocal(".cart-item-loop");
    } else {
      if(hasWELCOME25){
        localCart.removeDiscountCode('WELCOME25');
        localStorage.removeItem("WELCOME25_APPLIED");        
        console.log("Discount removed WELCOME25");
      }
      localCart.updateCartInfoFromLocal(".cart-item-loop");
    }

  } catch (e) {

    console.error(e);

    return false;
  } finally {
    if (loader) {
      loader.style.display = "none";
    }
  }
}


async function applyDiscountCodeOnlyWELCOME25() {

  try {

    // Remove all current discounts
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        discount: ""
      })
    });

  } catch (e) {

    console.error("applyDiscountCodeOnlyWELCOME15 error:", e);

  }
}

async function ensureWelcome15Only() {
    const REQUIRED_CODE = 'WELCOME15';
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      // 1️⃣ check discount_codes
      const codeApplied = (cart.discount_codes || []).some(
        d => String(d?.code || "").toUpperCase() === "WELCOME25" && d?.applicable
      );

      // 2️⃣ check cart_level_discount_applications for amount
      const app = (cart.cart_level_discount_applications || []).find(
        a => String(a?.title || a?.code || "").toUpperCase() === "WELCOME25"
      );

      const amountCents = app?.total_allocated_amount || 0;

      if(!(codeApplied || (amountCents > 0))){
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            discount: ""
          })
        });

        const cart = await res.json();
        console.log("Discount removed New", cart);
      }

    } catch (e) {
      console.error("WELCOME25 check error:", e);
      return { applied: false, amountCents: 0 };
    }
}

function getEmailCacheNew() {
  try {
    return JSON.parse(localStorage.getItem('email_check_cache')) || {};
  } catch {
    return {};
  }
}

function getCustomerDataFromCache(email) {

  const cache = getEmailCacheNew();
  const entry = cache[email];

  if (!entry) return null;

  // ✅ 1 minute check
  const minutesPassed =
    (Date.now() - entry.checkedAt) / 1000 / 60;

  const isExpired = minutesPassed > 1;

  return isExpired ? null : entry.data;
}

function getSubscriptionStatusFromCache(email) {
  const data = getCustomerDataFromCache(email);

  if (!data || !data.subscriptions?.is_available) return null;

  if (data.subscriptions.is_active?.length) return "active";
  if (data.subscriptions.is_paused?.length) return "paused";
  if (data.subscriptions.is_cancelled?.length) return "cancelled";

  return null;
}

function getSubscriptionFromCache(email) {
  try {
    const cache = JSON.parse(localStorage.getItem(EMAIL_CACHE_KEY) || "{}");
    const data = cache[email]?.data;

    if (!data || !data.subscriptions) return null;

    // ✅ priority: active → paused
    if (Array.isArray(data.subscriptions.is_active) && data.subscriptions.is_active.length > 0) {
      return true;
    }

    if (Array.isArray(data.subscriptions.is_paused) && data.subscriptions.is_paused.length > 0) {
      return false;
    }

    return false;

  } catch (e) {
    console.error("Error getting subscription status:", e);
    return false;
  }
}


document.addEventListener("DOMContentLoaded", function () {

  const ref = document.referrer || "";
  const cameFromCheckout = ref.includes("/checkout");

  if (cameFromCheckout) {
      location.reload();
  } 

  const sub_cart_added = localStorage.getItem("sub_cart_added");
  const path = window.location.pathname.toLowerCase();

  console.log('subscriptionContractId',subscriptionContractId);
  console.log('userLoggedIn',userLoggedIn);

  
  if (userLoggedIn) {
    let new_state = JSON.parse(localStorage.getItem("window_state") || "{}");
    const email = new_state.email || (typeof customerData !== 'undefined' ? customerData.email : "");

    if (email) {
      localCart.overwriteFromSubscriptionCache(email).then(newCart => {
        // If we found a subscription, newCart will have items
        const hasActiveSub = newCart && Array.isArray(newCart.items) && newCart.items.length > 0;

        console.log('hasActiveSub',hasActiveSub);

        localCart.updateCartInfoFromLocal(".cart-item-loop");

        if (hasActiveSub) {
          // Point E: subscription user
          localStorage.setItem("sub_cart_added", "1");                 
          setDisplaySafe("#pre_selected_data", "none");  /* cart-audit: element removed with its wrap — guard */
          setDisplaySafe("#pre_selected_data_wrap", "none");

        } else {

          // Point D: no active subscription
          localCart.updateReorderBox(); 
          setDisplaySafe("#pre_selected_data", "block"); /* cart-audit: element removed with its wrap — guard */
          setDisplaySafe("#pre_selected_data_wrap", "block");

        }

      });

    } else {

      localCart.updateCartInfoFromLocal(".cart-item-loop");

    }
  } else {

      if (frequencySelect.value === "OneTimePurchase") {
        
      }else{

        localCart.updateCartInfoFromLocal(".cart-item-loop");

      }
  }
  const isKetoUser = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
  
  if (!frequencySelect) return;
  
  frequencySelect.addEventListener("change", function () {
    const selectedValue = frequencySelect.value;
    if (selectedValue === "OneTimePurchase") {
      document.querySelector("#min-response")?.classList.add("d-none");
    }
  });
  
  if(isKetoUser){    
    frequencySelect.value = "OneTimePurchase";
    const changeEvent = new Event("change", { bubbles: true });
    frequencySelect.dispatchEvent(changeEvent);  
    document.querySelector(".frequency-selector")?.classList.add("d-none"); // ⬅️ Hides the dropdown
    document.querySelector("#min-response")?.classList.add("d-none");
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("continue_to_reorder");

  if (!btn) return;

  btn.addEventListener("click", function () {
    localCart.handleReorderClick(); // 👈 class method
  });

});

document.querySelectorAll('input[name="meal_style"]').forEach(input => {
  input.addEventListener("change", function () {

    // remove active from all
    document.querySelectorAll(".meal-tag").forEach(tag => {
      tag.classList.remove("active");
    });

    // add active to selected
    this.closest(".meal-tag").classList.add("active");
    
    localCart.updateCartInfoFromLocal(".cart-item-loop");

  });
});


$(document).on("click", ".product-quantity .qtybutton", function() {
  const allItems = localCart.cart.items;

  const $button = $(this),
      action = $button.data("action"),
      $qtySpan = $button.siblings(".cusqtyspan"),
      oldQty = parseInt($qtySpan.text(), 10),
      newQty = action === "+" ? oldQty + 1 : Math.max(0, oldQty - 1);
  
  const $productQuantity = $button.closest(".product-quantity"),
      variantId = parseInt($productQuantity.data("variant"), 10),
      quantityElement = $button.siblings(".cusqtyspan");
  //console.log(allItems);
  if(allItems.length > 0){
    const itemFc = getLocalCartItemByVarId(variantId, allItems);
    console.log(itemFc);
    let enabled = false;
    if(itemFc.qty_limit_enabled){
      enabled = itemFc.qty_limit_enabled === true || itemFc.qty_limit_enabled === "true" || itemFc.qty_limit_enabled === 1 || itemFc.qty_limit_enabled === "1";
    }else{
      enabled = false;
    }

    if (enabled) {
      const max = Number(itemFc.max_qty_per_order);

      if (enabled) {
        // ✅ show popup only if user tries to exceed max
        if ((newQty > max) && (Number.isFinite(max) && (max >= 1))) {
          openQtyLimitModal(`Maximum of ${max} units per order for this item.`);
          return; // ⛔ STOP
        }
      }

    }
  }
  
  console.log(newQty+' ===');
  $qtySpan.html(newQty);
  $button.siblings("input").val(newQty);
    $productQuantityAction = $button.closest(".product-quantity-action");  
    localCart.changeInToLocalCart(variantId, newQty, $productQuantityAction);
    localCart.updateCartInfoFromLocal(".cart-item-loop");
});

document.addEventListener("DOMContentLoaded", () => {
  const getCart = localCart.getCartData();
  const orderType = getCart?.attributes?.orderType?.type;
  if (orderType) {
    if (frequencySelect) {
      frequencySelect.value = orderType;
    }
  }
});


function changeInToCart(variantId, quantity, quantityElement=null, $productQuantityAction=null,  localCart=null) {
    $productQuantityAction?.addClass('loading');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: quantity,
            id: variantId
        },
        success: function(data) {
          $productQuantityAction?.removeClass('loading');
          localCart.updateCartInfoFromLocal(".cart-item-loop");
        },
        error: function(error) {
            console.error("Error adding to cart: ", error);
           if (quantityElement) {
              quantityElement.text(quantityElement.data('original-value')); // Revert to original value on error
          }
           $productQuantityAction?.removeClass('loading');
        }
    });
}

function clearCartData() {
  return fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(clearCart => {
      // console.log('Success:', clearCart);
      localCart.updateCartInfoFromLocal(".cart-item-loop");
      localStorage.removeItem("contractInfo");
      window.location.href = `/collections/fresh-ready-meals`;
    })
    .catch((error) => {
      console.error("Error clearing cart:", error);
      throw error; // Rethrow the error for further handling
    });
}

function applyShippingAmount(appiled = true) {
  const statenew = JSON.parse(localStorage.getItem("window_state") || "{}");
  const locaDelInit = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

  let shipping_amount = localStorage.getItem("shipping_amount") || 0;
  let selected_frequency = statenew?.freq;

  let amountEl = document.querySelector(".free-shipping-amount");
  let freeTextEl = document.querySelector(".free-shipping-text");
  let deliveryShippingEl = document.querySelector(".delivery-text-shippingamount");

  if (!amountEl) return;

  const format = (cents) => localCart.formatMoney(cents);
  const defaultShippingCents = 1500; // $15.00 default
  const currentShippingCents = Math.round(parseFloat(shipping_amount || 0) * 100);
  const mealsCount = localCart.countLunchAndDinnerMeals(localCart.cart.items);

  const hasAddress = !!(
    statenew?.address && String(statenew.address).trim() !== ""
  );

  const setShippingText = (text) => {
    amountEl.textContent = text;
  };

  amountEl.classList.add("fw-bold");

  // AUTHORITATIVE supplement shipping (mirrors getShippingAmount). Per ORDER:
  //   Case 3 (supplements only / no qualifying ≥$89 food) → Australia Post standalone (~$10)
  //   Case 1 (qualifying SUBSCRIPTION food)               → FREE; Case 2 / meal OTP → "Est. $15–$20".
  const suppState = (typeof localCart !== "undefined" && localCart.supplementCartState)
    ? localCart.supplementCartState(localCart.cart.items) : { hasSupplement: false, qualifyingFood: false };
  const isOneTimeShip = selected_frequency === "OneTimePurchase";
  amountEl.classList.remove("text-decoration-line-through");
  freeTextEl?.classList.add("d-none");
  if (suppState.hasSupplement && !suppState.qualifyingFood) {
    setShippingText("Est. $10");
    amountEl.classList.remove("free_amount", "shipping-free-green");
    amountEl.style.textTransform = "none";
    amountEl.style.removeProperty("color");
    if (deliveryShippingEl) deliveryShippingEl.textContent = "Est. $10";
  } else if (isOneTimeShip) {
    setShippingText("Est. $15–$20");
    amountEl.classList.remove("free_amount", "shipping-free-green");
    amountEl.style.textTransform = "none";
    amountEl.style.removeProperty("color");
    if (deliveryShippingEl) deliveryShippingEl.textContent = "Est. $15–$20";
  } else {
    setShippingText("FREE");
    amountEl.classList.add("free_amount", "shipping-free-green");
    amountEl.style.setProperty("color", "#3F8F1F", "important"); // green
    amountEl.style.textTransform = "uppercase";
    if (deliveryShippingEl) deliveryShippingEl.textContent = "FREE";
  }
}


/* ------------------------------------------------------------------
   Checkout validator (custom page → Shopify checkout)
   - Validates email, phone, address, delivery date/time, plan(+freq)
   - Saves: cartAttributes, deliveryInfo, widgetAddress
   - Calls: localCart.continueToShipping(requestPath)
  ------------------------------------------------------------------- */
  window.checkoutValidate = function checkoutValidate(requestPath = "mini-cart") {
    const vEmail = v => /\S+@\S+\.\S+/.test(String(v||""));
    const vPhone = v => String(v||"").replace(/\D/g,"").length >= 8;
    const vAddr  = v => String(v||"").trim().length >= 6;
    const qs     = (s, r=document) => r.querySelector(s);
    
    const window_state   = JSON.parse(localStorage.getItem("window_state")   || "{}");

    // read from your global `state` first; fall back to DOM fields
    const email   = (window.state?.email   || (qs("#email2")?.value || qs("#email1")?.value || "")).trim();
    //const phone   = (window.state?.phone   || (qs("#phone2")?.value || qs("#phone1")?.value || "")).trim();
    const address = (window.state?.address || (qs("#address2")?.value || qs("#address1")?.value || "")).trim();

    const dateStr = (window.state?.date || (window_state?.date || "")).trim();
    const timeStr = (window.state?.time || (window_state?.time || "")).trim();
    const plan    = (window.state?.plan || (window_state?.plan || "")).trim();           // "subscribe" | "onetime"
    const freq    = (window.state?.freq || (window_state?.freq || "")).trim();           // "weekly" | "fortnightly" | ""

    //if (!vEmail(email))  { alert("Please enter a valid email."); return false; }
    /*if (!vPhone(phone))  { alert("Please enter a valid phone number (min 8 digits)."); return false; }
    if (!vAddr(address)) { alert("Please enter a valid delivery address."); return false; }
    if (!dateStr)        { alert("Please select a delivery date."); return false; }
    if (!timeStr)        { alert("Please select a delivery time slot."); return false; }
    if (!plan)           { alert("Please select a plan (Subscribe & Save or One-Time)."); return false; }
    if (plan === "subscribe" && !freq) {
      alert("Please choose Weekly or Fortnightly for your subscription."); return false;
    }*/

    // Normalize to theme’s expected values
    const orderType =
      plan === "subscribe"
        ? (freq === "WeeklySubscription" ? "WeeklySubscription" : "FortnightlySubscription")
        : "OneTimePurchase";



    // Helpers to parse the UI’s date/time formats into what createFormData expects
    const parseDeliveryDate = (label) => {
      const m = /\(([^)]+)\)$/.exec(String(label));
      return m ? m[1] : String(label || "");
    };
    const parseTimeSlot = (slot) => {
      const parts = String(slot).split(/–|-/).map(s => s.trim());
      const pad = s => {
        const [h,m="00"] = s.split(":");
        return `${String(h).padStart(2,"0")}:${m}`;
      };
      return parts.length === 2 ? [pad(parts[0]), pad(parts[1])] : ["",""];
    };

    const deliveryDate = parseDeliveryDate(dateStr);
    const [deliveryStart, deliveryEnd] = parseTimeSlot(timeStr);

    // Persist info for LocalCart pipeline
    localStorage.setItem("cartAttributes", JSON.stringify({ orderType: { type: orderType } }));

    // Best-effort AU postcode extraction for validatedAddress()
    const postcodeMatch = address.match(/\b(\d{4})\b(?!.*\b\d{4}\b)/);

    // Keep window.state in sync (optional)
    window.state = Object.assign({}, window.state, {
    email, address, date: dateStr, time: timeStr, plan, freq
    });

    localCart.updateCartInfoFromLocal(".cart-item-loop");
    
  };

  document.addEventListener("DOMContentLoaded", function () {
    applyDiscountCodeOnlyWELCOME25();
    localCart.updateCartInfoFromLocal(".cart-item-loop");
    // #toPlan lived in the deleted #finalflow — guard so this init handler can't throw
    // (an uncaught throw here aborted the rest of cart bootstrap and left window.localCart unset).
    var _toPlan = document.getElementById("toPlan"); if (_toPlan) _toPlan.disabled = true;
  });